
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref5c1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref5c1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iw2gE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7acf975af164d67$export$ffb0004e005737fa, (v) => $d7acf975af164d67$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7acf975af164d67$export$34b9dba7ce09269b, (v) => $d7acf975af164d67$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7acf975af164d67$export$25062201e9e25d76, (v) => $d7acf975af164d67$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7acf975af164d67$export$ffb0004e005737fa;
var $d7acf975af164d67$export$34b9dba7ce09269b;
var $d7acf975af164d67$export$25062201e9e25d76;
"use strict";
var $d7acf975af164d67$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d7acf975af164d67$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d7acf975af164d67$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d7acf975af164d67$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d7acf975af164d67$export$ffb0004e005737fa = $d7acf975af164d67$var$REACT_FRAGMENT_TYPE;
$d7acf975af164d67$export$34b9dba7ce09269b = $d7acf975af164d67$var$jsxProd;
$d7acf975af164d67$export$25062201e9e25d76 = $d7acf975af164d67$var$jsxProd;

});

parcelRegister("fjpcG", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $b25c2e442c996fe7$export$882461b6382ed46c, (v) => $b25c2e442c996fe7$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $b25c2e442c996fe7$export$757ceba2d55c277e, (v) => $b25c2e442c996fe7$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $b25c2e442c996fe7$export$83d89fbfd8236492, (v) => $b25c2e442c996fe7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b25c2e442c996fe7$export$882461b6382ed46c;
var $b25c2e442c996fe7$export$757ceba2d55c277e;
var $b25c2e442c996fe7$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");
function $b25c2e442c996fe7$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b25c2e442c996fe7$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b25c2e442c996fe7$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b25c2e442c996fe7$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $b25c2e442c996fe7$var$assertIsMounted(fiber) {
    if ($b25c2e442c996fe7$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
}
function $b25c2e442c996fe7$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b25c2e442c996fe7$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b25c2e442c996fe7$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b25c2e442c996fe7$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b25c2e442c996fe7$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b25c2e442c996fe7$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b25c2e442c996fe7$var$assign = Object.assign, $b25c2e442c996fe7$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b25c2e442c996fe7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b25c2e442c996fe7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b25c2e442c996fe7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b25c2e442c996fe7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b25c2e442c996fe7$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b25c2e442c996fe7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b25c2e442c996fe7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b25c2e442c996fe7$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b25c2e442c996fe7$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b25c2e442c996fe7$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b25c2e442c996fe7$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b25c2e442c996fe7$var$getComponentNameFromType(type.type) || "Memo";
        case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b25c2e442c996fe7$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b25c2e442c996fe7$var$isArrayImpl = Array.isArray, $b25c2e442c996fe7$var$ReactSharedInternals = $2WGWz.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b25c2e442c996fe7$var$ReactDOMSharedInternals = $9Np2q.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b25c2e442c996fe7$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b25c2e442c996fe7$var$valueStack = [], $b25c2e442c996fe7$var$index = -1;
function $b25c2e442c996fe7$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b25c2e442c996fe7$var$pop(cursor) {
    0 > $b25c2e442c996fe7$var$index || (cursor.current = $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index], $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index] = null, $b25c2e442c996fe7$var$index--);
}
function $b25c2e442c996fe7$var$push(cursor, value) {
    $b25c2e442c996fe7$var$index++;
    $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index] = cursor.current;
    cursor.current = value;
}
var $b25c2e442c996fe7$var$contextStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$contextFiberStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$rootInstanceStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$hostTransitionProviderCursor = $b25c2e442c996fe7$var$createCursor(null);
function $b25c2e442c996fe7$var$pushHostContainer(fiber, nextRootInstance) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$rootInstanceStackCursor, nextRootInstance);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextFiberStackCursor, fiber);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b25c2e442c996fe7$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b25c2e442c996fe7$var$getOwnHostContext(nextRootInstance), fiber = $b25c2e442c996fe7$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, fiber);
}
function $b25c2e442c996fe7$var$popHostContainer() {
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextFiberStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$rootInstanceStackCursor);
}
function $b25c2e442c996fe7$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$hostTransitionProviderCursor, fiber);
    var context = $b25c2e442c996fe7$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b25c2e442c996fe7$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextFiberStackCursor, fiber), $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, JSCompiler_inline_result));
}
function $b25c2e442c996fe7$var$popHostContext(fiber) {
    $b25c2e442c996fe7$var$contextFiberStackCursor.current === fiber && ($b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor), $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextFiberStackCursor));
    $b25c2e442c996fe7$var$hostTransitionProviderCursor.current === fiber && ($b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$hostTransitionProviderCursor), $b25c2e442c996fe7$var$HostTransitionContext._currentValue = $b25c2e442c996fe7$var$sharedNotPendingObject);
}
var $b25c2e442c996fe7$var$prefix, $b25c2e442c996fe7$var$suffix;
function $b25c2e442c996fe7$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b25c2e442c996fe7$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b25c2e442c996fe7$var$prefix = match && match[1] || "";
        $b25c2e442c996fe7$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b25c2e442c996fe7$var$prefix + name + $b25c2e442c996fe7$var$suffix;
}
var $b25c2e442c996fe7$var$reentry = !1;
function $b25c2e442c996fe7$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b25c2e442c996fe7$var$reentry) return "";
    $b25c2e442c996fe7$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b25c2e442c996fe7$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b25c2e442c996fe7$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b25c2e442c996fe7$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Suspense Fallback") : $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $b25c2e442c996fe7$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $b25c2e442c996fe7$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b25c2e442c996fe7$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $b25c2e442c996fe7$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $b25c2e442c996fe7$var$shouldYield = $bIbqH.unstable_shouldYield, $b25c2e442c996fe7$var$requestPaint = $bIbqH.unstable_requestPaint, $b25c2e442c996fe7$var$now = $bIbqH.unstable_now, $b25c2e442c996fe7$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $b25c2e442c996fe7$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $b25c2e442c996fe7$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $b25c2e442c996fe7$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$LowPriority = $bIbqH.unstable_LowPriority, $b25c2e442c996fe7$var$IdlePriority = $bIbqH.unstable_IdlePriority, $b25c2e442c996fe7$var$log$1 = $bIbqH.log, $b25c2e442c996fe7$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $b25c2e442c996fe7$var$rendererID = null, $b25c2e442c996fe7$var$injectedHook = null;
function $b25c2e442c996fe7$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b25c2e442c996fe7$var$log$1 && $b25c2e442c996fe7$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.setStrictMode) try {
        $b25c2e442c996fe7$var$injectedHook.setStrictMode($b25c2e442c996fe7$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b25c2e442c996fe7$var$clz32 = Math.clz32 ? Math.clz32 : $b25c2e442c996fe7$var$clz32Fallback, $b25c2e442c996fe7$var$log = Math.log, $b25c2e442c996fe7$var$LN2 = Math.LN2;
function $b25c2e442c996fe7$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b25c2e442c996fe7$var$log(x) / $b25c2e442c996fe7$var$LN2 | 0) | 0;
}
var $b25c2e442c996fe7$var$nextTransitionUpdateLane = 256, $b25c2e442c996fe7$var$nextTransitionDeferredLane = 262144, $b25c2e442c996fe7$var$nextRetryLane = 4194304;
function $b25c2e442c996fe7$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b25c2e442c996fe7$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b25c2e442c996fe7$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b25c2e442c996fe7$var$claimNextRetryLane() {
    var lane = $b25c2e442c996fe7$var$nextRetryLane;
    $b25c2e442c996fe7$var$nextRetryLane <<= 1;
    0 === ($b25c2e442c996fe7$var$nextRetryLane & 62914560) && ($b25c2e442c996fe7$var$nextRetryLane = 4194304);
    return lane;
}
function $b25c2e442c996fe7$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b25c2e442c996fe7$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b25c2e442c996fe7$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b25c2e442c996fe7$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b25c2e442c996fe7$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $b25c2e442c996fe7$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b25c2e442c996fe7$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b25c2e442c996fe7$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b25c2e442c996fe7$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b25c2e442c996fe7$var$resolveUpdatePriority() {
    var updatePriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b25c2e442c996fe7$var$getEventPriority(updatePriority.type);
}
function $b25c2e442c996fe7$var$runWithPriority(priority, fn) {
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        return $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b25c2e442c996fe7$var$randomKey = Math.random().toString(36).slice(2), $b25c2e442c996fe7$var$internalInstanceKey = "__reactFiber$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalPropsKey = "__reactProps$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalContainerInstanceKey = "__reactContainer$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlersKey = "__reactEvents$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlerListenersKey = "__reactListeners$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlesSetKey = "__reactHandles$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalRootNodeResourcesKey = "__reactResources$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalHoistableMarker = "__reactMarker$" + $b25c2e442c996fe7$var$randomKey;
function $b25c2e442c996fe7$var$detachDeletedInstance(node) {
    delete node[$b25c2e442c996fe7$var$internalInstanceKey];
    delete node[$b25c2e442c996fe7$var$internalPropsKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlersKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlerListenersKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlesSetKey];
}
function $b25c2e442c996fe7$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b25c2e442c996fe7$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b25c2e442c996fe7$var$internalContainerInstanceKey] || parentNode[$b25c2e442c996fe7$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b25c2e442c996fe7$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b25c2e442c996fe7$var$internalInstanceKey]) return parentNode;
                targetNode = $b25c2e442c996fe7$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b25c2e442c996fe7$var$getInstanceFromNode(node) {
    if (node = node[$b25c2e442c996fe7$var$internalInstanceKey] || node[$b25c2e442c996fe7$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b25c2e442c996fe7$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(33));
}
function $b25c2e442c996fe7$var$getResourcesFromRoot(root) {
    var resources = root[$b25c2e442c996fe7$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b25c2e442c996fe7$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b25c2e442c996fe7$var$markNodeAsHoistable(node) {
    node[$b25c2e442c996fe7$var$internalHoistableMarker] = !0;
}
var $b25c2e442c996fe7$var$allNativeEvents = new Set(), $b25c2e442c996fe7$var$registrationNameDependencies = {};
function $b25c2e442c996fe7$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b25c2e442c996fe7$var$registerDirectEvent(registrationName, dependencies);
    $b25c2e442c996fe7$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b25c2e442c996fe7$var$registerDirectEvent(registrationName, dependencies) {
    $b25c2e442c996fe7$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b25c2e442c996fe7$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b25c2e442c996fe7$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b25c2e442c996fe7$var$illegalAttributeNameCache = {}, $b25c2e442c996fe7$var$validatedAttributeNameCache = {};
function $b25c2e442c996fe7$var$isAttributeNameSafe(attributeName) {
    if ($b25c2e442c996fe7$var$hasOwnProperty.call($b25c2e442c996fe7$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b25c2e442c996fe7$var$hasOwnProperty.call($b25c2e442c996fe7$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b25c2e442c996fe7$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b25c2e442c996fe7$var$validatedAttributeNameCache[attributeName] = !0;
    $b25c2e442c996fe7$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b25c2e442c996fe7$var$setValueForAttribute(node, name, value) {
    if ($b25c2e442c996fe7$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b25c2e442c996fe7$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b25c2e442c996fe7$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b25c2e442c996fe7$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b25c2e442c996fe7$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b25c2e442c996fe7$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b25c2e442c996fe7$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $b25c2e442c996fe7$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $b25c2e442c996fe7$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $b25c2e442c996fe7$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b25c2e442c996fe7$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b25c2e442c996fe7$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b25c2e442c996fe7$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b25c2e442c996fe7$var$getToStringValue(value);
        } else element.value !== "" + $b25c2e442c996fe7$var$getToStringValue(value) && (element.value = "" + $b25c2e442c996fe7$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b25c2e442c996fe7$var$setDefaultValue(element, type, $b25c2e442c996fe7$var$getToStringValue(value)) : null != defaultValue ? $b25c2e442c996fe7$var$setDefaultValue(element, type, $b25c2e442c996fe7$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b25c2e442c996fe7$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b25c2e442c996fe7$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $b25c2e442c996fe7$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $b25c2e442c996fe7$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b25c2e442c996fe7$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $b25c2e442c996fe7$var$track(element);
}
function $b25c2e442c996fe7$var$setDefaultValue(node, type, value) {
    "number" === type && $b25c2e442c996fe7$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b25c2e442c996fe7$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b25c2e442c996fe7$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b25c2e442c996fe7$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b25c2e442c996fe7$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b25c2e442c996fe7$var$getToStringValue(defaultValue) : "";
}
function $b25c2e442c996fe7$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(92));
            if ($b25c2e442c996fe7$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b25c2e442c996fe7$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $b25c2e442c996fe7$var$track(element);
}
function $b25c2e442c996fe7$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b25c2e442c996fe7$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b25c2e442c996fe7$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b25c2e442c996fe7$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b25c2e442c996fe7$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b25c2e442c996fe7$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b25c2e442c996fe7$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b25c2e442c996fe7$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b25c2e442c996fe7$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b25c2e442c996fe7$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b25c2e442c996fe7$var$sanitizeURL(url) {
    return $b25c2e442c996fe7$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $b25c2e442c996fe7$var$noop$1() {}
var $b25c2e442c996fe7$var$currentReplayingEvent = null;
function $b25c2e442c996fe7$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b25c2e442c996fe7$var$restoreTarget = null, $b25c2e442c996fe7$var$restoreQueue = null;
function $b25c2e442c996fe7$var$restoreStateOfTarget(target) {
    var internalInstance = $b25c2e442c996fe7$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b25c2e442c996fe7$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b25c2e442c996fe7$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b25c2e442c996fe7$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(90));
                            $b25c2e442c996fe7$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b25c2e442c996fe7$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b25c2e442c996fe7$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b25c2e442c996fe7$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b25c2e442c996fe7$var$isInsideEventHandler = !1;
function $b25c2e442c996fe7$var$batchedUpdates$1(fn, a, b) {
    if ($b25c2e442c996fe7$var$isInsideEventHandler) return fn(a, b);
    $b25c2e442c996fe7$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b25c2e442c996fe7$var$isInsideEventHandler = !1, null !== $b25c2e442c996fe7$var$restoreTarget || null !== $b25c2e442c996fe7$var$restoreQueue) {
            if ($b25c2e442c996fe7$var$flushSyncWork$1(), $b25c2e442c996fe7$var$restoreTarget && (a = $b25c2e442c996fe7$var$restoreTarget, fn = $b25c2e442c996fe7$var$restoreQueue, $b25c2e442c996fe7$var$restoreQueue = $b25c2e442c996fe7$var$restoreTarget = null, $b25c2e442c996fe7$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b25c2e442c996fe7$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b25c2e442c996fe7$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b25c2e442c996fe7$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b25c2e442c996fe7$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !1;
if ($b25c2e442c996fe7$var$canUseDOM) try {
    var $b25c2e442c996fe7$var$options = {};
    Object.defineProperty($b25c2e442c996fe7$var$options, "passive", {
        get: function() {
            $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b25c2e442c996fe7$var$options, $b25c2e442c996fe7$var$options);
    window.removeEventListener("test", $b25c2e442c996fe7$var$options, $b25c2e442c996fe7$var$options);
} catch (e) {
    $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !1;
}
var $b25c2e442c996fe7$var$root = null, $b25c2e442c996fe7$var$startText = null, $b25c2e442c996fe7$var$fallbackText = null;
function $b25c2e442c996fe7$var$getData() {
    if ($b25c2e442c996fe7$var$fallbackText) return $b25c2e442c996fe7$var$fallbackText;
    var start, startValue = $b25c2e442c996fe7$var$startText, startLength = startValue.length, end, endValue = "value" in $b25c2e442c996fe7$var$root ? $b25c2e442c996fe7$var$root.value : $b25c2e442c996fe7$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b25c2e442c996fe7$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b25c2e442c996fe7$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b25c2e442c996fe7$var$functionThatReturnsTrue() {
    return !0;
}
function $b25c2e442c996fe7$var$functionThatReturnsFalse() {
    return !1;
}
function $b25c2e442c996fe7$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b25c2e442c996fe7$var$functionThatReturnsTrue : $b25c2e442c996fe7$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b25c2e442c996fe7$var$functionThatReturnsFalse;
        return this;
    }
    $b25c2e442c996fe7$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b25c2e442c996fe7$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b25c2e442c996fe7$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b25c2e442c996fe7$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b25c2e442c996fe7$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b25c2e442c996fe7$var$SyntheticEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$EventInterface), $b25c2e442c996fe7$var$UIEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    view: 0,
    detail: 0
}), $b25c2e442c996fe7$var$SyntheticUIEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$UIEventInterface), $b25c2e442c996fe7$var$lastMovementX, $b25c2e442c996fe7$var$lastMovementY, $b25c2e442c996fe7$var$lastMouseEvent, $b25c2e442c996fe7$var$MouseEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b25c2e442c996fe7$var$lastMouseEvent && ($b25c2e442c996fe7$var$lastMouseEvent && "mousemove" === event.type ? ($b25c2e442c996fe7$var$lastMovementX = event.screenX - $b25c2e442c996fe7$var$lastMouseEvent.screenX, $b25c2e442c996fe7$var$lastMovementY = event.screenY - $b25c2e442c996fe7$var$lastMouseEvent.screenY) : $b25c2e442c996fe7$var$lastMovementY = $b25c2e442c996fe7$var$lastMovementX = 0, $b25c2e442c996fe7$var$lastMouseEvent = event);
        return $b25c2e442c996fe7$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b25c2e442c996fe7$var$lastMovementY;
    }
}), $b25c2e442c996fe7$var$SyntheticMouseEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$MouseEventInterface), $b25c2e442c996fe7$var$DragEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    dataTransfer: 0
}), $b25c2e442c996fe7$var$SyntheticDragEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$DragEventInterface), $b25c2e442c996fe7$var$FocusEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    relatedTarget: 0
}), $b25c2e442c996fe7$var$SyntheticFocusEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$FocusEventInterface), $b25c2e442c996fe7$var$AnimationEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b25c2e442c996fe7$var$SyntheticAnimationEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$AnimationEventInterface), $b25c2e442c996fe7$var$ClipboardEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b25c2e442c996fe7$var$SyntheticClipboardEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$ClipboardEventInterface), $b25c2e442c996fe7$var$CompositionEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    data: 0
}), $b25c2e442c996fe7$var$SyntheticCompositionEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$CompositionEventInterface), $b25c2e442c996fe7$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b25c2e442c996fe7$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b25c2e442c996fe7$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b25c2e442c996fe7$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b25c2e442c996fe7$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b25c2e442c996fe7$var$getEventModifierState() {
    return $b25c2e442c996fe7$var$modifierStateGetter;
}
var $b25c2e442c996fe7$var$KeyboardEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b25c2e442c996fe7$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b25c2e442c996fe7$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b25c2e442c996fe7$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b25c2e442c996fe7$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b25c2e442c996fe7$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b25c2e442c996fe7$var$SyntheticKeyboardEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$KeyboardEventInterface), $b25c2e442c996fe7$var$PointerEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b25c2e442c996fe7$var$SyntheticPointerEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$PointerEventInterface), $b25c2e442c996fe7$var$TouchEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState
}), $b25c2e442c996fe7$var$SyntheticTouchEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$TouchEventInterface), $b25c2e442c996fe7$var$TransitionEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b25c2e442c996fe7$var$SyntheticTransitionEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$TransitionEventInterface), $b25c2e442c996fe7$var$WheelEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b25c2e442c996fe7$var$SyntheticWheelEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$WheelEventInterface), $b25c2e442c996fe7$var$ToggleEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b25c2e442c996fe7$var$SyntheticToggleEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$ToggleEventInterface), $b25c2e442c996fe7$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b25c2e442c996fe7$var$canUseCompositionEvent = $b25c2e442c996fe7$var$canUseDOM && "CompositionEvent" in window, $b25c2e442c996fe7$var$documentMode = null;
$b25c2e442c996fe7$var$canUseDOM && "documentMode" in document && ($b25c2e442c996fe7$var$documentMode = document.documentMode);
var $b25c2e442c996fe7$var$canUseTextInputEvent = $b25c2e442c996fe7$var$canUseDOM && "TextEvent" in window && !$b25c2e442c996fe7$var$documentMode, $b25c2e442c996fe7$var$useFallbackCompositionData = $b25c2e442c996fe7$var$canUseDOM && (!$b25c2e442c996fe7$var$canUseCompositionEvent || $b25c2e442c996fe7$var$documentMode && 8 < $b25c2e442c996fe7$var$documentMode && 11 >= $b25c2e442c996fe7$var$documentMode), $b25c2e442c996fe7$var$SPACEBAR_CHAR = String.fromCharCode(32), $b25c2e442c996fe7$var$hasSpaceKeypress = !1;
function $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b25c2e442c996fe7$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b25c2e442c996fe7$var$isComposing = !1;
function $b25c2e442c996fe7$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b25c2e442c996fe7$var$hasSpaceKeypress = !0;
            return $b25c2e442c996fe7$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b25c2e442c996fe7$var$SPACEBAR_CHAR && $b25c2e442c996fe7$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b25c2e442c996fe7$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b25c2e442c996fe7$var$isComposing) return "compositionend" === domEventName || !$b25c2e442c996fe7$var$canUseCompositionEvent && $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b25c2e442c996fe7$var$getData(), $b25c2e442c996fe7$var$fallbackText = $b25c2e442c996fe7$var$startText = $b25c2e442c996fe7$var$root = null, $b25c2e442c996fe7$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b25c2e442c996fe7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b25c2e442c996fe7$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b25c2e442c996fe7$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b25c2e442c996fe7$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b25c2e442c996fe7$var$restoreTarget ? $b25c2e442c996fe7$var$restoreQueue ? $b25c2e442c996fe7$var$restoreQueue.push(target) : $b25c2e442c996fe7$var$restoreQueue = [
        target
    ] : $b25c2e442c996fe7$var$restoreTarget = target;
    inst = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b25c2e442c996fe7$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b25c2e442c996fe7$var$activeElement$1 = null, $b25c2e442c996fe7$var$activeElementInst$1 = null;
function $b25c2e442c996fe7$var$runEventInBatch(dispatchQueue) {
    $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, 0);
}
function $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b25c2e442c996fe7$var$getNodeFromInstance(targetInst);
    if ($b25c2e442c996fe7$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b25c2e442c996fe7$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b25c2e442c996fe7$var$isInputEventSupported = !1;
if ($b25c2e442c996fe7$var$canUseDOM) {
    var $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286;
    if ($b25c2e442c996fe7$var$canUseDOM) {
        var $b25c2e442c996fe7$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$b25c2e442c996fe7$var$isSupported$jscomp$inline_427) {
            var $b25c2e442c996fe7$var$element$jscomp$inline_428 = document.createElement("div");
            $b25c2e442c996fe7$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $b25c2e442c996fe7$var$isSupported$jscomp$inline_427 = "function" === typeof $b25c2e442c996fe7$var$element$jscomp$inline_428.oninput;
        }
        $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 = $b25c2e442c996fe7$var$isSupported$jscomp$inline_427;
    } else $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 = !1;
    $b25c2e442c996fe7$var$isInputEventSupported = $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $b25c2e442c996fe7$var$stopWatchingForValueChange() {
    $b25c2e442c996fe7$var$activeElement$1 && ($b25c2e442c996fe7$var$activeElement$1.detachEvent("onpropertychange", $b25c2e442c996fe7$var$handlePropertyChange), $b25c2e442c996fe7$var$activeElementInst$1 = $b25c2e442c996fe7$var$activeElement$1 = null);
}
function $b25c2e442c996fe7$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b25c2e442c996fe7$var$getInstIfValueChanged($b25c2e442c996fe7$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, $b25c2e442c996fe7$var$activeElementInst$1, nativeEvent, $b25c2e442c996fe7$var$getEventTarget(nativeEvent));
        $b25c2e442c996fe7$var$batchedUpdates$1($b25c2e442c996fe7$var$runEventInBatch, dispatchQueue);
    }
}
function $b25c2e442c996fe7$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b25c2e442c996fe7$var$stopWatchingForValueChange(), $b25c2e442c996fe7$var$activeElement$1 = target, $b25c2e442c996fe7$var$activeElementInst$1 = targetInst, $b25c2e442c996fe7$var$activeElement$1.attachEvent("onpropertychange", $b25c2e442c996fe7$var$handlePropertyChange)) : "focusout" === domEventName && $b25c2e442c996fe7$var$stopWatchingForValueChange();
}
function $b25c2e442c996fe7$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged($b25c2e442c996fe7$var$activeElementInst$1);
}
function $b25c2e442c996fe7$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst);
}
function $b25c2e442c996fe7$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst);
}
function $b25c2e442c996fe7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b25c2e442c996fe7$var$objectIs = "function" === typeof Object.is ? Object.is : $b25c2e442c996fe7$var$is;
function $b25c2e442c996fe7$var$shallowEqual(objA, objB) {
    if ($b25c2e442c996fe7$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b25c2e442c996fe7$var$hasOwnProperty.call(objB, currentKey) || !$b25c2e442c996fe7$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b25c2e442c996fe7$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b25c2e442c996fe7$var$getNodeForCharacterOffset(root, offset) {
    var node = $b25c2e442c996fe7$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b25c2e442c996fe7$var$getLeafNode(node);
    }
}
function $b25c2e442c996fe7$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b25c2e442c996fe7$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b25c2e442c996fe7$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b25c2e442c996fe7$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b25c2e442c996fe7$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b25c2e442c996fe7$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b25c2e442c996fe7$var$skipSelectionChangeEvent = $b25c2e442c996fe7$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b25c2e442c996fe7$var$activeElement = null, $b25c2e442c996fe7$var$activeElementInst = null, $b25c2e442c996fe7$var$lastSelection = null, $b25c2e442c996fe7$var$mouseDown = !1;
function $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b25c2e442c996fe7$var$mouseDown || null == $b25c2e442c996fe7$var$activeElement || $b25c2e442c996fe7$var$activeElement !== $b25c2e442c996fe7$var$getActiveElement(doc) || (doc = $b25c2e442c996fe7$var$activeElement, "selectionStart" in doc && $b25c2e442c996fe7$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b25c2e442c996fe7$var$lastSelection && $b25c2e442c996fe7$var$shallowEqual($b25c2e442c996fe7$var$lastSelection, doc) || ($b25c2e442c996fe7$var$lastSelection = doc, doc = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners($b25c2e442c996fe7$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b25c2e442c996fe7$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b25c2e442c996fe7$var$activeElement)));
}
function $b25c2e442c996fe7$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b25c2e442c996fe7$var$vendorPrefixes = {
    animationend: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionEnd")
}, $b25c2e442c996fe7$var$prefixedEventNames = {}, $b25c2e442c996fe7$var$style = {};
$b25c2e442c996fe7$var$canUseDOM && ($b25c2e442c996fe7$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b25c2e442c996fe7$var$vendorPrefixes.animationend.animation, delete $b25c2e442c996fe7$var$vendorPrefixes.animationiteration.animation, delete $b25c2e442c996fe7$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b25c2e442c996fe7$var$vendorPrefixes.transitionend.transition);
function $b25c2e442c996fe7$var$getVendorPrefixedEventName(eventName) {
    if ($b25c2e442c996fe7$var$prefixedEventNames[eventName]) return $b25c2e442c996fe7$var$prefixedEventNames[eventName];
    if (!$b25c2e442c996fe7$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b25c2e442c996fe7$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b25c2e442c996fe7$var$style) return $b25c2e442c996fe7$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b25c2e442c996fe7$var$ANIMATION_END = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationend"), $b25c2e442c996fe7$var$ANIMATION_ITERATION = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationiteration"), $b25c2e442c996fe7$var$ANIMATION_START = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationstart"), $b25c2e442c996fe7$var$TRANSITION_RUN = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionrun"), $b25c2e442c996fe7$var$TRANSITION_START = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionstart"), $b25c2e442c996fe7$var$TRANSITION_CANCEL = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitioncancel"), $b25c2e442c996fe7$var$TRANSITION_END = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionend"), $b25c2e442c996fe7$var$topLevelEventsToReactNames = new Map(), $b25c2e442c996fe7$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b25c2e442c996fe7$var$simpleEventPluginEvents.push("scrollEnd");
function $b25c2e442c996fe7$var$registerSimpleEvent(domEventName, reactName) {
    $b25c2e442c996fe7$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b25c2e442c996fe7$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b25c2e442c996fe7$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b25c2e442c996fe7$var$concurrentQueues = [], $b25c2e442c996fe7$var$concurrentQueuesIndex = 0, $b25c2e442c996fe7$var$concurrentlyUpdatedLanes = 0;
function $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b25c2e442c996fe7$var$concurrentQueuesIndex, i = $b25c2e442c996fe7$var$concurrentlyUpdatedLanes = $b25c2e442c996fe7$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var queue = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var update = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var lane = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = fiber;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = queue;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = update;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = lane;
    $b25c2e442c996fe7$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b25c2e442c996fe7$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b25c2e442c996fe7$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b25c2e442c996fe7$var$nestedUpdateCount) throw $b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = null, Error($b25c2e442c996fe7$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b25c2e442c996fe7$var$emptyContextObject = {};
function $b25c2e442c996fe7$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b25c2e442c996fe7$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b25c2e442c996fe7$var$FiberNode(tag, pendingProps, key, mode);
}
function $b25c2e442c996fe7$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b25c2e442c996fe7$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b25c2e442c996fe7$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b25c2e442c996fe7$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b25c2e442c996fe7$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b25c2e442c996fe7$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b25c2e442c996fe7$var$isHostHoistableType(type, pendingProps, $b25c2e442c996fe7$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE:
            return $b25c2e442c996fe7$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b25c2e442c996fe7$var$REACT_PROFILER_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b25c2e442c996fe7$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b25c2e442c996fe7$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b25c2e442c996fe7$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b25c2e442c996fe7$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b25c2e442c996fe7$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b25c2e442c996fe7$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b25c2e442c996fe7$var$createFiberFromText(content, mode, lanes) {
    content = $b25c2e442c996fe7$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $b25c2e442c996fe7$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $b25c2e442c996fe7$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b25c2e442c996fe7$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b25c2e442c996fe7$var$CapturedStacks = new WeakMap();
function $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b25c2e442c996fe7$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(source)
        };
        $b25c2e442c996fe7$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(source)
    };
}
var $b25c2e442c996fe7$var$forkStack = [], $b25c2e442c996fe7$var$forkStackIndex = 0, $b25c2e442c996fe7$var$treeForkProvider = null, $b25c2e442c996fe7$var$treeForkCount = 0, $b25c2e442c996fe7$var$idStack = [], $b25c2e442c996fe7$var$idStackIndex = 0, $b25c2e442c996fe7$var$treeContextProvider = null, $b25c2e442c996fe7$var$treeContextId = 1, $b25c2e442c996fe7$var$treeContextOverflow = "";
function $b25c2e442c996fe7$var$pushTreeFork(workInProgress, totalChildren) {
    $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex++] = $b25c2e442c996fe7$var$treeForkCount;
    $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex++] = $b25c2e442c996fe7$var$treeForkProvider;
    $b25c2e442c996fe7$var$treeForkProvider = workInProgress;
    $b25c2e442c996fe7$var$treeForkCount = totalChildren;
}
function $b25c2e442c996fe7$var$pushTreeId(workInProgress, totalChildren, index) {
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextId;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextOverflow;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextProvider;
    $b25c2e442c996fe7$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b25c2e442c996fe7$var$treeContextId;
    workInProgress = $b25c2e442c996fe7$var$treeContextOverflow;
    var baseLength = 32 - $b25c2e442c996fe7$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b25c2e442c996fe7$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b25c2e442c996fe7$var$treeContextId = 1 << 32 - $b25c2e442c996fe7$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b25c2e442c996fe7$var$treeContextOverflow = length + workInProgress;
    } else $b25c2e442c996fe7$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b25c2e442c996fe7$var$treeContextOverflow = workInProgress;
}
function $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b25c2e442c996fe7$var$pushTreeFork(workInProgress, 1), $b25c2e442c996fe7$var$pushTreeId(workInProgress, 1, 0));
}
function $b25c2e442c996fe7$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b25c2e442c996fe7$var$treeForkProvider;)$b25c2e442c996fe7$var$treeForkProvider = $b25c2e442c996fe7$var$forkStack[--$b25c2e442c996fe7$var$forkStackIndex], $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex] = null, $b25c2e442c996fe7$var$treeForkCount = $b25c2e442c996fe7$var$forkStack[--$b25c2e442c996fe7$var$forkStackIndex], $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex] = null;
    for(; workInProgress === $b25c2e442c996fe7$var$treeContextProvider;)$b25c2e442c996fe7$var$treeContextProvider = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null, $b25c2e442c996fe7$var$treeContextOverflow = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null, $b25c2e442c996fe7$var$treeContextId = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null;
}
function $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextId;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextOverflow;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextProvider;
    $b25c2e442c996fe7$var$treeContextId = suspendedContext.id;
    $b25c2e442c996fe7$var$treeContextOverflow = suspendedContext.overflow;
    $b25c2e442c996fe7$var$treeContextProvider = workInProgress;
}
var $b25c2e442c996fe7$var$hydrationParentFiber = null, $b25c2e442c996fe7$var$nextHydratableInstance = null, $b25c2e442c996fe7$var$isHydrating = !1, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, $b25c2e442c996fe7$var$HydrationMismatchException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(519));
function $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b25c2e442c996fe7$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(error, fiber));
    throw $b25c2e442c996fe7$var$HydrationMismatchException;
}
function $b25c2e442c996fe7$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b25c2e442c996fe7$var$internalInstanceKey] = fiber;
    instance[$b25c2e442c996fe7$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("cancel", instance);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b25c2e442c996fe7$var$mediaEventTypes.length; type++)$b25c2e442c996fe7$var$listenToNonDelegatedEvent($b25c2e442c996fe7$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", instance);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance);
            $b25c2e442c996fe7$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance), $b25c2e442c996fe7$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b25c2e442c996fe7$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", instance), $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b25c2e442c996fe7$var$noop$1), instance = !0) : instance = !1;
    instance || $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber, !0);
}
function $b25c2e442c996fe7$var$popToNextHostParent(fiber) {
    for($b25c2e442c996fe7$var$hydrationParentFiber = fiber.return; $b25c2e442c996fe7$var$hydrationParentFiber;)switch($b25c2e442c996fe7$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $b25c2e442c996fe7$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b25c2e442c996fe7$var$rootOrSingletonContext = !0;
            return;
        default:
            $b25c2e442c996fe7$var$hydrationParentFiber = $b25c2e442c996fe7$var$hydrationParentFiber.return;
    }
}
function $b25c2e442c996fe7$var$popHydrationState(fiber) {
    if (fiber !== $b25c2e442c996fe7$var$hydrationParentFiber) return !1;
    if (!$b25c2e442c996fe7$var$isHydrating) return $b25c2e442c996fe7$var$popToNextHostParent(fiber), $b25c2e442c996fe7$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b25c2e442c996fe7$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b25c2e442c996fe7$var$nextHydratableInstance && $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber);
    $b25c2e442c996fe7$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $b25c2e442c996fe7$var$nextHydratableInstance, $b25c2e442c996fe7$var$isSingletonScope(fiber.type) ? (fiber = $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton, $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = null, $b25c2e442c996fe7$var$nextHydratableInstance = fiber) : $b25c2e442c996fe7$var$nextHydratableInstance = tag) : $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$hydrationParentFiber ? $b25c2e442c996fe7$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b25c2e442c996fe7$var$resetHydrationState() {
    $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$hydrationParentFiber = null;
    $b25c2e442c996fe7$var$isHydrating = !1;
}
function $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b25c2e442c996fe7$var$hydrationErrors;
    null !== queuedErrors && (null === $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors ? $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = queuedErrors : $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors.push.apply($b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, queuedErrors), $b25c2e442c996fe7$var$hydrationErrors = null);
    return queuedErrors;
}
function $b25c2e442c996fe7$var$queueHydrationError(error) {
    null === $b25c2e442c996fe7$var$hydrationErrors ? $b25c2e442c996fe7$var$hydrationErrors = [
        error
    ] : $b25c2e442c996fe7$var$hydrationErrors.push(error);
}
var $b25c2e442c996fe7$var$valueCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null, $b25c2e442c996fe7$var$lastContextDependency = null;
function $b25c2e442c996fe7$var$pushProvider(providerFiber, context, nextValue) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b25c2e442c996fe7$var$popProvider(context) {
    context._currentValue = $b25c2e442c996fe7$var$valueCursor.current;
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$valueCursor);
}
function $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b25c2e442c996fe7$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b25c2e442c996fe7$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b25c2e442c996fe7$var$HostTransitionContext) : current = [
                $b25c2e442c996fe7$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b25c2e442c996fe7$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b25c2e442c996fe7$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b25c2e442c996fe7$var$prepareToReadContext(workInProgress) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = workInProgress;
    $b25c2e442c996fe7$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b25c2e442c996fe7$var$readContext(context) {
    return $b25c2e442c996fe7$var$readContextForConsumer($b25c2e442c996fe7$var$currentlyRenderingFiber$1, context);
}
function $b25c2e442c996fe7$var$readContextDuringReconciliation(consumer, context) {
    null === $b25c2e442c996fe7$var$currentlyRenderingFiber$1 && $b25c2e442c996fe7$var$prepareToReadContext(consumer);
    return $b25c2e442c996fe7$var$readContextForConsumer(consumer, context);
}
function $b25c2e442c996fe7$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b25c2e442c996fe7$var$lastContextDependency) {
        if (null === consumer) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(308));
        $b25c2e442c996fe7$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$lastContextDependency.next = context;
    return value;
}
var $b25c2e442c996fe7$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b25c2e442c996fe7$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $b25c2e442c996fe7$var$NormalPriority = $bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$CacheContext = {
    $$typeof: $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b25c2e442c996fe7$var$createCache() {
    return {
        controller: new $b25c2e442c996fe7$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b25c2e442c996fe7$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b25c2e442c996fe7$var$scheduleCallback$2($b25c2e442c996fe7$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b25c2e442c996fe7$var$currentEntangledListeners = null, $b25c2e442c996fe7$var$currentEntangledPendingCount = 0, $b25c2e442c996fe7$var$currentEntangledLane = 0, $b25c2e442c996fe7$var$currentEntangledActionThenable = null;
function $b25c2e442c996fe7$var$entangleAsyncAction(transition, thenable) {
    if (null === $b25c2e442c996fe7$var$currentEntangledListeners) {
        var entangledListeners = $b25c2e442c996fe7$var$currentEntangledListeners = [];
        $b25c2e442c996fe7$var$currentEntangledPendingCount = 0;
        $b25c2e442c996fe7$var$currentEntangledLane = $b25c2e442c996fe7$var$requestTransitionLane();
        $b25c2e442c996fe7$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b25c2e442c996fe7$var$currentEntangledPendingCount++;
    thenable.then($b25c2e442c996fe7$var$pingEngtangledActionScope, $b25c2e442c996fe7$var$pingEngtangledActionScope);
    return thenable;
}
function $b25c2e442c996fe7$var$pingEngtangledActionScope() {
    if (0 === --$b25c2e442c996fe7$var$currentEntangledPendingCount && null !== $b25c2e442c996fe7$var$currentEntangledListeners) {
        null !== $b25c2e442c996fe7$var$currentEntangledActionThenable && ($b25c2e442c996fe7$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b25c2e442c996fe7$var$currentEntangledListeners;
        $b25c2e442c996fe7$var$currentEntangledListeners = null;
        $b25c2e442c996fe7$var$currentEntangledLane = 0;
        $b25c2e442c996fe7$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b25c2e442c996fe7$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b25c2e442c996fe7$var$prevOnStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
$b25c2e442c996fe7$var$ReactSharedInternals.S = function(transition, returnValue) {
    $b25c2e442c996fe7$var$globalMostRecentTransitionTime = $b25c2e442c996fe7$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b25c2e442c996fe7$var$entangleAsyncAction(transition, returnValue);
    null !== $b25c2e442c996fe7$var$prevOnStartTransitionFinish && $b25c2e442c996fe7$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b25c2e442c996fe7$var$resumedCache = $b25c2e442c996fe7$var$createCursor(null);
function $b25c2e442c996fe7$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b25c2e442c996fe7$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b25c2e442c996fe7$var$workInProgressRoot.pooledCache;
}
function $b25c2e442c996fe7$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$resumedCache, $b25c2e442c996fe7$var$resumedCache.current) : $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$resumedCache, prevCachePool.pool);
}
function $b25c2e442c996fe7$var$getSuspendedCache() {
    var cacheFromPool = $b25c2e442c996fe7$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b25c2e442c996fe7$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b25c2e442c996fe7$var$SuspenseException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(460)), $b25c2e442c996fe7$var$SuspenseyCommitException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(474)), $b25c2e442c996fe7$var$SuspenseActionException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(542)), $b25c2e442c996fe7$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b25c2e442c996fe7$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b25c2e442c996fe7$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b25c2e442c996fe7$var$noop$1, $b25c2e442c996fe7$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b25c2e442c996fe7$var$noop$1, $b25c2e442c996fe7$var$noop$1);
            else {
                thenableState = $b25c2e442c996fe7$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b25c2e442c996fe7$var$suspendedThenable = thenable;
            throw $b25c2e442c996fe7$var$SuspenseException;
    }
}
function $b25c2e442c996fe7$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $b25c2e442c996fe7$var$suspendedThenable = x, $b25c2e442c996fe7$var$SuspenseException;
        throw x;
    }
}
var $b25c2e442c996fe7$var$suspendedThenable = null;
function $b25c2e442c996fe7$var$getSuspendedThenable() {
    if (null === $b25c2e442c996fe7$var$suspendedThenable) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(459));
    var thenable = $b25c2e442c996fe7$var$suspendedThenable;
    $b25c2e442c996fe7$var$suspendedThenable = null;
    return thenable;
}
function $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b25c2e442c996fe7$var$SuspenseException || rejectedReason === $b25c2e442c996fe7$var$SuspenseActionException) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(483));
}
var $b25c2e442c996fe7$var$thenableState$1 = null, $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
function $b25c2e442c996fe7$var$unwrapThenable(thenable) {
    var index = $b25c2e442c996fe7$var$thenableIndexCounter$1;
    $b25c2e442c996fe7$var$thenableIndexCounter$1 += 1;
    null === $b25c2e442c996fe7$var$thenableState$1 && ($b25c2e442c996fe7$var$thenableState$1 = []);
    return $b25c2e442c996fe7$var$trackUsedThenable($b25c2e442c996fe7$var$thenableState$1, thenable, index);
}
function $b25c2e442c996fe7$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b25c2e442c996fe7$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b25c2e442c996fe7$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b25c2e442c996fe7$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b25c2e442c996fe7$var$REACT_LAZY_TYPE && $b25c2e442c996fe7$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b25c2e442c996fe7$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b25c2e442c996fe7$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b25c2e442c996fe7$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b25c2e442c996fe7$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b25c2e442c996fe7$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return lanes = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b25c2e442c996fe7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return newChild = $b25c2e442c996fe7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return newChild = $b25c2e442c996fe7$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b25c2e442c996fe7$var$REACT_LAZY_TYPE && $b25c2e442c996fe7$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b25c2e442c996fe7$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE ? (lanes = $b25c2e442c996fe7$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b25c2e442c996fe7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b25c2e442c996fe7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b25c2e442c996fe7$var$getIteratorFn(newChild)) {
                key = $b25c2e442c996fe7$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b25c2e442c996fe7$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b25c2e442c996fe7$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b25c2e442c996fe7$var$SuspenseException || x === $b25c2e442c996fe7$var$SuspenseActionException) throw x;
            var fiber = $b25c2e442c996fe7$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b25c2e442c996fe7$var$reconcileChildFibers = $b25c2e442c996fe7$var$createChildReconciler(!0), $b25c2e442c996fe7$var$mountChildFibers = $b25c2e442c996fe7$var$createChildReconciler(!1), $b25c2e442c996fe7$var$hasForceUpdate = !1;
function $b25c2e442c996fe7$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b25c2e442c996fe7$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b25c2e442c996fe7$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
        $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b25c2e442c996fe7$var$markRootEntangled(root, lane);
    }
}
function $b25c2e442c996fe7$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !1;
function $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b25c2e442c996fe7$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b25c2e442c996fe7$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b25c2e442c996fe7$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b25c2e442c996fe7$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b25c2e442c996fe7$var$currentEntangledLane && ($b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b25c2e442c996fe7$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b25c2e442c996fe7$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b25c2e442c996fe7$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b25c2e442c996fe7$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b25c2e442c996fe7$var$callCallback(callbacks[updateQueue], context);
}
var $b25c2e442c996fe7$var$currentTreeHiddenStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$prevEntangledRenderLanesCursor = $b25c2e442c996fe7$var$createCursor(0);
function $b25c2e442c996fe7$var$pushHiddenContext(fiber, context) {
    fiber = $b25c2e442c996fe7$var$entangledRenderLanes;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor, fiber);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$currentTreeHiddenStackCursor, context);
    $b25c2e442c996fe7$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b25c2e442c996fe7$var$reuseHiddenContextOnStack() {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor, $b25c2e442c996fe7$var$entangledRenderLanes);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$currentTreeHiddenStackCursor, $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current);
}
function $b25c2e442c996fe7$var$popHiddenContext() {
    $b25c2e442c996fe7$var$entangledRenderLanes = $b25c2e442c996fe7$var$prevEntangledRenderLanesCursor.current;
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$currentTreeHiddenStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor);
}
var $b25c2e442c996fe7$var$suspenseHandlerStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$shellBoundary = null;
function $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current & 1);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, handler);
    null === $b25c2e442c996fe7$var$shellBoundary && (null === current || null !== $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current ? $b25c2e442c996fe7$var$shellBoundary = handler : null !== current.memoizedState && ($b25c2e442c996fe7$var$shellBoundary = handler));
}
function $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, fiber);
    null === $b25c2e442c996fe7$var$shellBoundary && ($b25c2e442c996fe7$var$shellBoundary = fiber);
}
function $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current), $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, fiber), null === $b25c2e442c996fe7$var$shellBoundary && ($b25c2e442c996fe7$var$shellBoundary = fiber)) : $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack() {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current);
}
function $b25c2e442c996fe7$var$popSuspenseHandler(fiber) {
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseHandlerStackCursor);
    $b25c2e442c996fe7$var$shellBoundary === fiber && ($b25c2e442c996fe7$var$shellBoundary = null);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
}
var $b25c2e442c996fe7$var$suspenseStackCursor = $b25c2e442c996fe7$var$createCursor(0);
function $b25c2e442c996fe7$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $b25c2e442c996fe7$var$isSuspenseInstancePending(state) || $b25c2e442c996fe7$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b25c2e442c996fe7$var$renderLanes = 0, $b25c2e442c996fe7$var$currentlyRenderingFiber = null, $b25c2e442c996fe7$var$currentHook = null, $b25c2e442c996fe7$var$workInProgressHook = null, $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1, $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b25c2e442c996fe7$var$localIdCounter = 0, $b25c2e442c996fe7$var$thenableIndexCounter = 0, $b25c2e442c996fe7$var$thenableState = null, $b25c2e442c996fe7$var$globalClientIdCounter = 0;
function $b25c2e442c996fe7$var$throwInvalidHookError() {
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(321));
}
function $b25c2e442c996fe7$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b25c2e442c996fe7$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b25c2e442c996fe7$var$renderLanes = nextRenderLanes;
    $b25c2e442c996fe7$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b25c2e442c996fe7$var$HooksDispatcherOnMount : $b25c2e442c996fe7$var$HooksDispatcherOnUpdate;
    $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b25c2e442c996fe7$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b25c2e442c996fe7$var$finishRenderingHooks(current) {
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b25c2e442c996fe7$var$currentHook && null !== $b25c2e442c996fe7$var$currentHook.next;
    $b25c2e442c996fe7$var$renderLanes = 0;
    $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1;
    $b25c2e442c996fe7$var$thenableIndexCounter = 0;
    $b25c2e442c996fe7$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(300));
    null === current || $b25c2e442c996fe7$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b25c2e442c996fe7$var$checkIfContextChanged(current) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0));
}
function $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b25c2e442c996fe7$var$thenableState = null);
        $b25c2e442c996fe7$var$thenableIndexCounter = 0;
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b25c2e442c996fe7$var$TransitionAwareHostComponent() {
    var dispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b25c2e442c996fe7$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b25c2e442c996fe7$var$currentHook ? $b25c2e442c996fe7$var$currentHook.memoizedState : null) !== dispatcher && ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b25c2e442c996fe7$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b25c2e442c996fe7$var$localIdCounter;
    $b25c2e442c996fe7$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b25c2e442c996fe7$var$resetHooksOnUnwind(workInProgress) {
    if ($b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b25c2e442c996fe7$var$renderLanes = 0;
    $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b25c2e442c996fe7$var$thenableIndexCounter = $b25c2e442c996fe7$var$localIdCounter = 0;
    $b25c2e442c996fe7$var$thenableState = null;
}
function $b25c2e442c996fe7$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState = $b25c2e442c996fe7$var$workInProgressHook = hook : $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$workInProgressHook.next = hook;
    return $b25c2e442c996fe7$var$workInProgressHook;
}
function $b25c2e442c996fe7$var$updateWorkInProgressHook() {
    if (null === $b25c2e442c996fe7$var$currentHook) {
        var nextCurrentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b25c2e442c996fe7$var$currentHook.next;
    var nextWorkInProgressHook = null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState : $b25c2e442c996fe7$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b25c2e442c996fe7$var$workInProgressHook = nextWorkInProgressHook, $b25c2e442c996fe7$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(467));
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(310));
        }
        $b25c2e442c996fe7$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b25c2e442c996fe7$var$currentHook.memoizedState,
            baseState: $b25c2e442c996fe7$var$currentHook.baseState,
            baseQueue: $b25c2e442c996fe7$var$currentHook.baseQueue,
            queue: $b25c2e442c996fe7$var$currentHook.queue,
            next: null
        };
        null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState = $b25c2e442c996fe7$var$workInProgressHook = nextCurrentHook : $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b25c2e442c996fe7$var$workInProgressHook;
}
function $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b25c2e442c996fe7$var$useThenable(thenable) {
    var index = $b25c2e442c996fe7$var$thenableIndexCounter;
    $b25c2e442c996fe7$var$thenableIndexCounter += 1;
    null === $b25c2e442c996fe7$var$thenableState && ($b25c2e442c996fe7$var$thenableState = []);
    thenable = $b25c2e442c996fe7$var$trackUsedThenable($b25c2e442c996fe7$var$thenableState, thenable, index);
    index = $b25c2e442c996fe7$var$currentlyRenderingFiber;
    null === (null === $b25c2e442c996fe7$var$workInProgressHook ? index.memoizedState : $b25c2e442c996fe7$var$workInProgressHook.next) && (index = index.alternate, $b25c2e442c996fe7$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b25c2e442c996fe7$var$HooksDispatcherOnMount : $b25c2e442c996fe7$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b25c2e442c996fe7$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b25c2e442c996fe7$var$useThenable(usable);
        if (usable.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return $b25c2e442c996fe7$var$readContext(usable);
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(438, String(usable)));
}
function $b25c2e442c996fe7$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b25c2e442c996fe7$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b25c2e442c996fe7$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b25c2e442c996fe7$var$updateReducer(reducer) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    return $b25c2e442c996fe7$var$updateReducerImpl(hook, $b25c2e442c996fe7$var$currentHook, reducer);
}
function $b25c2e442c996fe7$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b25c2e442c996fe7$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b25c2e442c996fe7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($b25c2e442c996fe7$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b25c2e442c996fe7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= revertLane, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= updateLane, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b25c2e442c996fe7$var$objectIs(pendingQueue, hook.memoizedState) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $b25c2e442c996fe7$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b25c2e442c996fe7$var$rerenderReducer(reducer) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b25c2e442c996fe7$var$objectIs(newState, hook.memoizedState) || ($b25c2e442c996fe7$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b25c2e442c996fe7$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b25c2e442c996fe7$var$currentlyRenderingFiber, hook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b25c2e442c996fe7$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b25c2e442c996fe7$var$objectIs(($b25c2e442c996fe7$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b25c2e442c996fe7$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b25c2e442c996fe7$var$updateEffect($b25c2e442c996fe7$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b25c2e442c996fe7$var$workInProgressHook && $b25c2e442c996fe7$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b25c2e442c996fe7$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b25c2e442c996fe7$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b25c2e442c996fe7$var$workInProgressRoot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b25c2e442c996fe7$var$renderLanes & 127) || $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b25c2e442c996fe7$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) && $b25c2e442c996fe7$var$forceStoreRerender(fiber);
}
function $b25c2e442c996fe7$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) && $b25c2e442c996fe7$var$forceStoreRerender(fiber);
    });
}
function $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b25c2e442c996fe7$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b25c2e442c996fe7$var$forceStoreRerender(fiber) {
    var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b25c2e442c996fe7$var$mountStateImpl(initialState) {
    var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b25c2e442c996fe7$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b25c2e442c996fe7$var$updateReducerImpl(hook, $b25c2e442c996fe7$var$currentHook, "function" === typeof reducer ? reducer : $b25c2e442c996fe7$var$basicStateReducer);
}
function $b25c2e442c996fe7$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b25c2e442c996fe7$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b25c2e442c996fe7$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b25c2e442c996fe7$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, currentTransition = {};
        $b25c2e442c996fe7$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b25c2e442c996fe7$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $b25c2e442c996fe7$var$onActionError(actionQueue, node, error$66);
    }
}
function $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b25c2e442c996fe7$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b25c2e442c996fe7$var$onActionError(actionQueue, node, error);
    }) : $b25c2e442c996fe7$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b25c2e442c996fe7$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b25c2e442c996fe7$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b25c2e442c996fe7$var$runActionStateAction(actionQueue, nextState)));
}
function $b25c2e442c996fe7$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b25c2e442c996fe7$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b25c2e442c996fe7$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b25c2e442c996fe7$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b25c2e442c996fe7$var$mountActionState(action, initialStateProp) {
    if ($b25c2e442c996fe7$var$isHydrating) {
        var ssrFormState = $b25c2e442c996fe7$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b25c2e442c996fe7$var$currentlyRenderingFiber;
                if ($b25c2e442c996fe7$var$isHydrating) {
                    if ($b25c2e442c996fe7$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b25c2e442c996fe7$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b25c2e442c996fe7$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b25c2e442c996fe7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b25c2e442c996fe7$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b25c2e442c996fe7$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b25c2e442c996fe7$var$dispatchSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b25c2e442c996fe7$var$mountStateImpl(!1);
    inRootOrSingleton = $b25c2e442c996fe7$var$dispatchOptimisticSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b25c2e442c996fe7$var$dispatchActionState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b25c2e442c996fe7$var$updateActionState(action) {
    var stateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    return $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, $b25c2e442c996fe7$var$currentHook, action);
}
function $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b25c2e442c996fe7$var$updateReducerImpl(stateHook, currentStateHook, $b25c2e442c996fe7$var$actionStateReducer)[0];
    stateHook = $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b25c2e442c996fe7$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b25c2e442c996fe7$var$SuspenseException) throw $b25c2e442c996fe7$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 2048, $b25c2e442c996fe7$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $b25c2e442c996fe7$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b25c2e442c996fe7$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b25c2e442c996fe7$var$rerenderActionState(action) {
    var stateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), currentStateHook = $b25c2e442c996fe7$var$currentHook;
    if (null !== currentStateHook) return $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b25c2e442c996fe7$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b25c2e442c996fe7$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $b25c2e442c996fe7$var$updateRef() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $b25c2e442c996fe7$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b25c2e442c996fe7$var$currentHook && null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, $b25c2e442c996fe7$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b25c2e442c996fe7$var$mountEffect(create, deps) {
    $b25c2e442c996fe7$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b25c2e442c996fe7$var$updateEffect(create, deps) {
    $b25c2e442c996fe7$var$updateEffectImpl(2048, 8, create, deps);
}
function $b25c2e442c996fe7$var$useEffectEventImpl(payload) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $b25c2e442c996fe7$var$updateEvent(callback) {
    var ref = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
    $b25c2e442c996fe7$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $b25c2e442c996fe7$var$updateInsertionEffect(create, deps) {
    return $b25c2e442c996fe7$var$updateEffectImpl(4, 2, create, deps);
}
function $b25c2e442c996fe7$var$updateLayoutEffect(create, deps) {
    return $b25c2e442c996fe7$var$updateEffectImpl(4, 4, create, deps);
}
function $b25c2e442c996fe7$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b25c2e442c996fe7$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b25c2e442c996fe7$var$updateEffectImpl(4, 4, $b25c2e442c996fe7$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b25c2e442c996fe7$var$mountDebugValue() {}
function $b25c2e442c996fe7$var$updateCallback(callback, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b25c2e442c996fe7$var$updateMemo(nextCreate, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b25c2e442c996fe7$var$renderLanes & 1073741824) && 0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b25c2e442c996fe7$var$requestDeferredLane();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= hook;
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b25c2e442c996fe7$var$objectIs(value, prevValue)) return value;
    if (null !== $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current) return hook = $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue), $b25c2e442c996fe7$var$objectIs(hook, prevValue) || ($b25c2e442c996fe7$var$didReceiveUpdate = !0), hook;
    if (0 === ($b25c2e442c996fe7$var$renderLanes & 42) || 0 !== ($b25c2e442c996fe7$var$renderLanes & 1073741824) && 0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 261930)) return $b25c2e442c996fe7$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b25c2e442c996fe7$var$requestDeferredLane();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= hook;
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b25c2e442c996fe7$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, currentTransition = {};
    $b25c2e442c996fe7$var$ReactSharedInternals.T = currentTransition;
    $b25c2e442c996fe7$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b25c2e442c996fe7$var$chainThenableValue(returnValue, finishedState);
            $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b25c2e442c996fe7$var$requestUpdateLane(fiber));
        } else $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, finishedState, $b25c2e442c996fe7$var$requestUpdateLane(fiber));
    } catch (error) {
        $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b25c2e442c996fe7$var$requestUpdateLane());
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$noop() {}
function $b25c2e442c996fe7$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(476));
    var queue = $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber).queue;
    $b25c2e442c996fe7$var$startTransition(formFiber, queue, pendingState, $b25c2e442c996fe7$var$sharedNotPendingObject, null === action ? $b25c2e442c996fe7$var$noop : function() {
        $b25c2e442c996fe7$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b25c2e442c996fe7$var$sharedNotPendingObject,
        baseState: $b25c2e442c996fe7$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
            lastRenderedState: $b25c2e442c996fe7$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b25c2e442c996fe7$var$requestFormReset$1(formFiber) {
    var stateHook = $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $b25c2e442c996fe7$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $b25c2e442c996fe7$var$requestUpdateLane());
}
function $b25c2e442c996fe7$var$useHostTransitionStatus() {
    return $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$HostTransitionContext);
}
function $b25c2e442c996fe7$var$updateId() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$updateRefresh() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b25c2e442c996fe7$var$requestUpdateLane();
                fiber = $b25c2e442c996fe7$var$createUpdate(lane);
                var root$69 = $b25c2e442c996fe7$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(root$69, provider, lane), $b25c2e442c996fe7$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $b25c2e442c996fe7$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b25c2e442c996fe7$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b25c2e442c996fe7$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber) ? $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(action, fiber, lane), $b25c2e442c996fe7$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b25c2e442c996fe7$var$dispatchSetState(fiber, queue, action) {
    var lane = $b25c2e442c996fe7$var$requestUpdateLane();
    $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b25c2e442c996fe7$var$objectIs(eagerState, currentState)) return $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b25c2e442c996fe7$var$workInProgressRoot && $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b25c2e442c996fe7$var$scheduleUpdateOnFiber(action, fiber, lane), $b25c2e442c996fe7$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b25c2e442c996fe7$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b25c2e442c996fe7$var$currentlyRenderingFiber || null !== alternate && alternate === $b25c2e442c996fe7$var$currentlyRenderingFiber;
}
function $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, update) {
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b25c2e442c996fe7$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b25c2e442c996fe7$var$markRootEntangled(root, lane);
    }
}
var $b25c2e442c996fe7$var$ContextOnlyDispatcher = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$throwInvalidHookError,
    useContext: $b25c2e442c996fe7$var$throwInvalidHookError,
    useEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useImperativeHandle: $b25c2e442c996fe7$var$throwInvalidHookError,
    useLayoutEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useInsertionEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useMemo: $b25c2e442c996fe7$var$throwInvalidHookError,
    useReducer: $b25c2e442c996fe7$var$throwInvalidHookError,
    useRef: $b25c2e442c996fe7$var$throwInvalidHookError,
    useState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useDebugValue: $b25c2e442c996fe7$var$throwInvalidHookError,
    useDeferredValue: $b25c2e442c996fe7$var$throwInvalidHookError,
    useTransition: $b25c2e442c996fe7$var$throwInvalidHookError,
    useSyncExternalStore: $b25c2e442c996fe7$var$throwInvalidHookError,
    useId: $b25c2e442c996fe7$var$throwInvalidHookError,
    useHostTransitionStatus: $b25c2e442c996fe7$var$throwInvalidHookError,
    useFormState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useActionState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useOptimistic: $b25c2e442c996fe7$var$throwInvalidHookError,
    useMemoCache: $b25c2e442c996fe7$var$throwInvalidHookError,
    useCacheRefresh: $b25c2e442c996fe7$var$throwInvalidHookError
};
$b25c2e442c996fe7$var$ContextOnlyDispatcher.useEffectEvent = $b25c2e442c996fe7$var$throwInvalidHookError;
var $b25c2e442c996fe7$var$HooksDispatcherOnMount = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: function(callback, deps) {
        $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b25c2e442c996fe7$var$mountEffectImpl(4194308, 4, $b25c2e442c996fe7$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b25c2e442c996fe7$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b25c2e442c996fe7$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b25c2e442c996fe7$var$dispatchReducerAction.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b25c2e442c996fe7$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b25c2e442c996fe7$var$dispatchSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        return $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b25c2e442c996fe7$var$mountStateImpl(!1);
        stateHook = $b25c2e442c996fe7$var$startTransition.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b25c2e442c996fe7$var$currentlyRenderingFiber, hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        if ($b25c2e442c996fe7$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b25c2e442c996fe7$var$workInProgressRoot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(349));
            0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 127) || $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b25c2e442c996fe7$var$mountEffect($b25c2e442c996fe7$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b25c2e442c996fe7$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b25c2e442c996fe7$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook(), identifierPrefix = $b25c2e442c996fe7$var$workInProgressRoot.identifierPrefix;
        if ($b25c2e442c996fe7$var$isHydrating) {
            var JSCompiler_inline_result = $b25c2e442c996fe7$var$treeContextOverflow;
            var idWithLeadingBit = $b25c2e442c996fe7$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b25c2e442c996fe7$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b25c2e442c996fe7$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $b25c2e442c996fe7$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$mountActionState,
    useActionState: $b25c2e442c996fe7$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b25c2e442c996fe7$var$dispatchOptimisticSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: function() {
        return $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = $b25c2e442c996fe7$var$refreshCache.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $b25c2e442c996fe7$var$HooksDispatcherOnUpdate = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$updateCallback,
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$updateEffect,
    useImperativeHandle: $b25c2e442c996fe7$var$updateImperativeHandle,
    useInsertionEffect: $b25c2e442c996fe7$var$updateInsertionEffect,
    useLayoutEffect: $b25c2e442c996fe7$var$updateLayoutEffect,
    useMemo: $b25c2e442c996fe7$var$updateMemo,
    useReducer: $b25c2e442c996fe7$var$updateReducer,
    useRef: $b25c2e442c996fe7$var$updateRef,
    useState: function() {
        return $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer);
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, $b25c2e442c996fe7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer)[0], start = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b25c2e442c996fe7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b25c2e442c996fe7$var$updateSyncExternalStore,
    useId: $b25c2e442c996fe7$var$updateId,
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$updateActionState,
    useActionState: $b25c2e442c996fe7$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return $b25c2e442c996fe7$var$updateOptimisticImpl(hook, $b25c2e442c996fe7$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: $b25c2e442c996fe7$var$updateRefresh
};
$b25c2e442c996fe7$var$HooksDispatcherOnUpdate.useEffectEvent = $b25c2e442c996fe7$var$updateEvent;
var $b25c2e442c996fe7$var$HooksDispatcherOnRerender = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$updateCallback,
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$updateEffect,
    useImperativeHandle: $b25c2e442c996fe7$var$updateImperativeHandle,
    useInsertionEffect: $b25c2e442c996fe7$var$updateInsertionEffect,
    useLayoutEffect: $b25c2e442c996fe7$var$updateLayoutEffect,
    useMemo: $b25c2e442c996fe7$var$updateMemo,
    useReducer: $b25c2e442c996fe7$var$rerenderReducer,
    useRef: $b25c2e442c996fe7$var$updateRef,
    useState: function() {
        return $b25c2e442c996fe7$var$rerenderReducer($b25c2e442c996fe7$var$basicStateReducer);
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return null === $b25c2e442c996fe7$var$currentHook ? $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue) : $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, $b25c2e442c996fe7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b25c2e442c996fe7$var$rerenderReducer($b25c2e442c996fe7$var$basicStateReducer)[0], start = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b25c2e442c996fe7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b25c2e442c996fe7$var$updateSyncExternalStore,
    useId: $b25c2e442c996fe7$var$updateId,
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$rerenderActionState,
    useActionState: $b25c2e442c996fe7$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        if (null !== $b25c2e442c996fe7$var$currentHook) return $b25c2e442c996fe7$var$updateOptimisticImpl(hook, $b25c2e442c996fe7$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: $b25c2e442c996fe7$var$updateRefresh
};
$b25c2e442c996fe7$var$HooksDispatcherOnRerender.useEffectEvent = $b25c2e442c996fe7$var$updateEvent;
function $b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b25c2e442c996fe7$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b25c2e442c996fe7$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(payload, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(payload, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(callback, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(callback, inst, lane));
    }
};
function $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b25c2e442c996fe7$var$shallowEqual(oldProps, newProps) || !$b25c2e442c996fe7$var$shallowEqual(oldState, newState) : !0;
}
function $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b25c2e442c996fe7$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b25c2e442c996fe7$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b25c2e442c996fe7$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $b25c2e442c996fe7$var$defaultOnUncaughtError(error) {
    $b25c2e442c996fe7$var$reportGlobalError(error);
}
function $b25c2e442c996fe7$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b25c2e442c996fe7$var$defaultOnRecoverableError(error) {
    $b25c2e442c996fe7$var$reportGlobalError(error);
}
function $b25c2e442c996fe7$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b25c2e442c996fe7$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b25c2e442c996fe7$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b25c2e442c996fe7$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b25c2e442c996fe7$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b25c2e442c996fe7$var$createClassErrorUpdate(lane) {
    lane = $b25c2e442c996fe7$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b25c2e442c996fe7$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b25c2e442c996fe7$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b25c2e442c996fe7$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed ? $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b25c2e442c996fe7$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b25c2e442c996fe7$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $b25c2e442c996fe7$var$shellBoundary ? $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b25c2e442c996fe7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b25c2e442c996fe7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes);
        $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b25c2e442c996fe7$var$isHydrating) return returnFiber = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b25c2e442c996fe7$var$HydrationMismatchException && (root = Error($b25c2e442c996fe7$var$formatProdErrorMessage(422), {
        cause: value
    }), $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b25c2e442c996fe7$var$HydrationMismatchException && (returnFiber = Error($b25c2e442c996fe7$var$formatProdErrorMessage(423), {
        cause: value
    }), $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b25c2e442c996fe7$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b25c2e442c996fe7$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b25c2e442c996fe7$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b25c2e442c996fe7$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors ? $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b25c2e442c996fe7$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b25c2e442c996fe7$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed || !$b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b25c2e442c996fe7$var$createClassErrorUpdate(rootRenderLanes), $b25c2e442c996fe7$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b25c2e442c996fe7$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b25c2e442c996fe7$var$SelectiveHydrationException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(461)), $b25c2e442c996fe7$var$didReceiveUpdate = !1;
function $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b25c2e442c996fe7$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b25c2e442c996fe7$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    nextProps = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && key && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b25c2e442c996fe7$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b25c2e442c996fe7$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b25c2e442c996fe7$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b25c2e442c996fe7$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b25c2e442c996fe7$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b25c2e442c996fe7$var$pushHiddenContext(workInProgress, prevState) : $b25c2e442c996fe7$var$reuseHiddenContextOnStack(), $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($b25c2e442c996fe7$var$pushTransition(workInProgress, prevState.cachePool), $b25c2e442c996fe7$var$pushHiddenContext(workInProgress, prevState), $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null), $b25c2e442c996fe7$var$reuseHiddenContextOnStack(), $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $b25c2e442c996fe7$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b25c2e442c996fe7$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null);
    $b25c2e442c996fe7$var$reuseHiddenContextOnStack();
    $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $b25c2e442c996fe7$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($b25c2e442c996fe7$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, current);
            $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $b25c2e442c996fe7$var$nextHydratableInstance) ? (current = $b25c2e442c996fe7$var$canHydrateHydrationBoundary(current, $b25c2e442c996fe7$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b25c2e442c996fe7$var$treeContextProvider ? {
                    id: $b25c2e442c996fe7$var$treeContextId,
                    overflow: $b25c2e442c996fe7$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(558));
        } else if ($b25c2e442c996fe7$var$didReceiveUpdate || $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $b25c2e442c996fe7$var$didReceiveUpdate || didSuspend) {
            nextProps = $b25c2e442c996fe7$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $b25c2e442c996fe7$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(current, dehydrated), $b25c2e442c996fe7$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $b25c2e442c996fe7$var$SelectiveHydrationException;
            $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(dehydrated.nextSibling), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$isHydrating = !0, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, null !== current && $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $b25c2e442c996fe7$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $b25c2e442c996fe7$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    Component = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && nextProps && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b25c2e442c996fe7$var$finishRenderingHooks(current);
    Component = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && Component && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b25c2e442c996fe7$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b25c2e442c996fe7$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b25c2e442c996fe7$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b25c2e442c996fe7$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b25c2e442c996fe7$var$readContext(contextType) : $b25c2e442c996fe7$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b25c2e442c996fe7$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b25c2e442c996fe7$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b25c2e442c996fe7$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b25c2e442c996fe7$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b25c2e442c996fe7$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b25c2e442c996fe7$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b25c2e442c996fe7$var$hasForceUpdate || $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b25c2e442c996fe7$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b25c2e442c996fe7$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b25c2e442c996fe7$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b25c2e442c996fe7$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b25c2e442c996fe7$var$hasForceUpdate || null !== current && null !== current.dependencies && $b25c2e442c996fe7$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b25c2e442c996fe7$var$hasForceUpdate || $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b25c2e442c996fe7$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b25c2e442c996fe7$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b25c2e442c996fe7$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b25c2e442c996fe7$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b25c2e442c996fe7$var$getSuspendedCache()
    };
}
function $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b25c2e442c996fe7$var$workInProgressDeferredLane);
    return current;
}
function $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b25c2e442c996fe7$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b25c2e442c996fe7$var$isHydrating) {
            showFallback ? $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $b25c2e442c996fe7$var$nextHydratableInstance) ? (current = $b25c2e442c996fe7$var$canHydrateHydrationBoundary(current, $b25c2e442c996fe7$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b25c2e442c996fe7$var$treeContextProvider ? {
                    id: $b25c2e442c996fe7$var$treeContextId,
                    overflow: $b25c2e442c996fe7$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            $b25c2e442c996fe7$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $b25c2e442c996fe7$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps);
        $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $b25c2e442c996fe7$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, workInProgress = $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps));
        else if ($b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b25c2e442c996fe7$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b25c2e442c996fe7$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b25c2e442c996fe7$var$didReceiveUpdate || $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b25c2e442c996fe7$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b25c2e442c996fe7$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $b25c2e442c996fe7$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(current, nextProps), $b25c2e442c996fe7$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b25c2e442c996fe7$var$SelectiveHydrationException;
            $b25c2e442c996fe7$var$isSuspenseInstancePending(nextPrimaryChildren) || $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $b25c2e442c996fe7$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(nextPrimaryChildren.nextSibling), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$isHydrating = !0, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, null !== current && $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $b25c2e442c996fe7$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $b25c2e442c996fe7$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $b25c2e442c996fe7$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $b25c2e442c996fe7$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $b25c2e442c996fe7$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, $b25c2e442c996fe7$var$bailoutOffscreenComponent(current.child, nextProps);
    $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b25c2e442c996fe7$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b25c2e442c996fe7$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $b25c2e442c996fe7$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, suspenseContext);
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $b25c2e442c996fe7$var$isHydrating ? $b25c2e442c996fe7$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b25c2e442c996fe7$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b25c2e442c996fe7$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b25c2e442c996fe7$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b25c2e442c996fe7$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b25c2e442c996fe7$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b25c2e442c996fe7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, current.memoizedState.cache);
            $b25c2e442c996fe7$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b25c2e442c996fe7$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b25c2e442c996fe7$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, current.memoizedState.cache);
    }
    return $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b25c2e442c996fe7$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b25c2e442c996fe7$var$didReceiveUpdate = !0;
        else {
            if (!$b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b25c2e442c996fe7$var$didReceiveUpdate = !1, $b25c2e442c996fe7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b25c2e442c996fe7$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b25c2e442c996fe7$var$didReceiveUpdate = !1, $b25c2e442c996fe7$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b25c2e442c996fe7$var$pushTreeId(workInProgress, $b25c2e442c996fe7$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $b25c2e442c996fe7$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $b25c2e442c996fe7$var$shouldConstruct(current) ? (props = $b25c2e442c996fe7$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $b25c2e442c996fe7$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b25c2e442c996fe7$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b25c2e442c996fe7$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $b25c2e442c996fe7$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b25c2e442c996fe7$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b25c2e442c996fe7$var$getComponentNameFromType(current) || current;
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $b25c2e442c996fe7$var$resolveClassComponentProps(props, workInProgress.pendingProps), $b25c2e442c996fe7$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress);
                $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props);
                props !== prevState.cache && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, [
                    $b25c2e442c996fe7$var$CacheContext
                ], renderLanes, !0);
                $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $b25c2e442c996fe7$var$createCapturedValueAtFiber(Error($b25c2e442c996fe7$var$formatProdErrorMessage(424)), workInProgress);
                        $b25c2e442c996fe7$var$queueHydrationError($$typeof);
                        workInProgress = $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(current.firstChild);
                        $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress;
                        $b25c2e442c996fe7$var$isHydrating = !0;
                        $b25c2e442c996fe7$var$hydrationErrors = null;
                        $b25c2e442c996fe7$var$rootOrSingletonContext = !0;
                        renderLanes = $b25c2e442c996fe7$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b25c2e442c996fe7$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b25c2e442c996fe7$var$markRef(current, workInProgress), null === current ? (renderLanes = $b25c2e442c996fe7$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b25c2e442c996fe7$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer($b25c2e442c996fe7$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress, props[$b25c2e442c996fe7$var$internalPropsKey] = current, $b25c2e442c996fe7$var$setInitialProperties(props, renderLanes, current), $b25c2e442c996fe7$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $b25c2e442c996fe7$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b25c2e442c996fe7$var$pushHostContext(workInProgress), null === current && $b25c2e442c996fe7$var$isHydrating && (props = workInProgress.stateNode = $b25c2e442c996fe7$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootInstanceStackCursor.current), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$rootOrSingletonContext = !0, $$typeof = $b25c2e442c996fe7$var$nextHydratableInstance, $b25c2e442c996fe7$var$isSingletonScope(workInProgress.type) ? ($b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(props.firstChild)) : $b25c2e442c996fe7$var$nextHydratableInstance = $$typeof), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b25c2e442c996fe7$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b25c2e442c996fe7$var$isHydrating) {
                if ($$typeof = props = $b25c2e442c996fe7$var$nextHydratableInstance) props = $b25c2e442c996fe7$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(props.firstChild), $b25c2e442c996fe7$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            }
            $b25c2e442c996fe7$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $b25c2e442c996fe7$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $b25c2e442c996fe7$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, $b25c2e442c996fe7$var$TransitionAwareHostComponent, null, null, renderLanes), $b25c2e442c996fe7$var$HostTransitionContext._currentValue = $$typeof);
            $b25c2e442c996fe7$var$markRef(current, workInProgress);
            $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b25c2e442c996fe7$var$isHydrating) {
                if (current = renderLanes = $b25c2e442c996fe7$var$nextHydratableInstance) renderLanes = $b25c2e442c996fe7$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $b25c2e442c996fe7$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $b25c2e442c996fe7$var$pushProvider(workInProgress, workInProgress.type, props.value), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $b25c2e442c996fe7$var$prepareToReadContext(workInProgress), $$typeof = $b25c2e442c996fe7$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $b25c2e442c996fe7$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $b25c2e442c996fe7$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $b25c2e442c996fe7$var$prepareToReadContext(workInProgress), props = $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext), null === current ? ($$typeof = $b25c2e442c996fe7$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $b25c2e442c996fe7$var$workInProgressRoot, prevState = $b25c2e442c996fe7$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $b25c2e442c996fe7$var$initializeUpdateQueue(workInProgress), $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress), $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props)) : (props = prevState.cache, $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props), props !== $$typeof.cache && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, [
                $b25c2e442c996fe7$var$CacheContext
            ], renderLanes, !0))), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b25c2e442c996fe7$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($b25c2e442c996fe7$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $b25c2e442c996fe7$var$suspendedThenable = $b25c2e442c996fe7$var$noopSuspenseyCommitThenable, $b25c2e442c996fe7$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b25c2e442c996fe7$var$preloadResource(resource)) {
        if ($b25c2e442c996fe7$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $b25c2e442c996fe7$var$suspendedThenable = $b25c2e442c996fe7$var$noopSuspenseyCommitThenable, $b25c2e442c996fe7$var$SuspenseyCommitException;
    }
}
function $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b25c2e442c996fe7$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b25c2e442c996fe7$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b25c2e442c996fe7$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $b25c2e442c996fe7$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b25c2e442c996fe7$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b25c2e442c996fe7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
            $b25c2e442c996fe7$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b25c2e442c996fe7$var$popHydrationState(workInProgress) ? $b25c2e442c996fe7$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable());
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($b25c2e442c996fe7$var$markUpdate(workInProgress), null !== nextResource ? ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($b25c2e442c996fe7$var$markUpdate(workInProgress), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $b25c2e442c996fe7$var$popHostContext(workInProgress);
            renderLanes = $b25c2e442c996fe7$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b25c2e442c996fe7$var$contextStackCursor.current;
                $b25c2e442c996fe7$var$popHydrationState(workInProgress) ? $b25c2e442c996fe7$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b25c2e442c996fe7$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b25c2e442c996fe7$var$markUpdate(workInProgress));
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b25c2e442c996fe7$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $b25c2e442c996fe7$var$contextStackCursor.current;
                if ($b25c2e442c996fe7$var$popHydrationState(workInProgress)) $b25c2e442c996fe7$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer($b25c2e442c996fe7$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    nextResource[$b25c2e442c996fe7$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($b25c2e442c996fe7$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
                }
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                current = $b25c2e442c996fe7$var$rootInstanceStackCursor.current;
                if ($b25c2e442c996fe7$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b25c2e442c996fe7$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b25c2e442c996fe7$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $b25c2e442c996fe7$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(557));
                        current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    } else $b25c2e442c996fe7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(558));
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b25c2e442c996fe7$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
                        type[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    } else $b25c2e442c996fe7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b25c2e442c996fe7$var$popHostContainer(), null === current && $b25c2e442c996fe7$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b25c2e442c996fe7$var$popProvider(workInProgress.type), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 19:
            $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $b25c2e442c996fe7$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b25c2e442c996fe7$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current & 1 | 2);
                            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $b25c2e442c996fe7$var$now() > $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $b25c2e442c996fe7$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, current), $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$b25c2e442c996fe7$var$isHydrating) return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b25c2e442c996fe7$var$now() - newProps.renderingStartTime > $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $b25c2e442c996fe7$var$now(), current.sibling = null, renderLanes = $b25c2e442c996fe7$var$suspenseStackCursor.current, $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b25c2e442c996fe7$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b25c2e442c996fe7$var$unwindWork(current, workInProgress) {
    $b25c2e442c996fe7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), $b25c2e442c996fe7$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b25c2e442c996fe7$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(340));
                $b25c2e442c996fe7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(340));
                $b25c2e442c996fe7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor), null;
        case 4:
            return $b25c2e442c996fe7$var$popHostContainer(), null;
        case 10:
            return $b25c2e442c996fe7$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$popHiddenContext(), null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b25c2e442c996fe7$var$unwindInterruptedWork(current, interruptedWork) {
    $b25c2e442c996fe7$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
            $b25c2e442c996fe7$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b25c2e442c996fe7$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b25c2e442c996fe7$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
            break;
        case 10:
            $b25c2e442c996fe7$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            $b25c2e442c996fe7$var$popHiddenContext();
            null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache);
            break;
        case 24:
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
    }
}
function $b25c2e442c996fe7$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b25c2e442c996fe7$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b25c2e442c996fe7$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b25c2e442c996fe7$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b25c2e442c996fe7$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $b25c2e442c996fe7$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b25c2e442c996fe7$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b25c2e442c996fe7$var$internalPropsKey] = newProps;
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b25c2e442c996fe7$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b25c2e442c996fe7$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b25c2e442c996fe7$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b25c2e442c996fe7$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b25c2e442c996fe7$var$noop$1));
    else if (4 !== tag && (27 === tag && $b25c2e442c996fe7$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b25c2e442c996fe7$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b25c2e442c996fe7$var$setInitialProperties(singleton, type, props);
        singleton[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
        singleton[$b25c2e442c996fe7$var$internalPropsKey] = props;
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = !1, $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = !1, $b25c2e442c996fe7$var$needsFormReset = !1, $b25c2e442c996fe7$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b25c2e442c996fe7$var$nextEffect = null;
function $b25c2e442c996fe7$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b25c2e442c996fe7$var$eventsEnabled = $b25c2e442c996fe7$var$_enabled;
    root = $b25c2e442c996fe7$var$getActiveElementDeep(root);
    if ($b25c2e442c996fe7$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b25c2e442c996fe7$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b25c2e442c996fe7$var$_enabled = !1;
    for($b25c2e442c996fe7$var$nextEffect = firstChild; null !== $b25c2e442c996fe7$var$nextEffect;)if (firstChild = $b25c2e442c996fe7$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b25c2e442c996fe7$var$nextEffect = root;
    else for(; null !== $b25c2e442c996fe7$var$nextEffect;){
        firstChild = $b25c2e442c996fe7$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b25c2e442c996fe7$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b25c2e442c996fe7$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b25c2e442c996fe7$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b25c2e442c996fe7$var$nextEffect = root;
            break;
        }
        $b25c2e442c996fe7$var$nextEffect = firstChild.return;
    }
}
function $b25c2e442c996fe7$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b25c2e442c996fe7$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b25c2e442c996fe7$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostMount(finishedWork);
            flags & 512 && $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b25c2e442c996fe7$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b25c2e442c996fe7$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b25c2e442c996fe7$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
                prevProps = $b25c2e442c996fe7$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
                $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = flags;
                ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevProps;
                $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b25c2e442c996fe7$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b25c2e442c996fe7$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b25c2e442c996fe7$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b25c2e442c996fe7$var$hostParent = null, $b25c2e442c996fe7$var$hostParentIsContainer = !1;
function $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onCommitFiberUnmount) try {
        $b25c2e442c996fe7$var$injectedHook.onCommitFiberUnmount($b25c2e442c996fe7$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b25c2e442c996fe7$var$hostParent, prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$isSingletonScope(deletedFiber.type) && ($b25c2e442c996fe7$var$hostParent = deletedFiber.stateNode, $b25c2e442c996fe7$var$hostParentIsContainer = !1);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b25c2e442c996fe7$var$hostParent;
            prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$hostParent = null;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b25c2e442c996fe7$var$hostParent) {
                if ($b25c2e442c996fe7$var$hostParentIsContainer) try {
                    (9 === $b25c2e442c996fe7$var$hostParent.nodeType ? $b25c2e442c996fe7$var$hostParent.body : "HTML" === $b25c2e442c996fe7$var$hostParent.nodeName ? $b25c2e442c996fe7$var$hostParent.ownerDocument.body : $b25c2e442c996fe7$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b25c2e442c996fe7$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b25c2e442c996fe7$var$hostParent && ($b25c2e442c996fe7$var$hostParentIsContainer ? (finishedRoot = $b25c2e442c996fe7$var$hostParent, $b25c2e442c996fe7$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot)) : $b25c2e442c996fe7$var$clearHydrationBoundary($b25c2e442c996fe7$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b25c2e442c996fe7$var$hostParent;
            prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b25c2e442c996fe7$var$hostParentIsContainer = !0;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b25c2e442c996fe7$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || ($b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = (prevHostParent = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b25c2e442c996fe7$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b25c2e442c996fe7$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b25c2e442c996fe7$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $b25c2e442c996fe7$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b25c2e442c996fe7$var$isSingletonScope(parent.type)) {
                        $b25c2e442c996fe7$var$hostParent = parent.stateNode;
                        $b25c2e442c996fe7$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b25c2e442c996fe7$var$hostParent = parent.stateNode;
                    $b25c2e442c996fe7$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b25c2e442c996fe7$var$hostParent = parent.stateNode.containerInfo;
                    $b25c2e442c996fe7$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b25c2e442c996fe7$var$hostParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(160));
        $b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b25c2e442c996fe7$var$hostParent = null;
        $b25c2e442c996fe7$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b25c2e442c996fe7$var$currentHoistableRoot = null;
function $b25c2e442c996fe7$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b25c2e442c996fe7$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b25c2e442c996fe7$var$commitHookEffectListMount(3, finishedWork), $b25c2e442c996fe7$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            flags & 64 && $b25c2e442c996fe7$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b25c2e442c996fe7$var$internalHoistableMarker] || currentResource[$b25c2e442c996fe7$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
                                        $b25c2e442c996fe7$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b25c2e442c996fe7$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b25c2e442c996fe7$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
                                $b25c2e442c996fe7$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b25c2e442c996fe7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b25c2e442c996fe7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b25c2e442c996fe7$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b25c2e442c996fe7$var$needsFormReset = !0);
            break;
        case 6:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b25c2e442c996fe7$var$tagCaches = null;
            hoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(root.containerInfo);
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$currentHoistableRoot = hoistableRoot;
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b25c2e442c996fe7$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b25c2e442c996fe7$var$needsFormReset && ($b25c2e442c996fe7$var$needsFormReset = !1, $b25c2e442c996fe7$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            $b25c2e442c996fe7$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b25c2e442c996fe7$var$globalMostRecentFallbackTime = $b25c2e442c996fe7$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b25c2e442c996fe7$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
            $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b25c2e442c996fe7$var$offscreenSubtreeIsHidden || $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(instance, !0) : $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork), $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
    }
}
function $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b25c2e442c996fe7$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b25c2e442c996fe7$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b25c2e442c996fe7$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b25c2e442c996fe7$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b25c2e442c996fe7$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b25c2e442c996fe7$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b25c2e442c996fe7$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b25c2e442c996fe7$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostMount(finishedWork);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b25c2e442c996fe7$var$releaseCache(previousCache));
}
function $b25c2e442c996fe7$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b25c2e442c996fe7$var$releaseCache(current));
}
function $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b25c2e442c996fe7$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b25c2e442c996fe7$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b25c2e442c996fe7$var$suspenseyCommitFlag = 8192;
function $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $b25c2e442c996fe7$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $b25c2e442c996fe7$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b25c2e442c996fe7$var$suspendResource(suspendedState, $b25c2e442c996fe7$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $b25c2e442c996fe7$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b25c2e442c996fe7$var$suspenseyCommitFlag, $b25c2e442c996fe7$var$suspenseyCommitFlag = 16777216, $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $b25c2e442c996fe7$var$suspenseyCommitFlag = previousHoistableRoot) : $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b25c2e442c996fe7$var$nextEffect = childToDelete;
            $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b25c2e442c996fe7$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b25c2e442c996fe7$var$nextEffect = childToDelete;
            $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b25c2e442c996fe7$var$nextEffect;){
        var fiber = $b25c2e442c996fe7$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b25c2e442c996fe7$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b25c2e442c996fe7$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b25c2e442c996fe7$var$nextEffect;){
            cache = $b25c2e442c996fe7$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b25c2e442c996fe7$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b25c2e442c996fe7$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b25c2e442c996fe7$var$nextEffect = sibling;
                break a;
            }
            $b25c2e442c996fe7$var$nextEffect = returnFiber;
        }
    }
}
var $b25c2e442c996fe7$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext).controller.signal;
    }
}, $b25c2e442c996fe7$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b25c2e442c996fe7$var$executionContext = 0, $b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgress = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0, $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = !1, $b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !1, $b25c2e442c996fe7$var$entangledRenderLanes = 0, $b25c2e442c996fe7$var$workInProgressRootExitStatus = 0, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes = 0, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes = 0, $b25c2e442c996fe7$var$workInProgressRootPingedLanes = 0, $b25c2e442c996fe7$var$workInProgressDeferredLane = 0, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = 0, $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = null, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = null, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b25c2e442c996fe7$var$globalMostRecentFallbackTime = 0, $b25c2e442c996fe7$var$globalMostRecentTransitionTime = 0, $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = Infinity, $b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = null, $b25c2e442c996fe7$var$pendingEffectsStatus = 0, $b25c2e442c996fe7$var$pendingEffectsRoot = null, $b25c2e442c996fe7$var$pendingFinishedWork = null, $b25c2e442c996fe7$var$pendingEffectsLanes = 0, $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = 0, $b25c2e442c996fe7$var$pendingPassiveTransitions = null, $b25c2e442c996fe7$var$pendingRecoverableErrors = null, $b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = null;
function $b25c2e442c996fe7$var$requestUpdateLane() {
    return 0 !== ($b25c2e442c996fe7$var$executionContext & 2) && 0 !== $b25c2e442c996fe7$var$workInProgressRootRenderLanes ? $b25c2e442c996fe7$var$workInProgressRootRenderLanes & -$b25c2e442c996fe7$var$workInProgressRootRenderLanes : null !== $b25c2e442c996fe7$var$ReactSharedInternals.T ? $b25c2e442c996fe7$var$requestTransitionLane() : $b25c2e442c996fe7$var$resolveUpdatePriority();
}
function $b25c2e442c996fe7$var$requestDeferredLane() {
    if (0 === $b25c2e442c996fe7$var$workInProgressDeferredLane) {
        if (0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912) || $b25c2e442c996fe7$var$isHydrating) {
            var lane = $b25c2e442c996fe7$var$nextTransitionDeferredLane;
            $b25c2e442c996fe7$var$nextTransitionDeferredLane <<= 1;
            0 === ($b25c2e442c996fe7$var$nextTransitionDeferredLane & 3932160) && ($b25c2e442c996fe7$var$nextTransitionDeferredLane = 262144);
            $b25c2e442c996fe7$var$workInProgressDeferredLane = lane;
        } else $b25c2e442c996fe7$var$workInProgressDeferredLane = 536870912;
    }
    lane = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $b25c2e442c996fe7$var$workInProgressDeferredLane;
}
function $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b25c2e442c996fe7$var$workInProgressRoot && (2 === $b25c2e442c996fe7$var$workInProgressSuspendedReason || 9 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b25c2e442c996fe7$var$prepareFreshStack(root, 0), $b25c2e442c996fe7$var$markRootSuspended(root, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1);
    $b25c2e442c996fe7$var$markRootUpdated$1(root, lane);
    if (0 === ($b25c2e442c996fe7$var$executionContext & 2) || root !== $b25c2e442c996fe7$var$workInProgressRoot) root === $b25c2e442c996fe7$var$workInProgressRoot && (0 === ($b25c2e442c996fe7$var$executionContext & 2) && ($b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && $b25c2e442c996fe7$var$markRootSuspended(root, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1)), $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
}
function $b25c2e442c996fe7$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b25c2e442c996fe7$var$renderRootConcurrent(root$jscomp$0, lanes) : $b25c2e442c996fe7$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b25c2e442c996fe7$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b25c2e442c996fe7$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b25c2e442c996fe7$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b25c2e442c996fe7$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b25c2e442c996fe7$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b25c2e442c996fe7$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors;
                            $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors ? $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors.push.apply($b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b25c2e442c996fe7$var$prepareFreshStack(root$jscomp$0, 0);
                $b25c2e442c996fe7$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b25c2e442c996fe7$var$markRootSuspended(shouldTimeSlice, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !$b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b25c2e442c996fe7$var$globalMostRecentFallbackTime + 300 - $b25c2e442c996fe7$var$now(), 10 < exitStatus)) {
                    $b25c2e442c996fe7$var$markRootSuspended(shouldTimeSlice, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !$b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b25c2e442c996fe7$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $b25c2e442c996fe7$var$scheduleTimeout($b25c2e442c996fe7$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, $b25c2e442c996fe7$var$workInProgressTransitions, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $b25c2e442c996fe7$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, $b25c2e442c996fe7$var$workInProgressTransitions, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $b25c2e442c996fe7$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b25c2e442c996fe7$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $b25c2e442c996fe7$var$noop$1
        };
        $b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $b25c2e442c996fe7$var$globalMostRecentFallbackTime - $b25c2e442c996fe7$var$now() : (lanes & 4194048) === lanes ? $b25c2e442c996fe7$var$globalMostRecentTransitionTime - $b25c2e442c996fe7$var$now() : 0;
        timeoutOffset = $b25c2e442c996fe7$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($b25c2e442c996fe7$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $b25c2e442c996fe7$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b25c2e442c996fe7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b25c2e442c996fe7$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b25c2e442c996fe7$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b25c2e442c996fe7$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b25c2e442c996fe7$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b25c2e442c996fe7$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b25c2e442c996fe7$var$flushSyncWork$1() {
    return 0 === ($b25c2e442c996fe7$var$executionContext & 6) ? ($b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b25c2e442c996fe7$var$resetWorkInProgressStack() {
    if (null !== $b25c2e442c996fe7$var$workInProgress) {
        if (0 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) var interruptedWork = $b25c2e442c996fe7$var$workInProgress.return;
        else interruptedWork = $b25c2e442c996fe7$var$workInProgress, $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null, $b25c2e442c996fe7$var$resetHooksOnUnwind(interruptedWork), $b25c2e442c996fe7$var$thenableState$1 = null, $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0, interruptedWork = $b25c2e442c996fe7$var$workInProgress;
        for(; null !== interruptedWork;)$b25c2e442c996fe7$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b25c2e442c996fe7$var$workInProgress = null;
    }
}
function $b25c2e442c996fe7$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b25c2e442c996fe7$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b25c2e442c996fe7$var$pendingEffectsLanes = 0;
    $b25c2e442c996fe7$var$resetWorkInProgressStack();
    $b25c2e442c996fe7$var$workInProgressRoot = root;
    $b25c2e442c996fe7$var$workInProgress = timeoutHandle = $b25c2e442c996fe7$var$createWorkInProgress(root.current, null);
    $b25c2e442c996fe7$var$workInProgressRootRenderLanes = lanes;
    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
    $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, lanes);
    $b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !1;
    $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = $b25c2e442c996fe7$var$workInProgressDeferredLane = $b25c2e442c996fe7$var$workInProgressRootPingedLanes = $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes = $b25c2e442c996fe7$var$workInProgressRootSkippedLanes = $b25c2e442c996fe7$var$workInProgressRootExitStatus = 0;
    $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = null;
    $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b25c2e442c996fe7$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b25c2e442c996fe7$var$entangledRenderLanes = lanes;
    $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b25c2e442c996fe7$var$handleThrow(root, thrownValue) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    thrownValue === $b25c2e442c996fe7$var$SuspenseException || thrownValue === $b25c2e442c996fe7$var$SuspenseActionException ? (thrownValue = $b25c2e442c996fe7$var$getSuspendedThenable(), $b25c2e442c996fe7$var$workInProgressSuspendedReason = 3) : thrownValue === $b25c2e442c996fe7$var$SuspenseyCommitException ? (thrownValue = $b25c2e442c996fe7$var$getSuspendedThenable(), $b25c2e442c996fe7$var$workInProgressSuspendedReason = 4) : $b25c2e442c996fe7$var$workInProgressSuspendedReason = thrownValue === $b25c2e442c996fe7$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b25c2e442c996fe7$var$workInProgressThrownValue = thrownValue;
    null === $b25c2e442c996fe7$var$workInProgress && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 1, $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b25c2e442c996fe7$var$shouldRemainOnPreviousScreen() {
    var handler = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 4194048) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes ? null === $b25c2e442c996fe7$var$shellBoundary ? !0 : !1 : ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 62914560) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes || 0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912) ? handler === $b25c2e442c996fe7$var$shellBoundary : !1;
}
function $b25c2e442c996fe7$var$pushDispatcher() {
    var prevDispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.H;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b25c2e442c996fe7$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b25c2e442c996fe7$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.A;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = $b25c2e442c996fe7$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible() {
    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 4;
    $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings || ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 4194048) !== $b25c2e442c996fe7$var$workInProgressRootRenderLanes && null !== $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current || ($b25c2e442c996fe7$var$workInProgressRootIsPrerendering = !0);
    0 === ($b25c2e442c996fe7$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b25c2e442c996fe7$var$workInProgressRoot || $b25c2e442c996fe7$var$markRootSuspended($b25c2e442c996fe7$var$workInProgressRoot, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1);
}
function $b25c2e442c996fe7$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
    $b25c2e442c996fe7$var$executionContext |= 2;
    var prevDispatcher = $b25c2e442c996fe7$var$pushDispatcher(), prevAsyncDispatcher = $b25c2e442c996fe7$var$pushAsyncDispatcher();
    if ($b25c2e442c996fe7$var$workInProgressRoot !== root || $b25c2e442c996fe7$var$workInProgressRootRenderLanes !== lanes) $b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b25c2e442c996fe7$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && null !== $b25c2e442c996fe7$var$workInProgress) {
            var unitOfWork = $b25c2e442c996fe7$var$workInProgress, thrownValue = $b25c2e442c996fe7$var$workInProgressThrownValue;
            switch($b25c2e442c996fe7$var$workInProgressSuspendedReason){
                case 8:
                    $b25c2e442c996fe7$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b25c2e442c996fe7$var$workInProgressSuspendedReason;
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b25c2e442c996fe7$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b25c2e442c996fe7$var$workInProgressSuspendedReason, $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b25c2e442c996fe7$var$workLoopSync();
        exitStatus = $b25c2e442c996fe7$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $b25c2e442c996fe7$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = prevDispatcher;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b25c2e442c996fe7$var$workInProgress && ($b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0, $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b25c2e442c996fe7$var$workLoopSync() {
    for(; null !== $b25c2e442c996fe7$var$workInProgress;)$b25c2e442c996fe7$var$performUnitOfWork($b25c2e442c996fe7$var$workInProgress);
}
function $b25c2e442c996fe7$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
    $b25c2e442c996fe7$var$executionContext |= 2;
    var prevDispatcher = $b25c2e442c996fe7$var$pushDispatcher(), prevAsyncDispatcher = $b25c2e442c996fe7$var$pushAsyncDispatcher();
    $b25c2e442c996fe7$var$workInProgressRoot !== root || $b25c2e442c996fe7$var$workInProgressRootRenderLanes !== lanes ? ($b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = $b25c2e442c996fe7$var$now() + 500, $b25c2e442c996fe7$var$prepareFreshStack(root, lanes)) : $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && null !== $b25c2e442c996fe7$var$workInProgress) {
            lanes = $b25c2e442c996fe7$var$workInProgress;
            var thrownValue = $b25c2e442c996fe7$var$workInProgressThrownValue;
            b: switch($b25c2e442c996fe7$var$workInProgressSuspendedReason){
                case 1:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b25c2e442c996fe7$var$isThenableResolved(thrownValue)) {
                        $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                        $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                        $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && 9 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason || $b25c2e442c996fe7$var$workInProgressRoot !== root || ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 7);
                        $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b25c2e442c996fe7$var$isThenableResolved(thrownValue) ? ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(lanes)) : ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b25c2e442c996fe7$var$workInProgress.tag){
                        case 26:
                            resource = $b25c2e442c996fe7$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b25c2e442c996fe7$var$workInProgress;
                            if (resource ? $b25c2e442c996fe7$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                                $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b25c2e442c996fe7$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b25c2e442c996fe7$var$workInProgress = returnFiber, $b25c2e442c996fe7$var$completeUnitOfWork(returnFiber)) : $b25c2e442c996fe7$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b25c2e442c996fe7$var$resetWorkInProgressStack();
                    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(462));
            }
        }
        $b25c2e442c996fe7$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $b25c2e442c996fe7$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = prevDispatcher;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
    if (null !== $b25c2e442c996fe7$var$workInProgress) return 0;
    $b25c2e442c996fe7$var$workInProgressRoot = null;
    $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0;
    $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates();
    return $b25c2e442c996fe7$var$workInProgressRootExitStatus;
}
function $b25c2e442c996fe7$var$workLoopConcurrentByScheduler() {
    for(; null !== $b25c2e442c996fe7$var$workInProgress && !$b25c2e442c996fe7$var$shouldYield();)$b25c2e442c996fe7$var$performUnitOfWork($b25c2e442c996fe7$var$workInProgress);
}
function $b25c2e442c996fe7$var$performUnitOfWork(unitOfWork) {
    var next = $b25c2e442c996fe7$var$beginWork(unitOfWork.alternate, unitOfWork, $b25c2e442c996fe7$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) : $b25c2e442c996fe7$var$workInProgress = next;
}
function $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b25c2e442c996fe7$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b25c2e442c996fe7$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b25c2e442c996fe7$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b25c2e442c996fe7$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b25c2e442c996fe7$var$resetHooksOnUnwind(next);
        default:
            $b25c2e442c996fe7$var$unwindInterruptedWork(current, next), next = $b25c2e442c996fe7$var$workInProgress = $b25c2e442c996fe7$var$resetWorkInProgress(next, $b25c2e442c996fe7$var$entangledRenderLanes), next = $b25c2e442c996fe7$var$beginWork(current, next, $b25c2e442c996fe7$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) : $b25c2e442c996fe7$var$workInProgress = next;
}
function $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$resetHooksOnUnwind(unitOfWork);
    $b25c2e442c996fe7$var$thenableState$1 = null;
    $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b25c2e442c996fe7$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b25c2e442c996fe7$var$workInProgressRootRenderLanes)) {
            $b25c2e442c996fe7$var$workInProgressRootExitStatus = 1;
            $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b25c2e442c996fe7$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b25c2e442c996fe7$var$workInProgress = returnFiber, error;
        $b25c2e442c996fe7$var$workInProgressRootExitStatus = 1;
        $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b25c2e442c996fe7$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b25c2e442c996fe7$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b25c2e442c996fe7$var$workInProgressRootIsPrerendering || 0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b25c2e442c996fe7$var$unwindUnitOfWork(unitOfWork, root);
    } else $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork);
}
function $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b25c2e442c996fe7$var$unwindUnitOfWork(completedWork, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b25c2e442c996fe7$var$completeWork(completedWork.alternate, completedWork, $b25c2e442c996fe7$var$entangledRenderLanes);
        if (null !== next) {
            $b25c2e442c996fe7$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b25c2e442c996fe7$var$workInProgress = completedWork;
            return;
        }
        $b25c2e442c996fe7$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 5);
}
function $b25c2e442c996fe7$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b25c2e442c996fe7$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b25c2e442c996fe7$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b25c2e442c996fe7$var$workInProgress = unitOfWork;
            return;
        }
        $b25c2e442c996fe7$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 6;
    $b25c2e442c996fe7$var$workInProgress = null;
}
function $b25c2e442c996fe7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b25c2e442c996fe7$var$flushPendingEffects();
    while (0 !== $b25c2e442c996fe7$var$pendingEffectsStatus);
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b25c2e442c996fe7$var$concurrentlyUpdatedLanes;
        $b25c2e442c996fe7$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b25c2e442c996fe7$var$workInProgressRoot && ($b25c2e442c996fe7$var$workInProgress = $b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0);
        $b25c2e442c996fe7$var$pendingFinishedWork = finishedWork;
        $b25c2e442c996fe7$var$pendingEffectsRoot = root;
        $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
        $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b25c2e442c996fe7$var$pendingPassiveTransitions = transitions;
        $b25c2e442c996fe7$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b25c2e442c996fe7$var$scheduleCallback$1($b25c2e442c996fe7$var$NormalPriority$1, function() {
            $b25c2e442c996fe7$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            transitions = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b25c2e442c996fe7$var$executionContext = spawnedLane, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = transitions, $b25c2e442c996fe7$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b25c2e442c996fe7$var$pendingEffectsStatus = 1;
        $b25c2e442c996fe7$var$flushMutationEffects();
        $b25c2e442c996fe7$var$flushLayoutEffects();
        $b25c2e442c996fe7$var$flushSpawnedWork();
    }
}
function $b25c2e442c996fe7$var$flushMutationEffects() {
    if (1 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b25c2e442c996fe7$var$selectionInformation, curFocusedElem = $b25c2e442c996fe7$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b25c2e442c996fe7$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b25c2e442c996fe7$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b25c2e442c996fe7$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b25c2e442c996fe7$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b25c2e442c996fe7$var$_enabled = !!$b25c2e442c996fe7$var$eventsEnabled;
                $b25c2e442c996fe7$var$selectionInformation = $b25c2e442c996fe7$var$eventsEnabled = null;
            } finally{
                $b25c2e442c996fe7$var$executionContext = prevExecutionContext, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b25c2e442c996fe7$var$pendingEffectsStatus = 2;
    }
}
function $b25c2e442c996fe7$var$flushLayoutEffects() {
    if (2 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b25c2e442c996fe7$var$executionContext = prevExecutionContext, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b25c2e442c996fe7$var$pendingEffectsStatus = 3;
    }
}
function $b25c2e442c996fe7$var$flushSpawnedWork() {
    if (4 === $b25c2e442c996fe7$var$pendingEffectsStatus || 3 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        $b25c2e442c996fe7$var$requestPaint();
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, lanes = $b25c2e442c996fe7$var$pendingEffectsLanes, recoverableErrors = $b25c2e442c996fe7$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b25c2e442c996fe7$var$pendingEffectsStatus = 5 : ($b25c2e442c996fe7$var$pendingEffectsStatus = 0, $b25c2e442c996fe7$var$pendingFinishedWork = $b25c2e442c996fe7$var$pendingEffectsRoot = null, $b25c2e442c996fe7$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b25c2e442c996fe7$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onCommitFiberRoot) try {
            $b25c2e442c996fe7$var$injectedHook.onCommitFiberRoot($b25c2e442c996fe7$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            remainingLanes = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b25c2e442c996fe7$var$ReactSharedInternals.T = finishedWork, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b25c2e442c996fe7$var$pendingEffectsLanes & 3) && $b25c2e442c996fe7$var$flushPendingEffects();
        $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $b25c2e442c996fe7$var$rootWithNestedUpdates ? $b25c2e442c996fe7$var$nestedUpdateCount++ : ($b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = root) : $b25c2e442c996fe7$var$nestedUpdateCount = 0;
        $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b25c2e442c996fe7$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b25c2e442c996fe7$var$releaseCache(remainingLanes)));
}
function $b25c2e442c996fe7$var$flushPendingEffects() {
    $b25c2e442c996fe7$var$flushMutationEffects();
    $b25c2e442c996fe7$var$flushLayoutEffects();
    $b25c2e442c996fe7$var$flushSpawnedWork();
    return $b25c2e442c996fe7$var$flushPassiveEffects();
}
function $b25c2e442c996fe7$var$flushPassiveEffects() {
    if (5 !== $b25c2e442c996fe7$var$pendingEffectsStatus) return !1;
    var root = $b25c2e442c996fe7$var$pendingEffectsRoot, remainingLanes = $b25c2e442c996fe7$var$pendingEffectsRemainingLanes;
    $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b25c2e442c996fe7$var$lanesToEventPriority($b25c2e442c996fe7$var$pendingEffectsLanes), prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
        renderPriority = $b25c2e442c996fe7$var$pendingPassiveTransitions;
        $b25c2e442c996fe7$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b25c2e442c996fe7$var$pendingEffectsRoot, lanes = $b25c2e442c996fe7$var$pendingEffectsLanes;
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        $b25c2e442c996fe7$var$pendingFinishedWork = $b25c2e442c996fe7$var$pendingEffectsRoot = null;
        $b25c2e442c996fe7$var$pendingEffectsLanes = 0;
        if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
        $b25c2e442c996fe7$var$executionContext |= 4;
        $b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b25c2e442c996fe7$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
        $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onPostCommitFiberRoot) try {
            $b25c2e442c996fe7$var$injectedHook.onPostCommitFiberRoot($b25c2e442c996fe7$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition, $b25c2e442c996fe7$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b25c2e442c996fe7$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b25c2e442c996fe7$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b25c2e442c996fe7$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b25c2e442c996fe7$var$markRootUpdated$1(rootFiber, 2), $b25c2e442c996fe7$var$ensureRootIsScheduled(rootFiber));
}
function $b25c2e442c996fe7$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed || !$b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b25c2e442c996fe7$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b25c2e442c996fe7$var$createClassErrorUpdate(2);
                instance = $b25c2e442c996fe7$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b25c2e442c996fe7$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b25c2e442c996fe7$var$markRootUpdated$1(instance, 2), $b25c2e442c996fe7$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b25c2e442c996fe7$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b25c2e442c996fe7$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b25c2e442c996fe7$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b25c2e442c996fe7$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b25c2e442c996fe7$var$workInProgressRoot === root && ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b25c2e442c996fe7$var$workInProgressRootExitStatus || 3 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 62914560) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes && 300 > $b25c2e442c996fe7$var$now() - $b25c2e442c996fe7$var$globalMostRecentFallbackTime ? 0 === ($b25c2e442c996fe7$var$executionContext & 2) && $b25c2e442c996fe7$var$prepareFreshStack(root, 0) : $b25c2e442c996fe7$var$workInProgressRootPingedLanes |= pingedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes === $b25c2e442c996fe7$var$workInProgressRootRenderLanes && ($b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = 0));
    $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
}
function $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b25c2e442c996fe7$var$claimNextRetryLane());
    boundaryFiber = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b25c2e442c996fe7$var$markRootUpdated$1(boundaryFiber, retryLane), $b25c2e442c996fe7$var$ensureRootIsScheduled(boundaryFiber));
}
function $b25c2e442c996fe7$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b25c2e442c996fe7$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b25c2e442c996fe7$var$scheduleCallback$1(priorityLevel, callback) {
    return $b25c2e442c996fe7$var$scheduleCallback$3(priorityLevel, callback);
}
var $b25c2e442c996fe7$var$firstScheduledRoot = null, $b25c2e442c996fe7$var$lastScheduledRoot = null, $b25c2e442c996fe7$var$didScheduleMicrotask = !1, $b25c2e442c996fe7$var$mightHavePendingSyncWork = !1, $b25c2e442c996fe7$var$isFlushingWork = !1, $b25c2e442c996fe7$var$currentEventTransitionLane = 0;
function $b25c2e442c996fe7$var$ensureRootIsScheduled(root) {
    root !== $b25c2e442c996fe7$var$lastScheduledRoot && null === root.next && (null === $b25c2e442c996fe7$var$lastScheduledRoot ? $b25c2e442c996fe7$var$firstScheduledRoot = $b25c2e442c996fe7$var$lastScheduledRoot = root : $b25c2e442c996fe7$var$lastScheduledRoot = $b25c2e442c996fe7$var$lastScheduledRoot.next = root);
    $b25c2e442c996fe7$var$mightHavePendingSyncWork = !0;
    $b25c2e442c996fe7$var$didScheduleMicrotask || ($b25c2e442c996fe7$var$didScheduleMicrotask = !0, $b25c2e442c996fe7$var$scheduleImmediateRootScheduleTask());
}
function $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b25c2e442c996fe7$var$isFlushingWork && $b25c2e442c996fe7$var$mightHavePendingSyncWork) {
        $b25c2e442c996fe7$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $b25c2e442c996fe7$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b25c2e442c996fe7$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b25c2e442c996fe7$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b25c2e442c996fe7$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b25c2e442c996fe7$var$getNextLanes(root$170, root$170 === $b25c2e442c996fe7$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b25c2e442c996fe7$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $b25c2e442c996fe7$var$isFlushingWork = !1;
    }
}
function $b25c2e442c996fe7$var$processRootScheduleInImmediateTask() {
    $b25c2e442c996fe7$var$processRootScheduleInMicrotask();
}
function $b25c2e442c996fe7$var$processRootScheduleInMicrotask() {
    $b25c2e442c996fe7$var$mightHavePendingSyncWork = $b25c2e442c996fe7$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b25c2e442c996fe7$var$currentEventTransitionLane && $b25c2e442c996fe7$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b25c2e442c996fe7$var$currentEventTransitionLane);
    for(var currentTime = $b25c2e442c996fe7$var$now(), prev = null, root = $b25c2e442c996fe7$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b25c2e442c996fe7$var$firstScheduledRoot = next : prev.next = next, null === next && ($b25c2e442c996fe7$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b25c2e442c996fe7$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $b25c2e442c996fe7$var$pendingEffectsStatus && 5 !== $b25c2e442c996fe7$var$pendingEffectsStatus || $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $b25c2e442c996fe7$var$currentEventTransitionLane && ($b25c2e442c996fe7$var$currentEventTransitionLane = 0);
}
function $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b25c2e442c996fe7$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b25c2e442c996fe7$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b25c2e442c996fe7$var$workInProgressRoot;
    suspendedLanes = $b25c2e442c996fe7$var$workInProgressRootRenderLanes;
    suspendedLanes = $b25c2e442c996fe7$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b25c2e442c996fe7$var$workInProgressSuspendedReason || 9 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes);
        switch($b25c2e442c996fe7$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b25c2e442c996fe7$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b25c2e442c996fe7$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b25c2e442c996fe7$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b25c2e442c996fe7$var$NormalPriority$1;
        }
        pingedLanes = $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b25c2e442c996fe7$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b25c2e442c996fe7$var$pendingEffectsStatus && 5 !== $b25c2e442c996fe7$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b25c2e442c996fe7$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b25c2e442c996fe7$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b25c2e442c996fe7$var$getNextLanes(root, root === $b25c2e442c996fe7$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b25c2e442c996fe7$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, $b25c2e442c996fe7$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b25c2e442c996fe7$var$performSyncWorkOnRoot(root, lanes) {
    if ($b25c2e442c996fe7$var$flushPendingEffects()) return null;
    $b25c2e442c996fe7$var$performWorkOnRoot(root, lanes, !0);
}
function $b25c2e442c996fe7$var$scheduleImmediateRootScheduleTask() {
    $b25c2e442c996fe7$var$scheduleMicrotask(function() {
        0 !== ($b25c2e442c996fe7$var$executionContext & 6) ? $b25c2e442c996fe7$var$scheduleCallback$3($b25c2e442c996fe7$var$ImmediatePriority, $b25c2e442c996fe7$var$processRootScheduleInImmediateTask) : $b25c2e442c996fe7$var$processRootScheduleInMicrotask();
    });
}
function $b25c2e442c996fe7$var$requestTransitionLane() {
    if (0 === $b25c2e442c996fe7$var$currentEventTransitionLane) {
        var actionScopeLane = $b25c2e442c996fe7$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $b25c2e442c996fe7$var$nextTransitionUpdateLane, $b25c2e442c996fe7$var$nextTransitionUpdateLane <<= 1, 0 === ($b25c2e442c996fe7$var$nextTransitionUpdateLane & 261888) && ($b25c2e442c996fe7$var$nextTransitionUpdateLane = 256));
        $b25c2e442c996fe7$var$currentEventTransitionLane = actionScopeLane;
    }
    return $b25c2e442c996fe7$var$currentEventTransitionLane;
}
function $b25c2e442c996fe7$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b25c2e442c996fe7$var$sanitizeURL("" + actionProp);
}
function $b25c2e442c996fe7$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b25c2e442c996fe7$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b25c2e442c996fe7$var$coerceFormActionProp((nativeEventTarget[$b25c2e442c996fe7$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b25c2e442c996fe7$var$internalPropsKey] || null) ? $b25c2e442c996fe7$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b25c2e442c996fe7$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b25c2e442c996fe7$var$currentEventTransitionLane) {
                                var formData = submitter ? $b25c2e442c996fe7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b25c2e442c996fe7$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b25c2e442c996fe7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b25c2e442c996fe7$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b25c2e442c996fe7$var$i$jscomp$inline_1577 = 0; $b25c2e442c996fe7$var$i$jscomp$inline_1577 < $b25c2e442c996fe7$var$simpleEventPluginEvents.length; $b25c2e442c996fe7$var$i$jscomp$inline_1577++){
    var $b25c2e442c996fe7$var$eventName$jscomp$inline_1578 = $b25c2e442c996fe7$var$simpleEventPluginEvents[$b25c2e442c996fe7$var$i$jscomp$inline_1577], $b25c2e442c996fe7$var$domEventName$jscomp$inline_1579 = $b25c2e442c996fe7$var$eventName$jscomp$inline_1578.toLowerCase(), $b25c2e442c996fe7$var$capitalizedEvent$jscomp$inline_1580 = $b25c2e442c996fe7$var$eventName$jscomp$inline_1578[0].toUpperCase() + $b25c2e442c996fe7$var$eventName$jscomp$inline_1578.slice(1);
    $b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$domEventName$jscomp$inline_1579, "on" + $b25c2e442c996fe7$var$capitalizedEvent$jscomp$inline_1580);
}
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_END, "onAnimationEnd");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_ITERATION, "onAnimationIteration");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_START, "onAnimationStart");
$b25c2e442c996fe7$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b25c2e442c996fe7$var$registerSimpleEvent("focusin", "onFocus");
$b25c2e442c996fe7$var$registerSimpleEvent("focusout", "onBlur");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_RUN, "onTransitionRun");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_START, "onTransitionStart");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_CANCEL, "onTransitionCancel");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_END, "onTransitionEnd");
$b25c2e442c996fe7$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b25c2e442c996fe7$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b25c2e442c996fe7$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b25c2e442c996fe7$var$mediaEventTypes));
function $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b25c2e442c996fe7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b25c2e442c996fe7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b25c2e442c996fe7$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b25c2e442c996fe7$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b25c2e442c996fe7$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b25c2e442c996fe7$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b25c2e442c996fe7$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b25c2e442c996fe7$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b25c2e442c996fe7$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b25c2e442c996fe7$var$listeningMarker]) {
        rootContainerElement[$b25c2e442c996fe7$var$listeningMarker] = !0;
        $b25c2e442c996fe7$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b25c2e442c996fe7$var$nonDelegatedEvents.has(domEventName) || $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b25c2e442c996fe7$var$listeningMarker] || (ownerDocument[$b25c2e442c996fe7$var$listeningMarker] = !0, $b25c2e442c996fe7$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b25c2e442c996fe7$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b25c2e442c996fe7$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b25c2e442c996fe7$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b25c2e442c996fe7$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b25c2e442c996fe7$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b25c2e442c996fe7$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b25c2e442c996fe7$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b25c2e442c996fe7$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b25c2e442c996fe7$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b25c2e442c996fe7$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b25c2e442c996fe7$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticTouchEvent;
                        break;
                    case $b25c2e442c996fe7$var$ANIMATION_END:
                    case $b25c2e442c996fe7$var$ANIMATION_ITERATION:
                    case $b25c2e442c996fe7$var$ANIMATION_START:
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticAnimationEvent;
                        break;
                    case $b25c2e442c996fe7$var$TRANSITION_END:
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b25c2e442c996fe7$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b25c2e442c996fe7$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b25c2e442c996fe7$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b25c2e442c996fe7$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b25c2e442c996fe7$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b25c2e442c996fe7$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b25c2e442c996fe7$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b25c2e442c996fe7$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b25c2e442c996fe7$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b25c2e442c996fe7$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b25c2e442c996fe7$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b25c2e442c996fe7$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $b25c2e442c996fe7$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b25c2e442c996fe7$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForChangeEvent;
                else if ($b25c2e442c996fe7$var$isTextInputElement(reactName)) {
                    if ($b25c2e442c996fe7$var$isInputEventSupported) getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b25c2e442c996fe7$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b25c2e442c996fe7$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b25c2e442c996fe7$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b25c2e442c996fe7$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b25c2e442c996fe7$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b25c2e442c996fe7$var$activeElement = handleEventFunc, $b25c2e442c996fe7$var$activeElementInst = targetInst, $b25c2e442c996fe7$var$lastSelection = null;
                    break;
                case "focusout":
                    $b25c2e442c996fe7$var$lastSelection = $b25c2e442c996fe7$var$activeElementInst = $b25c2e442c996fe7$var$activeElement = null;
                    break;
                case "mousedown":
                    $b25c2e442c996fe7$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b25c2e442c996fe7$var$mouseDown = !1;
                    $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b25c2e442c996fe7$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b25c2e442c996fe7$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b25c2e442c996fe7$var$isComposing ? $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b25c2e442c996fe7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b25c2e442c996fe7$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b25c2e442c996fe7$var$isComposing && (fallbackData = $b25c2e442c996fe7$var$getData()) : ($b25c2e442c996fe7$var$root = nativeEventTarget, $b25c2e442c996fe7$var$startText = "value" in $b25c2e442c996fe7$var$root ? $b25c2e442c996fe7$var$root.value : $b25c2e442c996fe7$var$root.textContent, $b25c2e442c996fe7$var$isComposing = !0)), handleEventFunc = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b25c2e442c996fe7$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b25c2e442c996fe7$var$canUseTextInputEvent ? $b25c2e442c996fe7$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b25c2e442c996fe7$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b25c2e442c996fe7$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b25c2e442c996fe7$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b25c2e442c996fe7$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b25c2e442c996fe7$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b25c2e442c996fe7$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b25c2e442c996fe7$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b25c2e442c996fe7$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b25c2e442c996fe7$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b25c2e442c996fe7$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b25c2e442c996fe7$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b25c2e442c996fe7$var$getListener(target, registrationName), null != stateNode && listeners.push($b25c2e442c996fe7$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b25c2e442c996fe7$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b25c2e442c996fe7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b25c2e442c996fe7$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b25c2e442c996fe7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b25c2e442c996fe7$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b25c2e442c996fe7$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b25c2e442c996fe7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b25c2e442c996fe7$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b25c2e442c996fe7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b25c2e442c996fe7$var$setProp(domElement, tag, "name", props.name, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b25c2e442c996fe7$var$setProp(domElement, tag, "encType", props.encType, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "method", props.method, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b25c2e442c996fe7$var$noop$1);
            break;
        case "onScroll":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            $b25c2e442c996fe7$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b25c2e442c996fe7$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b25c2e442c996fe7$var$aliases.get(key) || key, $b25c2e442c996fe7$var$setValueForAttribute(domElement, key, value);
    }
}
function $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b25c2e442c996fe7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b25c2e442c996fe7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b25c2e442c996fe7$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b25c2e442c996fe7$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b25c2e442c996fe7$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b25c2e442c996fe7$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b25c2e442c996fe7$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b25c2e442c996fe7$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                    default:
                        $b25c2e442c996fe7$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b25c2e442c996fe7$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b25c2e442c996fe7$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b25c2e442c996fe7$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $b25c2e442c996fe7$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b25c2e442c996fe7$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b25c2e442c996fe7$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b25c2e442c996fe7$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("cancel", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b25c2e442c996fe7$var$mediaEventTypes.length; hasSrc++)$b25c2e442c996fe7$var$listenToNonDelegatedEvent($b25c2e442c996fe7$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement), $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b25c2e442c996fe7$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b25c2e442c996fe7$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b25c2e442c996fe7$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b25c2e442c996fe7$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $b25c2e442c996fe7$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b25c2e442c996fe7$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b25c2e442c996fe7$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, tag, !0) : $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b25c2e442c996fe7$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b25c2e442c996fe7$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($b25c2e442c996fe7$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $b25c2e442c996fe7$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $b25c2e442c996fe7$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $b25c2e442c996fe7$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $b25c2e442c996fe7$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $b25c2e442c996fe7$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $b25c2e442c996fe7$var$eventsEnabled = null, $b25c2e442c996fe7$var$selectionInformation = null;
function $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b25c2e442c996fe7$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b25c2e442c996fe7$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b25c2e442c996fe7$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b25c2e442c996fe7$var$currentPopstateTransitionEvent = null;
function $b25c2e442c996fe7$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b25c2e442c996fe7$var$currentPopstateTransitionEvent) return !1;
        $b25c2e442c996fe7$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b25c2e442c996fe7$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b25c2e442c996fe7$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b25c2e442c996fe7$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b25c2e442c996fe7$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b25c2e442c996fe7$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b25c2e442c996fe7$var$localPromise ? function(callback) {
    return $b25c2e442c996fe7$var$localPromise.resolve(null).then(callback).catch($b25c2e442c996fe7$var$handleErrorInNextTick);
} : $b25c2e442c996fe7$var$scheduleTimeout;
function $b25c2e442c996fe7$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b25c2e442c996fe7$var$isSingletonScope(type) {
    return "head" === type;
}
function $b25c2e442c996fe7$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b25c2e442c996fe7$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $b25c2e442c996fe7$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $b25c2e442c996fe7$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$b25c2e442c996fe7$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $b25c2e442c996fe7$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $b25c2e442c996fe7$var$retryIfBlockedOn(hydrationInstance);
}
function $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $b25c2e442c996fe7$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b25c2e442c996fe7$var$clearContainerSparingly(node);
                $b25c2e442c996fe7$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b25c2e442c996fe7$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b25c2e442c996fe7$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b25c2e442c996fe7$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b25c2e442c996fe7$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b25c2e442c996fe7$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $b25c2e442c996fe7$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $b25c2e442c996fe7$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b25c2e442c996fe7$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = null;
function $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $b25c2e442c996fe7$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $b25c2e442c996fe7$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b25c2e442c996fe7$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(451));
    }
}
function $b25c2e442c996fe7$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b25c2e442c996fe7$var$detachDeletedInstance(instance);
}
var $b25c2e442c996fe7$var$preloadPropsMap = new Map(), $b25c2e442c996fe7$var$preconnectsSet = new Set();
function $b25c2e442c996fe7$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b25c2e442c996fe7$var$previousDispatcher = $b25c2e442c996fe7$var$ReactDOMSharedInternals.d;
$b25c2e442c996fe7$var$ReactDOMSharedInternals.d = {
    f: $b25c2e442c996fe7$var$flushSyncWork,
    r: $b25c2e442c996fe7$var$requestFormReset,
    D: $b25c2e442c996fe7$var$prefetchDNS,
    C: $b25c2e442c996fe7$var$preconnect,
    L: $b25c2e442c996fe7$var$preload,
    m: $b25c2e442c996fe7$var$preloadModule,
    X: $b25c2e442c996fe7$var$preinitScript,
    S: $b25c2e442c996fe7$var$preinitStyle,
    M: $b25c2e442c996fe7$var$preinitModuleScript
};
function $b25c2e442c996fe7$var$flushSyncWork() {
    var previousWasRendering = $b25c2e442c996fe7$var$previousDispatcher.f(), wasRendering = $b25c2e442c996fe7$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b25c2e442c996fe7$var$requestFormReset(form) {
    var formInst = $b25c2e442c996fe7$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b25c2e442c996fe7$var$requestFormReset$1(formInst) : $b25c2e442c996fe7$var$previousDispatcher.r(form);
}
var $b25c2e442c996fe7$var$globalDocument = "undefined" === typeof document ? null : document;
function $b25c2e442c996fe7$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b25c2e442c996fe7$var$preconnectsSet.has(limitedEscapedHref) || ($b25c2e442c996fe7$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b25c2e442c996fe7$var$setInitialProperties(href, "link", rel), $b25c2e442c996fe7$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b25c2e442c996fe7$var$prefetchDNS(href) {
    $b25c2e442c996fe7$var$previousDispatcher.D(href);
    $b25c2e442c996fe7$var$preconnectAs("dns-prefetch", href, null);
}
function $b25c2e442c996fe7$var$preconnect(href, crossOrigin) {
    $b25c2e442c996fe7$var$previousDispatcher.C(href, crossOrigin);
    $b25c2e442c996fe7$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b25c2e442c996fe7$var$preload(href, as, options) {
    $b25c2e442c996fe7$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b25c2e442c996fe7$var$getStyleKey(href);
                break;
            case "script":
                key = $b25c2e442c996fe7$var$getScriptKey(href);
        }
        $b25c2e442c996fe7$var$preloadPropsMap.has(key) || (href = $b25c2e442c996fe7$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b25c2e442c996fe7$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b25c2e442c996fe7$var$setInitialProperties(as, "link", href), $b25c2e442c996fe7$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b25c2e442c996fe7$var$preloadModule(href, options) {
    $b25c2e442c996fe7$var$previousDispatcher.m(href, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b25c2e442c996fe7$var$getScriptKey(href);
        }
        if (!$b25c2e442c996fe7$var$preloadPropsMap.has(key) && (href = $b25c2e442c996fe7$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b25c2e442c996fe7$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b25c2e442c996fe7$var$setInitialProperties(as, "link", href);
            $b25c2e442c996fe7$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b25c2e442c996fe7$var$preinitStyle(href, precedence, options) {
    $b25c2e442c996fe7$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b25c2e442c996fe7$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b25c2e442c996fe7$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b25c2e442c996fe7$var$markNodeAsHoistable(link);
                $b25c2e442c996fe7$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b25c2e442c996fe7$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b25c2e442c996fe7$var$preinitScript(src, options) {
    $b25c2e442c996fe7$var$previousDispatcher.X(src, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b25c2e442c996fe7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)), resource || (src = $b25c2e442c996fe7$var$assign({
            src: src,
            async: !0
        }, options), (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b25c2e442c996fe7$var$markNodeAsHoistable(resource), $b25c2e442c996fe7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b25c2e442c996fe7$var$preinitModuleScript(src, options) {
    $b25c2e442c996fe7$var$previousDispatcher.M(src, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b25c2e442c996fe7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)), resource || (src = $b25c2e442c996fe7$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b25c2e442c996fe7$var$markNodeAsHoistable(resource), $b25c2e442c996fe7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b25c2e442c996fe7$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b25c2e442c996fe7$var$rootInstanceStackCursor.current) ? $b25c2e442c996fe7$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b25c2e442c996fe7$var$getStyleKey(pendingProps.href), pendingProps = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b25c2e442c996fe7$var$getStyleKey(pendingProps.href);
                var styles$243 = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $b25c2e442c996fe7$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b25c2e442c996fe7$var$preloadPropsMap.set(type, pendingProps), styles$243 || $b25c2e442c996fe7$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b25c2e442c996fe7$var$getScriptKey(pendingProps), pendingProps = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(444, type));
    }
}
function $b25c2e442c996fe7$var$getStyleKey(href) {
    return 'href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(rawProps) {
    return $b25c2e442c996fe7$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b25c2e442c996fe7$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b25c2e442c996fe7$var$setInitialProperties(key, "link", preloadProps), $b25c2e442c996fe7$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b25c2e442c996fe7$var$getScriptKey(src) {
    return '[src="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b25c2e442c996fe7$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b25c2e442c996fe7$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b25c2e442c996fe7$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b25c2e442c996fe7$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
            $b25c2e442c996fe7$var$setInitialProperties(instance, "style", styleProps);
            $b25c2e442c996fe7$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b25c2e442c996fe7$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $b25c2e442c996fe7$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b25c2e442c996fe7$var$preloadPropsMap.get(styleProps)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b25c2e442c996fe7$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $b25c2e442c996fe7$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $b25c2e442c996fe7$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $b25c2e442c996fe7$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b25c2e442c996fe7$var$preloadPropsMap.get(instance$249)) instance = $b25c2e442c996fe7$var$assign({}, props), $b25c2e442c996fe7$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b25c2e442c996fe7$var$markNodeAsHoistable(styleProps);
            $b25c2e442c996fe7$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b25c2e442c996fe7$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b25c2e442c996fe7$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b25c2e442c996fe7$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b25c2e442c996fe7$var$tagCaches = null;
function $b25c2e442c996fe7$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b25c2e442c996fe7$var$tagCaches) {
        var cache = new Map();
        var caches = $b25c2e442c996fe7$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b25c2e442c996fe7$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b25c2e442c996fe7$var$internalHoistableMarker] || node[$b25c2e442c996fe7$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b25c2e442c996fe7$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $b25c2e442c996fe7$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b25c2e442c996fe7$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b25c2e442c996fe7$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(props);
            (key = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b25c2e442c996fe7$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b25c2e442c996fe7$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $b25c2e442c996fe7$var$estimatedBytesWithinLimit = 0;
function $b25c2e442c996fe7$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $b25c2e442c996fe7$var$estimatedBytesWithinLimit && ($b25c2e442c996fe7$var$estimatedBytesWithinLimit = 62500 * $b25c2e442c996fe7$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $b25c2e442c996fe7$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $b25c2e442c996fe7$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $b25c2e442c996fe7$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b25c2e442c996fe7$var$precedencesByRoot = null;
function $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b25c2e442c996fe7$var$precedencesByRoot = new Map(), resources.forEach($b25c2e442c996fe7$var$insertStylesheetIntoRoot, state), $b25c2e442c996fe7$var$precedencesByRoot = null, $b25c2e442c996fe7$var$onUnsuspend.call(state));
}
function $b25c2e442c996fe7$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b25c2e442c996fe7$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b25c2e442c996fe7$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b25c2e442c996fe7$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b25c2e442c996fe7$var$HostTransitionContext = {
    $$typeof: $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b25c2e442c996fe7$var$sharedNotPendingObject,
    _currentValue2: $b25c2e442c996fe7$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b25c2e442c996fe7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b25c2e442c996fe7$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b25c2e442c996fe7$var$createLaneMap(0);
    this.hiddenUpdates = $b25c2e442c996fe7$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b25c2e442c996fe7$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $b25c2e442c996fe7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b25c2e442c996fe7$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b25c2e442c996fe7$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b25c2e442c996fe7$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b25c2e442c996fe7$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b25c2e442c996fe7$var$emptyContextObject;
    parentComponent = $b25c2e442c996fe7$var$emptyContextObject;
    return parentComponent;
}
function $b25c2e442c996fe7$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b25c2e442c996fe7$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b25c2e442c996fe7$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b25c2e442c996fe7$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b25c2e442c996fe7$var$entangleTransitions(element, rootFiber, lane));
}
function $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane);
}
function $b25c2e442c996fe7$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $b25c2e442c996fe7$var$requestUpdateLane();
        lane = $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(lane);
        var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, lane);
        $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $b25c2e442c996fe7$var$_enabled = !0;
function $b25c2e442c996fe7$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T;
    $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2, $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T;
    $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 8, $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b25c2e442c996fe7$var$_enabled) {
        var blockedOn = $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b25c2e442c996fe7$var$return_targetInst, targetContainer), $b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b25c2e442c996fe7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b25c2e442c996fe7$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b25c2e442c996fe7$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b25c2e442c996fe7$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b25c2e442c996fe7$var$ensureRootIsScheduled(fiber);
                                0 === ($b25c2e442c996fe7$var$executionContext & 6) && ($b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = $b25c2e442c996fe7$var$now() + 500, $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 2), $b25c2e442c996fe7$var$flushSyncWork$1(), $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b25c2e442c996fe7$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b25c2e442c996fe7$var$getEventTarget(nativeEvent);
    return $b25c2e442c996fe7$var$findInstanceBlockingTarget(nativeEvent);
}
var $b25c2e442c996fe7$var$return_targetInst = null;
function $b25c2e442c996fe7$var$findInstanceBlockingTarget(targetNode) {
    $b25c2e442c996fe7$var$return_targetInst = null;
    targetNode = $b25c2e442c996fe7$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b25c2e442c996fe7$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $b25c2e442c996fe7$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b25c2e442c996fe7$var$return_targetInst = targetNode;
    return null;
}
function $b25c2e442c996fe7$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b25c2e442c996fe7$var$getCurrentPriorityLevel()){
                case $b25c2e442c996fe7$var$ImmediatePriority:
                    return 2;
                case $b25c2e442c996fe7$var$UserBlockingPriority:
                    return 8;
                case $b25c2e442c996fe7$var$NormalPriority$1:
                case $b25c2e442c996fe7$var$LowPriority:
                    return 32;
                case $b25c2e442c996fe7$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b25c2e442c996fe7$var$hasScheduledReplayAttempt = !1, $b25c2e442c996fe7$var$queuedFocus = null, $b25c2e442c996fe7$var$queuedDrag = null, $b25c2e442c996fe7$var$queuedMouse = null, $b25c2e442c996fe7$var$queuedPointers = new Map(), $b25c2e442c996fe7$var$queuedPointerCaptures = new Map(), $b25c2e442c996fe7$var$queuedExplicitHydrationTargets = [], $b25c2e442c996fe7$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b25c2e442c996fe7$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b25c2e442c996fe7$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b25c2e442c996fe7$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b25c2e442c996fe7$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b25c2e442c996fe7$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b25c2e442c996fe7$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b25c2e442c996fe7$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b25c2e442c996fe7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b25c2e442c996fe7$var$queuedFocus = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b25c2e442c996fe7$var$queuedDrag = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b25c2e442c996fe7$var$queuedMouse = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b25c2e442c996fe7$var$queuedPointers.set(pointerId, $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b25c2e442c996fe7$var$queuedPointerCaptures.set(pointerId, $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b25c2e442c996fe7$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b25c2e442c996fe7$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b25c2e442c996fe7$var$runWithPriority(queuedTarget.priority, function() {
                        $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $b25c2e442c996fe7$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b25c2e442c996fe7$var$runWithPriority(queuedTarget.priority, function() {
                        $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b25c2e442c996fe7$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b25c2e442c996fe7$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b25c2e442c996fe7$var$currentReplayingEvent = null;
        } else return targetContainers = $b25c2e442c996fe7$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b25c2e442c996fe7$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b25c2e442c996fe7$var$replayUnblockedEvents() {
    $b25c2e442c996fe7$var$hasScheduledReplayAttempt = !1;
    null !== $b25c2e442c996fe7$var$queuedFocus && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedFocus) && ($b25c2e442c996fe7$var$queuedFocus = null);
    null !== $b25c2e442c996fe7$var$queuedDrag && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedDrag) && ($b25c2e442c996fe7$var$queuedDrag = null);
    null !== $b25c2e442c996fe7$var$queuedMouse && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedMouse) && ($b25c2e442c996fe7$var$queuedMouse = null);
    $b25c2e442c996fe7$var$queuedPointers.forEach($b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap);
    $b25c2e442c996fe7$var$queuedPointerCaptures.forEach($b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap);
}
function $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b25c2e442c996fe7$var$hasScheduledReplayAttempt || ($b25c2e442c996fe7$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$replayUnblockedEvents)));
}
var $b25c2e442c996fe7$var$lastScheduledReplayQueue = null;
function $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b25c2e442c996fe7$var$lastScheduledReplayQueue !== formReplayingQueue && ($b25c2e442c996fe7$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $b25c2e442c996fe7$var$lastScheduledReplayQueue === formReplayingQueue && ($b25c2e442c996fe7$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b25c2e442c996fe7$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b25c2e442c996fe7$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b25c2e442c996fe7$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b25c2e442c996fe7$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b25c2e442c996fe7$var$queuedFocus && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedFocus, unblocked);
    null !== $b25c2e442c996fe7$var$queuedDrag && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedDrag, unblocked);
    null !== $b25c2e442c996fe7$var$queuedMouse && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedMouse, unblocked);
    $b25c2e442c996fe7$var$queuedPointers.forEach(unblock);
    $b25c2e442c996fe7$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length && (i = $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b25c2e442c996fe7$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b25c2e442c996fe7$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b25c2e442c996fe7$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b25c2e442c996fe7$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $b25c2e442c996fe7$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.render = $b25c2e442c996fe7$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b25c2e442c996fe7$var$requestUpdateLane();
    $b25c2e442c996fe7$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.unmount = $b25c2e442c996fe7$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b25c2e442c996fe7$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b25c2e442c996fe7$var$flushSyncWork$1();
        container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = null;
    }
};
function $b25c2e442c996fe7$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b25c2e442c996fe7$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b25c2e442c996fe7$var$attemptExplicitHydrationTarget(target);
    }
};
var $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $2WGWz.version;
if ("19.2.4" !== $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(527, $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$b25c2e442c996fe7$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b25c2e442c996fe7$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b25c2e442c996fe7$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b25c2e442c996fe7$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b25c2e442c996fe7$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b25c2e442c996fe7$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b25c2e442c996fe7$var$hook$jscomp$inline_2348.isDisabled && $b25c2e442c996fe7$var$hook$jscomp$inline_2348.supportsFiber) try {
        $b25c2e442c996fe7$var$rendererID = $b25c2e442c996fe7$var$hook$jscomp$inline_2348.inject($b25c2e442c996fe7$var$internals$jscomp$inline_2347), $b25c2e442c996fe7$var$injectedHook = $b25c2e442c996fe7$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$b25c2e442c996fe7$export$882461b6382ed46c = function(container, options) {
    if (!$b25c2e442c996fe7$var$isValidContainer(container)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b25c2e442c996fe7$var$defaultOnUncaughtError, onCaughtError = $b25c2e442c996fe7$var$defaultOnCaughtError, onRecoverableError = $b25c2e442c996fe7$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $b25c2e442c996fe7$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator);
    container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = options.current;
    $b25c2e442c996fe7$var$listenToAllSupportedEvents(container);
    return new $b25c2e442c996fe7$var$ReactDOMRoot(options);
};
$b25c2e442c996fe7$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b25c2e442c996fe7$var$isValidContainer(container)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b25c2e442c996fe7$var$defaultOnUncaughtError, onCaughtError = $b25c2e442c996fe7$var$defaultOnCaughtError, onRecoverableError = $b25c2e442c996fe7$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b25c2e442c996fe7$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $b25c2e442c996fe7$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b25c2e442c996fe7$var$requestUpdateLane();
    isStrictMode = $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b25c2e442c996fe7$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b25c2e442c996fe7$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b25c2e442c996fe7$var$markRootUpdated$1(initialChildren, options);
    $b25c2e442c996fe7$var$ensureRootIsScheduled(initialChildren);
    container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = initialChildren.current;
    $b25c2e442c996fe7$var$listenToAllSupportedEvents(container);
    return new $b25c2e442c996fe7$var$ReactDOMHydrationRoot(initialChildren);
};
$b25c2e442c996fe7$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("2WGWz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Q9Iw"));

});
parcelRegister("9Q9Iw", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72a081fca2fa8551$export$9c16c1426311996d, (v) => $72a081fca2fa8551$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72a081fca2fa8551$export$dca3b0875bd9a954, (v) => $72a081fca2fa8551$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72a081fca2fa8551$export$16fa2f45be04daa8, (v) => $72a081fca2fa8551$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72a081fca2fa8551$export$ffb0004e005737fa, (v) => $72a081fca2fa8551$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72a081fca2fa8551$export$e2c29f18771995cb, (v) => $72a081fca2fa8551$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72a081fca2fa8551$export$221d75b3f55bb0bd, (v) => $72a081fca2fa8551$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72a081fca2fa8551$export$5f8d39834fd61797, (v) => $72a081fca2fa8551$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72a081fca2fa8551$export$74bf444e3cd11ea5, (v) => $72a081fca2fa8551$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72a081fca2fa8551$export$1ced07cd6b1985ce, (v) => $72a081fca2fa8551$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72a081fca2fa8551$export$abd8e32b826d7ea7, (v) => $72a081fca2fa8551$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72a081fca2fa8551$export$69a3209f1a06c04d, (v) => $72a081fca2fa8551$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72a081fca2fa8551$export$8c538325882c7eec, (v) => $72a081fca2fa8551$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72a081fca2fa8551$export$e530037191fcd5d7, (v) => $72a081fca2fa8551$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72a081fca2fa8551$export$fd42f52fd3ae1109, (v) => $72a081fca2fa8551$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72a081fca2fa8551$export$c8a8987d4410bf2d, (v) => $72a081fca2fa8551$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72a081fca2fa8551$export$7d1e3a5e95ceca43, (v) => $72a081fca2fa8551$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72a081fca2fa8551$export$257a8862b851cb5b, (v) => $72a081fca2fa8551$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72a081fca2fa8551$export$a8257692ac88316c, (v) => $72a081fca2fa8551$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72a081fca2fa8551$export$488013bae63b21da, (v) => $72a081fca2fa8551$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72a081fca2fa8551$export$7c73462e0d25e514, (v) => $72a081fca2fa8551$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72a081fca2fa8551$export$7568632d0d33d16d, (v) => $72a081fca2fa8551$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72a081fca2fa8551$export$f93f40ac0ca7e3a8, (v) => $72a081fca2fa8551$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72a081fca2fa8551$export$1f96ae73734a86cc, (v) => $72a081fca2fa8551$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72a081fca2fa8551$export$9a47ced3238df325, (v) => $72a081fca2fa8551$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72a081fca2fa8551$export$35808ee640e87ca7, (v) => $72a081fca2fa8551$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72a081fca2fa8551$export$fae74005e78b1a27, (v) => $72a081fca2fa8551$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72a081fca2fa8551$export$dc8fbce3eb94dc1e, (v) => $72a081fca2fa8551$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72a081fca2fa8551$export$6a7bc4e911dc01cf, (v) => $72a081fca2fa8551$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72a081fca2fa8551$export$6d9c69b0de29b591, (v) => $72a081fca2fa8551$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72a081fca2fa8551$export$7f54fc3180508a52, (v) => $72a081fca2fa8551$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72a081fca2fa8551$export$f680877a34711e37, (v) => $72a081fca2fa8551$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72a081fca2fa8551$export$d5a552a76deda3c2, (v) => $72a081fca2fa8551$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72a081fca2fa8551$export$aaabe4eda9ed9969, (v) => $72a081fca2fa8551$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72a081fca2fa8551$export$e5c5a5f917a5871c, (v) => $72a081fca2fa8551$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72a081fca2fa8551$export$1538c33de8887b59, (v) => $72a081fca2fa8551$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72a081fca2fa8551$export$fca7f784ae7a249a, (v) => $72a081fca2fa8551$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72a081fca2fa8551$export$13e3392192263954, (v) => $72a081fca2fa8551$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72a081fca2fa8551$export$b8f5890fc79d6aca, (v) => $72a081fca2fa8551$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72a081fca2fa8551$export$60241385465d0a34, (v) => $72a081fca2fa8551$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72a081fca2fa8551$export$306c0aa65ff9ec16, (v) => $72a081fca2fa8551$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72a081fca2fa8551$export$7b286972b8d8ccbf, (v) => $72a081fca2fa8551$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72a081fca2fa8551$export$83d89fbfd8236492, (v) => $72a081fca2fa8551$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72a081fca2fa8551$export$9c16c1426311996d;
var $72a081fca2fa8551$export$dca3b0875bd9a954;
var $72a081fca2fa8551$export$16fa2f45be04daa8;
var $72a081fca2fa8551$export$ffb0004e005737fa;
var $72a081fca2fa8551$export$e2c29f18771995cb;
var $72a081fca2fa8551$export$221d75b3f55bb0bd;
var $72a081fca2fa8551$export$5f8d39834fd61797;
var $72a081fca2fa8551$export$74bf444e3cd11ea5;
var $72a081fca2fa8551$export$1ced07cd6b1985ce;
var $72a081fca2fa8551$export$abd8e32b826d7ea7;
var $72a081fca2fa8551$export$69a3209f1a06c04d;
var $72a081fca2fa8551$export$8c538325882c7eec;
var $72a081fca2fa8551$export$e530037191fcd5d7;
var $72a081fca2fa8551$export$fd42f52fd3ae1109;
var $72a081fca2fa8551$export$c8a8987d4410bf2d;
var $72a081fca2fa8551$export$7d1e3a5e95ceca43;
var $72a081fca2fa8551$export$257a8862b851cb5b;
var $72a081fca2fa8551$export$a8257692ac88316c;
var $72a081fca2fa8551$export$488013bae63b21da;
var $72a081fca2fa8551$export$7c73462e0d25e514;
var $72a081fca2fa8551$export$7568632d0d33d16d;
var $72a081fca2fa8551$export$f93f40ac0ca7e3a8;
var $72a081fca2fa8551$export$1f96ae73734a86cc;
var $72a081fca2fa8551$export$9a47ced3238df325;
var $72a081fca2fa8551$export$35808ee640e87ca7;
var $72a081fca2fa8551$export$fae74005e78b1a27;
var $72a081fca2fa8551$export$dc8fbce3eb94dc1e;
var $72a081fca2fa8551$export$6a7bc4e911dc01cf;
var $72a081fca2fa8551$export$6d9c69b0de29b591;
var $72a081fca2fa8551$export$7f54fc3180508a52;
var $72a081fca2fa8551$export$f680877a34711e37;
var $72a081fca2fa8551$export$d5a552a76deda3c2;
var $72a081fca2fa8551$export$aaabe4eda9ed9969;
var $72a081fca2fa8551$export$e5c5a5f917a5871c;
var $72a081fca2fa8551$export$1538c33de8887b59;
var $72a081fca2fa8551$export$fca7f784ae7a249a;
var $72a081fca2fa8551$export$13e3392192263954;
var $72a081fca2fa8551$export$b8f5890fc79d6aca;
var $72a081fca2fa8551$export$60241385465d0a34;
var $72a081fca2fa8551$export$306c0aa65ff9ec16;
var $72a081fca2fa8551$export$7b286972b8d8ccbf;
var $72a081fca2fa8551$export$83d89fbfd8236492;
"use strict";
var $72a081fca2fa8551$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72a081fca2fa8551$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72a081fca2fa8551$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72a081fca2fa8551$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72a081fca2fa8551$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72a081fca2fa8551$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72a081fca2fa8551$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72a081fca2fa8551$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72a081fca2fa8551$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72a081fca2fa8551$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72a081fca2fa8551$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72a081fca2fa8551$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72a081fca2fa8551$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72a081fca2fa8551$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72a081fca2fa8551$var$assign = Object.assign, $72a081fca2fa8551$var$emptyObject = {};
function $72a081fca2fa8551$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72a081fca2fa8551$var$emptyObject;
    this.updater = updater || $72a081fca2fa8551$var$ReactNoopUpdateQueue;
}
$72a081fca2fa8551$var$Component.prototype.isReactComponent = {};
$72a081fca2fa8551$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72a081fca2fa8551$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72a081fca2fa8551$var$ComponentDummy() {}
$72a081fca2fa8551$var$ComponentDummy.prototype = $72a081fca2fa8551$var$Component.prototype;
function $72a081fca2fa8551$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72a081fca2fa8551$var$emptyObject;
    this.updater = updater || $72a081fca2fa8551$var$ReactNoopUpdateQueue;
}
var $72a081fca2fa8551$var$pureComponentPrototype = $72a081fca2fa8551$var$PureComponent.prototype = new $72a081fca2fa8551$var$ComponentDummy();
$72a081fca2fa8551$var$pureComponentPrototype.constructor = $72a081fca2fa8551$var$PureComponent;
$72a081fca2fa8551$var$assign($72a081fca2fa8551$var$pureComponentPrototype, $72a081fca2fa8551$var$Component.prototype);
$72a081fca2fa8551$var$pureComponentPrototype.isPureReactComponent = !0;
var $72a081fca2fa8551$var$isArrayImpl = Array.isArray;
function $72a081fca2fa8551$var$noop() {}
var $72a081fca2fa8551$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72a081fca2fa8551$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72a081fca2fa8551$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72a081fca2fa8551$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72a081fca2fa8551$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72a081fca2fa8551$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72a081fca2fa8551$var$REACT_ELEMENT_TYPE;
}
function $72a081fca2fa8551$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72a081fca2fa8551$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72a081fca2fa8551$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72a081fca2fa8551$var$escape("" + element.key) : index.toString(36);
}
function $72a081fca2fa8551$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72a081fca2fa8551$var$noop, $72a081fca2fa8551$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72a081fca2fa8551$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72a081fca2fa8551$var$REACT_ELEMENT_TYPE:
                case $72a081fca2fa8551$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72a081fca2fa8551$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72a081fca2fa8551$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72a081fca2fa8551$var$getElementKey(children, 0) : nameSoFar, $72a081fca2fa8551$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72a081fca2fa8551$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72a081fca2fa8551$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72a081fca2fa8551$var$isValidElement(callback) && (callback = $72a081fca2fa8551$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72a081fca2fa8551$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72a081fca2fa8551$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72a081fca2fa8551$var$getElementKey(nameSoFar, i), invokeCallback += $72a081fca2fa8551$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72a081fca2fa8551$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72a081fca2fa8551$var$getElementKey(nameSoFar, i++), invokeCallback += $72a081fca2fa8551$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72a081fca2fa8551$var$mapIntoArray($72a081fca2fa8551$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72a081fca2fa8551$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72a081fca2fa8551$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72a081fca2fa8551$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72a081fca2fa8551$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72a081fca2fa8551$var$Children = {
    map: $72a081fca2fa8551$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72a081fca2fa8551$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72a081fca2fa8551$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72a081fca2fa8551$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72a081fca2fa8551$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72a081fca2fa8551$export$9c16c1426311996d = $72a081fca2fa8551$var$REACT_ACTIVITY_TYPE;
$72a081fca2fa8551$export$dca3b0875bd9a954 = $72a081fca2fa8551$var$Children;
$72a081fca2fa8551$export$16fa2f45be04daa8 = $72a081fca2fa8551$var$Component;
$72a081fca2fa8551$export$ffb0004e005737fa = $72a081fca2fa8551$var$REACT_FRAGMENT_TYPE;
$72a081fca2fa8551$export$e2c29f18771995cb = $72a081fca2fa8551$var$REACT_PROFILER_TYPE;
$72a081fca2fa8551$export$221d75b3f55bb0bd = $72a081fca2fa8551$var$PureComponent;
$72a081fca2fa8551$export$5f8d39834fd61797 = $72a081fca2fa8551$var$REACT_STRICT_MODE_TYPE;
$72a081fca2fa8551$export$74bf444e3cd11ea5 = $72a081fca2fa8551$var$REACT_SUSPENSE_TYPE;
$72a081fca2fa8551$export$1ced07cd6b1985ce = $72a081fca2fa8551$var$ReactSharedInternals;
$72a081fca2fa8551$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72a081fca2fa8551$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72a081fca2fa8551$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72a081fca2fa8551$export$8c538325882c7eec = function() {
    return null;
};
$72a081fca2fa8551$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72a081fca2fa8551$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72a081fca2fa8551$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72a081fca2fa8551$var$ReactElement(element.type, key, props);
};
$72a081fca2fa8551$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72a081fca2fa8551$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72a081fca2fa8551$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72a081fca2fa8551$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72a081fca2fa8551$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72a081fca2fa8551$var$ReactElement(type, key, props);
};
$72a081fca2fa8551$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72a081fca2fa8551$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72a081fca2fa8551$export$a8257692ac88316c = $72a081fca2fa8551$var$isValidElement;
$72a081fca2fa8551$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72a081fca2fa8551$var$lazyInitializer
    };
};
$72a081fca2fa8551$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72a081fca2fa8551$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72a081fca2fa8551$var$ReactSharedInternals.T, currentTransition = {};
    $72a081fca2fa8551$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72a081fca2fa8551$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72a081fca2fa8551$var$noop, $72a081fca2fa8551$var$reportGlobalError);
    } catch (error) {
        $72a081fca2fa8551$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72a081fca2fa8551$var$ReactSharedInternals.T = prevTransition;
    }
};
$72a081fca2fa8551$export$f93f40ac0ca7e3a8 = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useCacheRefresh();
};
$72a081fca2fa8551$export$1f96ae73734a86cc = function(usable) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.use(usable);
};
$72a081fca2fa8551$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72a081fca2fa8551$export$35808ee640e87ca7 = function(callback, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72a081fca2fa8551$export$fae74005e78b1a27 = function(Context) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useContext(Context);
};
$72a081fca2fa8551$export$dc8fbce3eb94dc1e = function() {};
$72a081fca2fa8551$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72a081fca2fa8551$export$6d9c69b0de29b591 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72a081fca2fa8551$export$7f54fc3180508a52 = function(callback) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72a081fca2fa8551$export$f680877a34711e37 = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useId();
};
$72a081fca2fa8551$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72a081fca2fa8551$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72a081fca2fa8551$export$e5c5a5f917a5871c = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72a081fca2fa8551$export$1538c33de8887b59 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72a081fca2fa8551$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72a081fca2fa8551$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72a081fca2fa8551$export$b8f5890fc79d6aca = function(initialValue) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useRef(initialValue);
};
$72a081fca2fa8551$export$60241385465d0a34 = function(initialState) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useState(initialState);
};
$72a081fca2fa8551$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72a081fca2fa8551$export$7b286972b8d8ccbf = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useTransition();
};
$72a081fca2fa8551$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("9Np2q", function(module, exports) {
'use strict';
function $721c1cb7ddad561f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($721c1cb7ddad561f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$721c1cb7ddad561f$var$checkDCE();

module.exports = (parcelRequire("b7EY2"));

});
parcelRegister("b7EY2", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $8190206a2fec7346$export$69ce8ef3fe5cead0, (v) => $8190206a2fec7346$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $8190206a2fec7346$export$d39a5bbd09211389, (v) => $8190206a2fec7346$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $8190206a2fec7346$export$cd75ccfd720a3cd4, (v) => $8190206a2fec7346$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $8190206a2fec7346$export$a0816fa17a9e79be, (v) => $8190206a2fec7346$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $8190206a2fec7346$export$7292efcadded39f3, (v) => $8190206a2fec7346$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $8190206a2fec7346$export$da407abadb9b8f86, (v) => $8190206a2fec7346$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $8190206a2fec7346$export$314cfea32580671c, (v) => $8190206a2fec7346$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $8190206a2fec7346$export$513ccb98c53b8039, (v) => $8190206a2fec7346$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $8190206a2fec7346$export$dbca993bc2d264a, (v) => $8190206a2fec7346$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $8190206a2fec7346$export$4797a8006f0655d0, (v) => $8190206a2fec7346$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $8190206a2fec7346$export$c78a37762a8d58e1, (v) => $8190206a2fec7346$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $8190206a2fec7346$export$606f11b2eb45ecc6, (v) => $8190206a2fec7346$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $8190206a2fec7346$export$f7e8a0bf92324b1e, (v) => $8190206a2fec7346$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $8190206a2fec7346$export$83d89fbfd8236492, (v) => $8190206a2fec7346$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8190206a2fec7346$export$69ce8ef3fe5cead0;
var $8190206a2fec7346$export$d39a5bbd09211389;
var $8190206a2fec7346$export$cd75ccfd720a3cd4;
var $8190206a2fec7346$export$a0816fa17a9e79be;
var $8190206a2fec7346$export$7292efcadded39f3;
var $8190206a2fec7346$export$da407abadb9b8f86;
var $8190206a2fec7346$export$314cfea32580671c;
var $8190206a2fec7346$export$513ccb98c53b8039;
var $8190206a2fec7346$export$dbca993bc2d264a;
var $8190206a2fec7346$export$4797a8006f0655d0;
var $8190206a2fec7346$export$c78a37762a8d58e1;
var $8190206a2fec7346$export$606f11b2eb45ecc6;
var $8190206a2fec7346$export$f7e8a0bf92324b1e;
var $8190206a2fec7346$export$83d89fbfd8236492;
"use strict";

var $2WGWz = parcelRequire("2WGWz");
function $8190206a2fec7346$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8190206a2fec7346$var$noop() {}
var $8190206a2fec7346$var$Internals = {
    d: {
        f: $8190206a2fec7346$var$noop,
        r: function() {
            throw Error($8190206a2fec7346$var$formatProdErrorMessage(522));
        },
        D: $8190206a2fec7346$var$noop,
        C: $8190206a2fec7346$var$noop,
        L: $8190206a2fec7346$var$noop,
        m: $8190206a2fec7346$var$noop,
        X: $8190206a2fec7346$var$noop,
        S: $8190206a2fec7346$var$noop,
        M: $8190206a2fec7346$var$noop
    },
    p: 0,
    findDOMNode: null
}, $8190206a2fec7346$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $8190206a2fec7346$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8190206a2fec7346$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $8190206a2fec7346$var$ReactSharedInternals = $2WGWz.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $8190206a2fec7346$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$8190206a2fec7346$export$69ce8ef3fe5cead0 = $8190206a2fec7346$var$Internals;
$8190206a2fec7346$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($8190206a2fec7346$var$formatProdErrorMessage(299));
    return $8190206a2fec7346$var$createPortal$1(children, container, null, key);
};
$8190206a2fec7346$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $8190206a2fec7346$var$ReactSharedInternals.T, previousUpdatePriority = $8190206a2fec7346$var$Internals.p;
    try {
        if ($8190206a2fec7346$var$ReactSharedInternals.T = null, $8190206a2fec7346$var$Internals.p = 2, fn) return fn();
    } finally{
        $8190206a2fec7346$var$ReactSharedInternals.T = previousTransition, $8190206a2fec7346$var$Internals.p = previousUpdatePriority, $8190206a2fec7346$var$Internals.d.f();
    }
};
$8190206a2fec7346$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $8190206a2fec7346$var$Internals.d.C(href, options));
};
$8190206a2fec7346$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $8190206a2fec7346$var$Internals.d.D(href);
};
$8190206a2fec7346$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $8190206a2fec7346$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $8190206a2fec7346$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$8190206a2fec7346$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $8190206a2fec7346$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $8190206a2fec7346$var$Internals.d.M(href);
    }
};
$8190206a2fec7346$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(as, options.crossOrigin);
        $8190206a2fec7346$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$8190206a2fec7346$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $8190206a2fec7346$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $8190206a2fec7346$var$Internals.d.m(href);
    }
};
$8190206a2fec7346$export$4797a8006f0655d0 = function(form) {
    $8190206a2fec7346$var$Internals.d.r(form);
};
$8190206a2fec7346$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$8190206a2fec7346$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $8190206a2fec7346$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$8190206a2fec7346$export$f7e8a0bf92324b1e = function() {
    return $8190206a2fec7346$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$8190206a2fec7346$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


var $419c6008abfcce61$exports = {};
'use strict';

$419c6008abfcce61$exports = (parcelRequire("iw2gE"));


var $9304165f01abb7b7$exports = {};
'use strict';
function $9304165f01abb7b7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9304165f01abb7b7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9304165f01abb7b7$var$checkDCE();

$9304165f01abb7b7$exports = (parcelRequire("fjpcG"));




var $2WGWz = parcelRequire("2WGWz");

var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();


var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");

const $38c929f621e62455$var$_excluded = [
    "as",
    "disabled"
];
function $38c929f621e62455$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $38c929f621e62455$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $38c929f621e62455$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $38c929f621e62455$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $38c929f621e62455$var$Button = /*#__PURE__*/ $2WGWz.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $38c929f621e62455$var$_objectWithoutPropertiesLoose(_ref, $38c929f621e62455$var$_excluded);
    const [buttonProps, { tagName: Component }] = $38c929f621e62455$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$38c929f621e62455$var$Button.displayName = 'Button';
var $38c929f621e62455$export$2e2bcd8739ae039 = $38c929f621e62455$var$Button;



var $2WGWz = parcelRequire("2WGWz");

"use client";
const $9283c6e4393bcc4e$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $9283c6e4393bcc4e$export$ff817e17bad2e091 = 'xs';
const $9283c6e4393bcc4e$var$ThemeContext = /*#__PURE__*/ $2WGWz.createContext({
    prefixes: {},
    breakpoints: $9283c6e4393bcc4e$export$666ad80b5007f835,
    minBreakpoint: $9283c6e4393bcc4e$export$ff817e17bad2e091
});
const { Consumer: $9283c6e4393bcc4e$export$b631efc24e9d5e2f, Provider: $9283c6e4393bcc4e$var$Provider } = $9283c6e4393bcc4e$var$ThemeContext;
function $9283c6e4393bcc4e$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $9283c6e4393bcc4e$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $9283c6e4393bcc4e$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $2WGWz.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($9283c6e4393bcc4e$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $9283c6e4393bcc4e$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $2WGWz.useContext)($9283c6e4393bcc4e$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $9283c6e4393bcc4e$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $2WGWz.useContext)($9283c6e4393bcc4e$var$ThemeContext);
    return breakpoints;
}
function $9283c6e4393bcc4e$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $2WGWz.useContext)($9283c6e4393bcc4e$var$ThemeContext);
    return minBreakpoint;
}
function $9283c6e4393bcc4e$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $2WGWz.useContext)($9283c6e4393bcc4e$var$ThemeContext);
    return dir === 'rtl';
}
function $9283c6e4393bcc4e$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $2WGWz.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $9283c6e4393bcc4e$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $9283c6e4393bcc4e$export$2e2bcd8739ae039 = $9283c6e4393bcc4e$var$ThemeProvider;



"use client";
const $8fef066443ddfb90$var$Button = /*#__PURE__*/ $2WGWz.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $38c929f621e62455$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$8fef066443ddfb90$var$Button.displayName = 'Button';
var $8fef066443ddfb90$export$2e2bcd8739ae039 = $8fef066443ddfb90$var$Button;



var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");



"use client";
const $81c3594528509898$var$CardBody = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$81c3594528509898$var$CardBody.displayName = 'CardBody';
var $81c3594528509898$export$2e2bcd8739ae039 = $81c3594528509898$var$CardBody;



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $1ddecf6fbc71a88e$var$CardFooter = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1ddecf6fbc71a88e$var$CardFooter.displayName = 'CardFooter';
var $1ddecf6fbc71a88e$export$2e2bcd8739ae039 = $1ddecf6fbc71a88e$var$CardFooter;




var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");
"use client";
const $89976a14c022d99d$var$context = /*#__PURE__*/ $2WGWz.createContext(null);
$89976a14c022d99d$var$context.displayName = 'CardHeaderContext';
var $89976a14c022d99d$export$2e2bcd8739ae039 = $89976a14c022d99d$var$context;



"use client";
const $a0246b75d6c19bcd$var$CardHeader = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $2WGWz.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $89976a14c022d99d$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix)
        })
    });
});
$a0246b75d6c19bcd$var$CardHeader.displayName = 'CardHeader';
var $a0246b75d6c19bcd$export$2e2bcd8739ae039 = $a0246b75d6c19bcd$var$CardHeader;




var $2WGWz = parcelRequire("2WGWz");


"use client";
const $f71d38c39e8e1684$var$CardImg = /*#__PURE__*/ $2WGWz.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$f71d38c39e8e1684$var$CardImg.displayName = 'CardImg';
var $f71d38c39e8e1684$export$2e2bcd8739ae039 = $f71d38c39e8e1684$var$CardImg;



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $0dfc3bc971f881fd$var$CardImgOverlay = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$0dfc3bc971f881fd$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $0dfc3bc971f881fd$export$2e2bcd8739ae039 = $0dfc3bc971f881fd$var$CardImgOverlay;



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $2d3cdfa5bf0499b6$var$CardLink = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$2d3cdfa5bf0499b6$var$CardLink.displayName = 'CardLink';
var $2d3cdfa5bf0499b6$export$2e2bcd8739ae039 = $2d3cdfa5bf0499b6$var$CardLink;



var $2WGWz = parcelRequire("2WGWz");



var $2WGWz = parcelRequire("2WGWz");


var $b9f90237085a60cc$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $2WGWz.forwardRef((p, ref)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(p.className, className)
        }));



"use client";
const $3edf6a03faa428dc$var$DivStyledAsH6 = (0, $b9f90237085a60cc$export$2e2bcd8739ae039)('h6');
const $3edf6a03faa428dc$var$CardSubtitle = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $3edf6a03faa428dc$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$3edf6a03faa428dc$var$CardSubtitle.displayName = 'CardSubtitle';
var $3edf6a03faa428dc$export$2e2bcd8739ae039 = $3edf6a03faa428dc$var$CardSubtitle;



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $a83266c28f6c4631$var$CardText = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$a83266c28f6c4631$var$CardText.displayName = 'CardText';
var $a83266c28f6c4631$export$2e2bcd8739ae039 = $a83266c28f6c4631$var$CardText;



var $2WGWz = parcelRequire("2WGWz");




"use client";
const $0ec63d723ab32a78$var$DivStyledAsH5 = (0, $b9f90237085a60cc$export$2e2bcd8739ae039)('h5');
const $0ec63d723ab32a78$var$CardTitle = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $0ec63d723ab32a78$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$0ec63d723ab32a78$var$CardTitle.displayName = 'CardTitle';
var $0ec63d723ab32a78$export$2e2bcd8739ae039 = $0ec63d723ab32a78$var$CardTitle;



"use client";
const $e4744ef9e9086def$var$Card = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $81c3594528509898$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$e4744ef9e9086def$var$Card.displayName = 'Card';
var $e4744ef9e9086def$export$2e2bcd8739ae039 = Object.assign($e4744ef9e9086def$var$Card, {
    Img: (0, $f71d38c39e8e1684$export$2e2bcd8739ae039),
    Title: (0, $0ec63d723ab32a78$export$2e2bcd8739ae039),
    Subtitle: (0, $3edf6a03faa428dc$export$2e2bcd8739ae039),
    Body: (0, $81c3594528509898$export$2e2bcd8739ae039),
    Link: (0, $2d3cdfa5bf0499b6$export$2e2bcd8739ae039),
    Text: (0, $a83266c28f6c4631$export$2e2bcd8739ae039),
    Header: (0, $a0246b75d6c19bcd$export$2e2bcd8739ae039),
    Footer: (0, $1ddecf6fbc71a88e$export$2e2bcd8739ae039),
    ImgOverlay: (0, $0dfc3bc971f881fd$export$2e2bcd8739ae039)
});

/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}




var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
function $e95789ad4630b60e$export$2e2bcd8739ae039() {
    const mounted = (0, $2WGWz.useRef)(true);
    const isMounted = (0, $2WGWz.useRef)(()=>mounted.current);
    (0, $2WGWz.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $2WGWz = parcelRequire("2WGWz");
function $0fade4a4157dfb58$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $2WGWz.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $2WGWz = parcelRequire("2WGWz");
function $65aa685ec02b57e6$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $0fade4a4157dfb58$export$2e2bcd8739ae039)(fn);
    (0, $2WGWz.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $fec4993eee9b60b8$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $fec4993eee9b60b8$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $fec4993eee9b60b8$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$fec4993eee9b60b8$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $fec4993eee9b60b8$var$MAX_DELAY_MS);
}
function $fec4993eee9b60b8$export$2e2bcd8739ae039() {
    const isMounted = (0, $e95789ad4630b60e$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $2WGWz.useRef)();
    (0, $65aa685ec02b57e6$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $2WGWz.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $fec4993eee9b60b8$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $fec4993eee9b60b8$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}


var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;


function $8cca126ad984a2b0$export$2e2bcd8739ae039() {
    return $8cca126ad984a2b0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8cca126ad984a2b0$export$2e2bcd8739ae039.apply(null, arguments);
}


function $05275c30c5547392$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $2WGWz = parcelRequire("2WGWz");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $97d156d4bb70e673$var$noop = function noop() {};
function $97d156d4bb70e673$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $97d156d4bb70e673$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $97d156d4bb70e673$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$97d156d4bb70e673$export$26cbf8c37e721e67(prop)] = $97d156d4bb70e673$var$noop;
        var handler;
    });
    return propTypes;
}
function $97d156d4bb70e673$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $97d156d4bb70e673$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $97d156d4bb70e673$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $feb65fa3eb9d2358$var$_toPropertyKey(arg) {
    var key = $feb65fa3eb9d2358$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $feb65fa3eb9d2358$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $feb65fa3eb9d2358$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $2WGWz.useRef)(propValue !== undefined);
    var _useState = (0, $2WGWz.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $2WGWz.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $feb65fa3eb9d2358$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$97d156d4bb70e673$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $05275c30c5547392$export$2e2bcd8739ae039)(_ref, [
            $97d156d4bb70e673$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($feb65fa3eb9d2358$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $feb65fa3eb9d2358$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $4cb7199cf5d259cd$export$2e2bcd8739ae039(t, e) {
    return $4cb7199cf5d259cd$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4cb7199cf5d259cd$export$2e2bcd8739ae039(t, e);
}


function $c5e6b14794f06358$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4cb7199cf5d259cd$export$2e2bcd8739ae039)(t, o);
}



var $2WGWz = parcelRequire("2WGWz");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $1537ba6b3d9de465$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $1537ba6b3d9de465$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $97d156d4bb70e673$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($97d156d4bb70e673$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $c5e6b14794f06358$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$97d156d4bb70e673$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$97d156d4bb70e673$export$12ae2baa35bd9b8b(props, key) && $97d156d4bb70e673$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$97d156d4bb70e673$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $05275c30c5547392$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement(Component, (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $97d156d4bb70e673$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement(UncontrolledComponent, (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $1537ba6b3d9de465$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $1537ba6b3d9de465$export$2e2bcd8739ae039(newComponent, (0, $8cca126ad984a2b0$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $2WGWz = parcelRequire("2WGWz");
const $ef11d68cfaaeb713$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $ef11d68cfaaeb713$export$c9058316764c140e(refA, refB) {
    const a = $ef11d68cfaaeb713$var$toFnRef(refA);
    const b = $ef11d68cfaaeb713$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $ef11d68cfaaeb713$var$useMergedRefs(refA, refB) {
    return (0, $2WGWz.useMemo)(()=>$ef11d68cfaaeb713$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $ef11d68cfaaeb713$export$2e2bcd8739ae039 = $ef11d68cfaaeb713$var$useMergedRefs;



var $2WGWz = parcelRequire("2WGWz");
function $c132b796c65a883a$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $c132b796c65a883a$export$13e065f3a74cfe36() {
    const parts = $2WGWz.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $c132b796c65a883a$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $c132b796c65a883a$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}



var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");

var $2WGWz = parcelRequire("2WGWz");
function $4b076e22423d0050$export$2e2bcd8739ae039() {
    return (0, $2WGWz.useState)(null);
}



var $2WGWz = parcelRequire("2WGWz");
const $b38984c70268c255$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $b38984c70268c255$export$c9058316764c140e(refA, refB) {
    const a = $b38984c70268c255$var$toFnRef(refA);
    const b = $b38984c70268c255$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $b38984c70268c255$var$useMergedRefs(refA, refB) {
    return (0, $2WGWz.useMemo)(()=>$b38984c70268c255$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $b38984c70268c255$export$2e2bcd8739ae039 = $b38984c70268c255$var$useMergedRefs;



var $2WGWz = parcelRequire("2WGWz");
var $9b8288c93dde0611$var$has = Object.prototype.hasOwnProperty;
function $9b8288c93dde0611$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($9b8288c93dde0611$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $9b8288c93dde0611$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $9b8288c93dde0611$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$9b8288c93dde0611$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($9b8288c93dde0611$var$has.call(foo, ctor) && ++len && !$9b8288c93dde0611$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$9b8288c93dde0611$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
function $54f0a492ad063b1e$export$2e2bcd8739ae039() {
    const mounted = (0, $2WGWz.useRef)(true);
    const isMounted = (0, $2WGWz.useRef)(()=>mounted.current);
    (0, $2WGWz.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $5ca4466beab7b719$var$useSafeState(state) {
    const isMounted = (0, $54f0a492ad063b1e$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $2WGWz.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $5ca4466beab7b719$export$2e2bcd8739ae039 = $5ca4466beab7b719$var$useSafeState;



function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;



function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
}


function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3822c5a08263882b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) >= 0;
}




function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element);
    if ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $94c820df5d403ed2$export$2e2bcd8739ae039)(offsetParent) && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}


function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $049d14be9b4f15bb$export$8960430cfd85939f)(min, (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $559cca984964a2c1$export$2e2bcd8739ae039)(), paddingObject);
}


function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];


var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var sideY = (0, $961d5315ffabf519$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(popper);
            if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || placement === (0, $961d5315ffabf519$export$79ffe56a765070d2)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideY = (0, $961d5315ffabf519$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || placement === (0, $961d5315ffabf519$export$40e543e69a8b3fbb)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideX = (0, $961d5315ffabf519$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};



var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};


var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}



var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}








function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)).left + (0, $e826853427a61d24$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3822c5a08263882b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e826853427a61d24$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node) && (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(node));
}





function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a31d6136541392dc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(target)));
}










function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) ? (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $4c6294ad0a5a884e$export$2e2bcd8739ae039)(element, strategy)) : (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $32cb83235cf6af6b$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) ? (0, $8debf15f2d350881$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $961d5315ffabf519$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $961d5315ffabf519$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $961d5315ffabf519$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $961d5315ffabf519$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $961d5315ffabf519$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $961d5315ffabf519$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $961d5315ffabf519$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $961d5315ffabf519$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? (0, $961d5315ffabf519$export$ca50aac9f3ba507f) : (0, $961d5315ffabf519$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3ed34baa7075c065$export$2e2bcd8739ae039)((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $961d5315ffabf519$export$79ffe56a765070d2),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $961d5315ffabf519$export$1e95b668f3b82d),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $961d5315ffabf519$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $961d5315ffabf519$export$368f9a87e87fa4e1) : (0, $961d5315ffabf519$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $961d5315ffabf519$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $895264d7f1285abd$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860) ? (0, $5f0f7fd33e6df374$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$b3571188c770cc5a);
        var isVertical = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $961d5315ffabf519$export$79ffe56a765070d2) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $961d5315ffabf519$export$1e95b668f3b82d),
        (0, $961d5315ffabf519$export$79ffe56a765070d2),
        (0, $961d5315ffabf519$export$40e543e69a8b3fbb),
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};




function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $961d5315ffabf519$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};



function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};





function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $45abdfcc61968a12$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $559cca984964a2c1$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8debf15f2d350881$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $049d14be9b4f15bb$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $32a9692ec37d141e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node) || !(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node)) return (0, $e826853427a61d24$export$2e2bcd8739ae039)(node);
    else return (0, $9f852250855e3d87$export$2e2bcd8739ae039)(node);
}








function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b434581b465cb432$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $961d5315ffabf519$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(reference) ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7fa7d91227c213a7$export$2e2bcd8739ae039)((0, $79e2fb482cad3d90$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dbf000ff4b3c4664$export$2e2bcd8739ae039)(reference, (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $348b53990a67b9f2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $7877dfaf8a1d2f7a$export$8f7491d57c8f97a9 = (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039),
        (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
        (0, $bbe366718497d634$export$2e2bcd8739ae039),
        (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
        (0, $6137a161b4896709$export$2e2bcd8739ae039),
        (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
        (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
        (0, $48ddd81393695a53$export$2e2bcd8739ae039)
    ]
});


const $35256269bd45e702$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $35256269bd45e702$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $35256269bd45e702$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $35256269bd45e702$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $35256269bd45e702$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $35256269bd45e702$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $35256269bd45e702$var$EMPTY_MODIFIERS } = _ref, config = $35256269bd45e702$var$_objectWithoutPropertiesLoose(_ref, $35256269bd45e702$var$_excluded);
    const prevModifiers = (0, $2WGWz.useRef)(modifiers);
    const popperInstanceRef = (0, $2WGWz.useRef)();
    const update = (0, $2WGWz.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $2WGWz.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $5ca4466beab7b719$export$2e2bcd8739ae039)((0, $2WGWz.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $2WGWz.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $2WGWz.useMemo)(()=>{
        if (!(0, $9b8288c93dde0611$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $2WGWz.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $35256269bd45e702$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $2WGWz.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $7877dfaf8a1d2f7a$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $35256269bd45e702$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $35256269bd45e702$export$2e2bcd8739ae039 = $35256269bd45e702$var$usePopper;


/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;


function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $1f09aa616755b094$var$useCommittedRef(value) {
    const ref = (0, $2WGWz.useRef)(value);
    (0, $2WGWz.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $1f09aa616755b094$export$2e2bcd8739ae039 = $1f09aa616755b094$var$useCommittedRef;


function $32770ad027b0258a$export$2e2bcd8739ae039(fn) {
    const ref = (0, $1f09aa616755b094$export$2e2bcd8739ae039)(fn);
    return (0, $2WGWz.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}






var $2WGWz = parcelRequire("2WGWz");


const $e6f94228500b34f7$var$noop = ()=>{};
function $e6f94228500b34f7$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $e6f94228500b34f7$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $e6f94228500b34f7$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $e6f94228500b34f7$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $e6f94228500b34f7$var$useClickOutside(ref, onClickOutside = $e6f94228500b34f7$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $2WGWz.useRef)(false);
    const waitingForTrigger = (0, $2WGWz.useRef)(false);
    const handleMouseCapture = (0, $2WGWz.useCallback)((e)=>{
        const currentTarget = $e6f94228500b34f7$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $e6f94228500b34f7$var$isModifiedEvent(e) || !$e6f94228500b34f7$var$isLeftClickEvent(e) || !!(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $e6f94228500b34f7$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $2WGWz.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)($e6f94228500b34f7$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($e6f94228500b34f7$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, $e6f94228500b34f7$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(el, 'mousemove', $e6f94228500b34f7$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $e6f94228500b34f7$export$2e2bcd8739ae039 = $e6f94228500b34f7$var$useClickOutside;



const $1105472843610c3b$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $1105472843610c3b$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $1105472843610c3b$var$noop;
    (0, $e6f94228500b34f7$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        if ((0, $c132b796c65a883a$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $2WGWz.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)((0, $e6f94228500b34f7$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $1105472843610c3b$export$2e2bcd8739ae039 = $1105472843610c3b$var$useRootClose;





var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");

const $2e6f3a6bd4973324$var$Context = /*#__PURE__*/ (0, $2WGWz.createContext)((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) ? window : undefined);
const $2e6f3a6bd4973324$export$f7d306aeb1cf5fbc = $2e6f3a6bd4973324$var$Context.Provider;
function $2e6f3a6bd4973324$export$2e2bcd8739ae039() {
    return (0, $2WGWz.useContext)($2e6f3a6bd4973324$var$Context);
}


const $ccbe49e7055777dd$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $ccbe49e7055777dd$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $2e6f3a6bd4973324$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $2WGWz.useState)(()=>$ccbe49e7055777dd$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $ccbe49e7055777dd$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $2WGWz.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $2WGWz.useEffect)(()=>{
        const nextRef = $ccbe49e7055777dd$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}


function $1aca7e00f790d7ed$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $1aca7e00f790d7ed$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $1aca7e00f790d7ed$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $1aca7e00f790d7ed$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $1aca7e00f790d7ed$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}





var $2WGWz = parcelRequire("2WGWz");
const $5db33268a50b3680$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $5db33268a50b3680$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $5db33268a50b3680$export$2e2bcd8739ae039 = $5db33268a50b3680$var$isDOM || $5db33268a50b3680$var$isReactNative ? (0, $2WGWz.useLayoutEffect) : (0, $2WGWz.useEffect);



var $2WGWz = parcelRequire("2WGWz");



var $2WGWz = parcelRequire("2WGWz");

function $1c8ce9fd851ca5e7$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $2WGWz.useRef)(null);
    const hasEnteredRef = (0, $2WGWz.useRef)(inProp);
    const handleExited = (0, $32770ad027b0258a$export$2e2bcd8739ae039)(onExited);
    (0, $2WGWz.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $b38984c70268c255$export$2e2bcd8739ae039)(ref, (0, $c132b796c65a883a$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $2WGWz.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $1c8ce9fd851ca5e7$export$2e2bcd8739ae039 = $1c8ce9fd851ca5e7$var$NoopTransition;



var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");


const $5ec197274b9b564c$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $5ec197274b9b564c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $5ec197274b9b564c$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $5ec197274b9b564c$var$_objectWithoutPropertiesLoose(_ref, $5ec197274b9b564c$var$_excluded);
    const nodeRef = (0, $2WGWz.useRef)(null);
    const mergedRef = (0, $b38984c70268c255$export$2e2bcd8739ae039)(nodeRef, (0, $c132b796c65a883a$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $2WGWz.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $2WGWz.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $2WGWz.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $2WGWz.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $2WGWz.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $2WGWz.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $2WGWz.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $2WGWz.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $0fe706a193a9c572$var$_excluded = [
    "component"
];
function $0fe706a193a9c572$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $0fe706a193a9c572$var$RTGTransition = /*#__PURE__*/ $2WGWz.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $0fe706a193a9c572$var$_objectWithoutPropertiesLoose(_ref, $0fe706a193a9c572$var$_excluded);
    const transitionProps = (0, $5ec197274b9b564c$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $0fe706a193a9c572$export$2e2bcd8739ae039 = $0fe706a193a9c572$var$RTGTransition;




function $c5fbdc32ab2a3998$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $2WGWz.useRef)(null);
    const isInitialRef = (0, $2WGWz.useRef)(true);
    const handleTransition = (0, $32770ad027b0258a$export$2e2bcd8739ae039)(onTransition);
    (0, $5db33268a50b3680$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $5db33268a50b3680$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $c5fbdc32ab2a3998$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $2WGWz.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $c5fbdc32ab2a3998$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $b38984c70268c255$export$2e2bcd8739ae039)(ref, (0, $c132b796c65a883a$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $2WGWz.cloneElement)(children, {
        ref: combinedRef
    });
}
function $c5fbdc32ab2a3998$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $0fe706a193a9c572$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($c5fbdc32ab2a3998$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $1c8ce9fd851ca5e7$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $a2fc9b38dd63ec7a$var$Overlay = /*#__PURE__*/ $2WGWz.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $4b076e22423d0050$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $4b076e22423d0050$export$2e2bcd8739ae039)();
    const mergedRef = (0, $b38984c70268c255$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $ccbe49e7055777dd$export$2e2bcd8739ae039)(props.container);
    const target = (0, $ccbe49e7055777dd$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $2WGWz.useState)(!props.show);
    const popper = (0, $35256269bd45e702$export$2e2bcd8739ae039)(target, rootElement, (0, $1aca7e00f790d7ed$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $1105472843610c3b$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $c5fbdc32ab2a3998$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).createPortal(child, container) : null;
});
$a2fc9b38dd63ec7a$var$Overlay.displayName = 'Overlay';
var $a2fc9b38dd63ec7a$export$2e2bcd8739ae039 = $a2fc9b38dd63ec7a$var$Overlay;



var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $855fe4baf6aa7b52$var$useCommittedRef(value) {
    const ref = (0, $2WGWz.useRef)(value);
    (0, $2WGWz.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $855fe4baf6aa7b52$export$2e2bcd8739ae039 = $855fe4baf6aa7b52$var$useCommittedRef;


function $2e552e42661327c8$export$2e2bcd8739ae039(fn) {
    const ref = (0, $855fe4baf6aa7b52$export$2e2bcd8739ae039)(fn);
    return (0, $2WGWz.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $2WGWz = parcelRequire("2WGWz");
const $cc67bff9c4584725$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $cc67bff9c4584725$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $cc67bff9c4584725$export$2e2bcd8739ae039 = $cc67bff9c4584725$var$isDOM || $cc67bff9c4584725$var$isReactNative ? (0, $2WGWz.useLayoutEffect) : (0, $2WGWz.useEffect);




var $2WGWz = parcelRequire("2WGWz");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");



"use client";
const $68894f26c3d4b7d0$var$PopoverHeader = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$68894f26c3d4b7d0$var$PopoverHeader.displayName = 'PopoverHeader';
var $68894f26c3d4b7d0$export$2e2bcd8739ae039 = $68894f26c3d4b7d0$var$PopoverHeader;



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $73c4e9fe09d0cf57$var$PopoverBody = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$73c4e9fe09d0cf57$var$PopoverBody.displayName = 'PopoverBody';
var $73c4e9fe09d0cf57$export$2e2bcd8739ae039 = $73c4e9fe09d0cf57$var$PopoverBody;



var $2WGWz = parcelRequire("2WGWz");
class $35b17b0949f09f9b$export$34582a676b91ff07 extends $2WGWz.Component {
}
function $35b17b0949f09f9b$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $c53f06b735008e67$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $52903fdd1f11706f$var$Popover = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $9283c6e4393bcc4e$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $35b17b0949f09f9b$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $c53f06b735008e67$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $73c4e9fe09d0cf57$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$52903fdd1f11706f$var$Popover.displayName = 'Popover';
var $52903fdd1f11706f$export$2e2bcd8739ae039 = Object.assign($52903fdd1f11706f$var$Popover, {
    Header: (0, $68894f26c3d4b7d0$export$2e2bcd8739ae039),
    Body: (0, $73c4e9fe09d0cf57$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $2WGWz = parcelRequire("2WGWz");




"use client";
const $9e73697666d1eda6$var$Tooltip = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $9283c6e4393bcc4e$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $35b17b0949f09f9b$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $c53f06b735008e67$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$9e73697666d1eda6$var$Tooltip.displayName = 'Tooltip';
var $9e73697666d1eda6$export$2e2bcd8739ae039 = Object.assign($9e73697666d1eda6$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $819dda4df6f91cc4$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $2WGWz.useRef)(null);
    const popoverClass = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $2WGWz.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $52903fdd1f11706f$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $9e73697666d1eda6$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}




var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");
var $0d25f6ec89269b93$export$2e2bcd8739ae039 = {
    disabled: false
};




var $2WGWz = parcelRequire("2WGWz");
var $6f19ddf122fc30da$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createContext(null);


var $1a839d6e8cde990c$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $dcf47152d49f7679$export$bb38bb9a1161268 = 'unmounted';
var $dcf47152d49f7679$export$84cbff306f539230 = 'exited';
var $dcf47152d49f7679$export$df38205c966be359 = 'entering';
var $dcf47152d49f7679$export$78e9e6e3e014d60a = 'entered';
var $dcf47152d49f7679$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $dcf47152d49f7679$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $c5e6b14794f06358$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $dcf47152d49f7679$export$84cbff306f539230;
                _this.appearStatus = $dcf47152d49f7679$export$df38205c966be359;
            } else initialStatus = $dcf47152d49f7679$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $dcf47152d49f7679$export$bb38bb9a1161268;
        else initialStatus = $dcf47152d49f7679$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $dcf47152d49f7679$export$bb38bb9a1161268) return {
            status: $dcf47152d49f7679$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $dcf47152d49f7679$export$df38205c966be359 && status !== $dcf47152d49f7679$export$78e9e6e3e014d60a) nextStatus = $dcf47152d49f7679$export$df38205c966be359;
            } else if (status === $dcf47152d49f7679$export$df38205c966be359 || status === $dcf47152d49f7679$export$78e9e6e3e014d60a) nextStatus = $dcf47152d49f7679$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $dcf47152d49f7679$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $1a839d6e8cde990c$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $dcf47152d49f7679$export$84cbff306f539230) this.setState({
            status: $dcf47152d49f7679$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $0d25f6ec89269b93$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $dcf47152d49f7679$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $dcf47152d49f7679$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $dcf47152d49f7679$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $0d25f6ec89269b93$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $dcf47152d49f7679$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $dcf47152d49f7679$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $dcf47152d49f7679$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $dcf47152d49f7679$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $05275c30c5547392$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement((0, $6f19ddf122fc30da$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
$dcf47152d49f7679$var$Transition.contextType = (0, $6f19ddf122fc30da$export$2e2bcd8739ae039);
$dcf47152d49f7679$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $dcf47152d49f7679$var$noop() {}
$dcf47152d49f7679$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $dcf47152d49f7679$var$noop,
    onEntering: $dcf47152d49f7679$var$noop,
    onEntered: $dcf47152d49f7679$var$noop,
    onExit: $dcf47152d49f7679$var$noop,
    onExiting: $dcf47152d49f7679$var$noop,
    onExited: $dcf47152d49f7679$var$noop
};
$dcf47152d49f7679$var$Transition.UNMOUNTED = $dcf47152d49f7679$export$bb38bb9a1161268;
$dcf47152d49f7679$var$Transition.EXITED = $dcf47152d49f7679$export$84cbff306f539230;
$dcf47152d49f7679$var$Transition.ENTERING = $dcf47152d49f7679$export$df38205c966be359;
$dcf47152d49f7679$var$Transition.ENTERED = $dcf47152d49f7679$export$78e9e6e3e014d60a;
$dcf47152d49f7679$var$Transition.EXITING = $dcf47152d49f7679$export$4aacc83d4d59139f;
var $dcf47152d49f7679$export$2e2bcd8739ae039 = $dcf47152d49f7679$var$Transition;




function $687967af0f2f65dd$export$2e2bcd8739ae039(node) {
    var doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bab365215d6465d0$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $687967af0f2f65dd$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $bb45a00770e1e637$var$rUpper = /([A-Z])/g;
function $bb45a00770e1e637$export$2e2bcd8739ae039(string) {
    return string.replace($bb45a00770e1e637$var$rUpper, '-$1').toLowerCase();
}


var $b9e9e022259fd181$var$msPattern = /^ms-/;
function $b9e9e022259fd181$export$2e2bcd8739ae039(string) {
    return (0, $bb45a00770e1e637$export$2e2bcd8739ae039)(string).replace($b9e9e022259fd181$var$msPattern, '-ms-');
}


var $cfefa1cd0af90d26$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cfefa1cd0af90d26$export$2e2bcd8739ae039(value) {
    return !!(value && $cfefa1cd0af90d26$var$supportedTransforms.test(value));
}


function $8e0039237f2a8b13$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property)) || (0, $bab365215d6465d0$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key));
        else if ((0, $cfefa1cd0af90d26$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8e0039237f2a8b13$export$2e2bcd8739ae039 = $8e0039237f2a8b13$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $86531d9dcbce6c08$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d247f6e7f04e903f$var$parseDuration(node) {
    var str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $86531d9dcbce6c08$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d247f6e7f04e903f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d247f6e7f04e903f$var$parseDuration(element) || 0;
    var removeEmulate = $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $a7c5e041381e39e9$var$parseDuration(node, property) {
    const str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $a7c5e041381e39e9$export$2e2bcd8739ae039(element, handler) {
    const duration = $a7c5e041381e39e9$var$parseDuration(element, 'transitionDuration');
    const delay = $a7c5e041381e39e9$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $ece0fef539b40514$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $2WGWz = parcelRequire("2WGWz");



var $9Np2q = parcelRequire("9Np2q");
function $880d81d9a8f606d2$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $980b3c7829c29a12$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $2WGWz.useRef)(null);
    const mergedRef = (0, $ef11d68cfaaeb713$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $880d81d9a8f606d2$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $2WGWz.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $2WGWz.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $2WGWz.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $2WGWz.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $2WGWz.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $2WGWz.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $2WGWz.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $dcf47152d49f7679$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$980b3c7829c29a12$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $980b3c7829c29a12$export$2e2bcd8739ae039 = $980b3c7829c29a12$var$TransitionWrapper;



const $acf1c2fbf4ec15e7$var$fadeStyles = {
    [(0, $dcf47152d49f7679$export$df38205c966be359)]: 'show',
    [(0, $dcf47152d49f7679$export$78e9e6e3e014d60a)]: 'show'
};
const $acf1c2fbf4ec15e7$var$Fade = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $2WGWz.useCallback)((node, isAppearing)=>{
        (0, $ece0fef539b40514$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $980b3c7829c29a12$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a7c5e041381e39e9$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $c132b796c65a883a$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $2WGWz.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fade', className, children.props.className, $acf1c2fbf4ec15e7$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$acf1c2fbf4ec15e7$var$Fade.displayName = 'Fade';
var $acf1c2fbf4ec15e7$export$2e2bcd8739ae039 = $acf1c2fbf4ec15e7$var$Fade;




"use client";
function $4fbf74e397d71c94$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $880d81d9a8f606d2$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $880d81d9a8f606d2$export$2e2bcd8739ae039)(r)));
}
const $4fbf74e397d71c94$var$Overlay = /*#__PURE__*/ $2WGWz.forwardRef(({ children: overlay, transition: transition = (0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $2WGWz.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $2WGWz.useState)(null);
    const [ref, modifiers] = (0, $819dda4df6f91cc4$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $ef11d68cfaaeb713$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $2e552e42661327c8$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $cc67bff9c4584725$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $2WGWz.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a2fc9b38dd63ec7a$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $4fbf74e397d71c94$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $2WGWz.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$4fbf74e397d71c94$var$Overlay.displayName = 'Overlay';
var $4fbf74e397d71c94$export$2e2bcd8739ae039 = $4fbf74e397d71c94$var$Overlay;




"use client";
function $5489e531a8951c51$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $5489e531a8951c51$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $5489e531a8951c51$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $5489e531a8951c51$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $2WGWz.useRef)(null);
    const mergedRef = (0, $ef11d68cfaaeb713$export$2e2bcd8739ae039)(triggerNodeRef, (0, $c132b796c65a883a$export$87943f2672146d57)(children));
    const timeout = (0, $fec4993eee9b60b8$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $2WGWz.useRef)('');
    const [show, setShow] = (0, $feb65fa3eb9d2358$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $5489e531a8951c51$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $2WGWz.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $880d81d9a8f606d2$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $2WGWz.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $2WGWz.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $2WGWz.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $2WGWz.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $2WGWz.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $2WGWz.useCallback)((...args)=>{
        $5489e531a8951c51$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $2WGWz.useCallback)((...args)=>{
        $5489e531a8951c51$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $2WGWz.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $4fbf74e397d71c94$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $5489e531a8951c51$export$2e2bcd8739ae039 = $5489e531a8951c51$var$OverlayTrigger;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1ea4a0cb853f5c10$var$_extends() {
    $1ea4a0cb853f5c10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ea4a0cb853f5c10$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1ea4a0cb853f5c10$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1ea4a0cb853f5c10$export$e19cd5f9376f8cee || ($1ea4a0cb853f5c10$export$e19cd5f9376f8cee = {}));
const $1ea4a0cb853f5c10$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1ea4a0cb853f5c10$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1ea4a0cb853f5c10$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1ea4a0cb853f5c10$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1ea4a0cb853f5c10$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to);
    }
    return $1ea4a0cb853f5c10$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1ea4a0cb853f5c10$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1ea4a0cb853f5c10$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1ea4a0cb853f5c10$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1ea4a0cb853f5c10$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1ea4a0cb853f5c10$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1ea4a0cb853f5c10$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1ea4a0cb853f5c10$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1ea4a0cb853f5c10$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1ea4a0cb853f5c10$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1ea4a0cb853f5c10$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1ea4a0cb853f5c10$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1ea4a0cb853f5c10$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1ea4a0cb853f5c10$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
        let location = $1ea4a0cb853f5c10$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1ea4a0cb853f5c10$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
        let location = $1ea4a0cb853f5c10$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1ea4a0cb853f5c10$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1ea4a0cb853f5c10$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1ea4a0cb853f5c10$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1ea4a0cb853f5c10$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1ea4a0cb853f5c10$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1ea4a0cb853f5c10$var$ResultType || ($1ea4a0cb853f5c10$var$ResultType = {}));
const $1ea4a0cb853f5c10$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1ea4a0cb853f5c10$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1ea4a0cb853f5c10$var$isIndexRoute(route)) {
            let indexRoute = $1ea4a0cb853f5c10$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1ea4a0cb853f5c10$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1ea4a0cb853f5c10$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1ea4a0cb853f5c10$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1ea4a0cb853f5c10$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1ea4a0cb853f5c10$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1ea4a0cb853f5c10$var$flattenRoutes(routes);
    $1ea4a0cb853f5c10$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1ea4a0cb853f5c10$export$30d21fd6d7295f52(pathname);
        matches = $1ea4a0cb853f5c10$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1ea4a0cb853f5c10$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1ea4a0cb853f5c10$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1ea4a0cb853f5c10$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1ea4a0cb853f5c10$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1ea4a0cb853f5c10$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1ea4a0cb853f5c10$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1ea4a0cb853f5c10$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1ea4a0cb853f5c10$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1ea4a0cb853f5c10$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1ea4a0cb853f5c10$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1ea4a0cb853f5c10$var$paramRe = /^:[\w-]+$/;
const $1ea4a0cb853f5c10$var$dynamicSegmentValue = 3;
const $1ea4a0cb853f5c10$var$indexRouteValue = 2;
const $1ea4a0cb853f5c10$var$emptySegmentValue = 1;
const $1ea4a0cb853f5c10$var$staticSegmentValue = 10;
const $1ea4a0cb853f5c10$var$splatPenalty = -2;
const $1ea4a0cb853f5c10$var$isSplat = (s)=>s === "*";
function $1ea4a0cb853f5c10$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1ea4a0cb853f5c10$var$isSplat)) initialScore += $1ea4a0cb853f5c10$var$splatPenalty;
    if (index) initialScore += $1ea4a0cb853f5c10$var$indexRouteValue;
    return segments.filter((s)=>!$1ea4a0cb853f5c10$var$isSplat(s)).reduce((score, segment)=>score + ($1ea4a0cb853f5c10$var$paramRe.test(segment) ? $1ea4a0cb853f5c10$var$dynamicSegmentValue : segment === "" ? $1ea4a0cb853f5c10$var$emptySegmentValue : $1ea4a0cb853f5c10$var$staticSegmentValue), initialScore);
}
function $1ea4a0cb853f5c10$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1ea4a0cb853f5c10$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1ea4a0cb853f5c10$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1ea4a0cb853f5c10$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1ea4a0cb853f5c10$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1ea4a0cb853f5c10$export$a5c6d149b50c1d86($1ea4a0cb853f5c10$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1ea4a0cb853f5c10$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1ea4a0cb853f5c10$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1ea4a0cb853f5c10$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1ea4a0cb853f5c10$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1ea4a0cb853f5c10$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1ea4a0cb853f5c10$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1ea4a0cb853f5c10$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1ea4a0cb853f5c10$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1ea4a0cb853f5c10$var$isAbsoluteUrl = (url)=>$1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1ea4a0cb853f5c10$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1ea4a0cb853f5c10$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1ea4a0cb853f5c10$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1ea4a0cb853f5c10$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1ea4a0cb853f5c10$var$normalizeSearch(search),
        hash: $1ea4a0cb853f5c10$var$normalizeHash(hash)
    };
}
function $1ea4a0cb853f5c10$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1ea4a0cb853f5c10$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1ea4a0cb853f5c10$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1ea4a0cb853f5c10$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1ea4a0cb853f5c10$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1ea4a0cb853f5c10$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1ea4a0cb853f5c10$var$_extends({}, toArg);
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1ea4a0cb853f5c10$var$getInvalidPathError("?", "pathname", "search", to));
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1ea4a0cb853f5c10$var$getInvalidPathError("#", "pathname", "hash", to));
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1ea4a0cb853f5c10$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1ea4a0cb853f5c10$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1ea4a0cb853f5c10$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1ea4a0cb853f5c10$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1ea4a0cb853f5c10$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1ea4a0cb853f5c10$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1ea4a0cb853f5c10$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1ea4a0cb853f5c10$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1ea4a0cb853f5c10$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1ea4a0cb853f5c10$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1ea4a0cb853f5c10$export$4051a07651545597(data, init) {
    return new $1ea4a0cb853f5c10$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a extends Error {
}
class $1ea4a0cb853f5c10$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1ea4a0cb853f5c10$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1ea4a0cb853f5c10$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1ea4a0cb853f5c10$var$unwrapTrackedPromise(value) {
    if (!$1ea4a0cb853f5c10$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1ea4a0cb853f5c10$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1ea4a0cb853f5c10$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ea4a0cb853f5c10$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1ea4a0cb853f5c10$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ea4a0cb853f5c10$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1ea4a0cb853f5c10$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1ea4a0cb853f5c10$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1ea4a0cb853f5c10$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1ea4a0cb853f5c10$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1ea4a0cb853f5c10$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1ea4a0cb853f5c10$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1ea4a0cb853f5c10$var$validMutationMethods = new Set($1ea4a0cb853f5c10$var$validMutationMethodsArr);
const $1ea4a0cb853f5c10$var$validRequestMethodsArr = [
    "get",
    ...$1ea4a0cb853f5c10$var$validMutationMethodsArr
];
const $1ea4a0cb853f5c10$var$validRequestMethods = new Set($1ea4a0cb853f5c10$var$validRequestMethodsArr);
const $1ea4a0cb853f5c10$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1ea4a0cb853f5c10$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1ea4a0cb853f5c10$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1ea4a0cb853f5c10$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1ea4a0cb853f5c10$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1ea4a0cb853f5c10$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1ea4a0cb853f5c10$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1ea4a0cb853f5c10$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1ea4a0cb853f5c10$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1ea4a0cb853f5c10$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1ea4a0cb853f5c10$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1ea4a0cb853f5c10$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1ea4a0cb853f5c10$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1ea4a0cb853f5c10$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1ea4a0cb853f5c10$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1ea4a0cb853f5c10$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1ea4a0cb853f5c10$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1ea4a0cb853f5c10$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1ea4a0cb853f5c10$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1ea4a0cb853f5c10$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1ea4a0cb853f5c10$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1ea4a0cb853f5c10$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1ea4a0cb853f5c10$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1ea4a0cb853f5c10$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1ea4a0cb853f5c10$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1ea4a0cb853f5c10$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1ea4a0cb853f5c10$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1ea4a0cb853f5c10$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1ea4a0cb853f5c10$var$findNearestBoundary(matches).route.id,
            {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1ea4a0cb853f5c10$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1ea4a0cb853f5c10$var$isErrorResult(result) && $1ea4a0cb853f5c10$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1ea4a0cb853f5c10$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1ea4a0cb853f5c10$var$_extends({
            matches: updatedMatches || matches
        }, $1ea4a0cb853f5c10$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1ea4a0cb853f5c10$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1ea4a0cb853f5c10$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1ea4a0cb853f5c10$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1ea4a0cb853f5c10$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1ea4a0cb853f5c10$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1ea4a0cb853f5c10$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) throw $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1ea4a0cb853f5c10$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1ea4a0cb853f5c10$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1ea4a0cb853f5c10$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1ea4a0cb853f5c10$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1ea4a0cb853f5c10$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1ea4a0cb853f5c10$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1ea4a0cb853f5c10$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1ea4a0cb853f5c10$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1ea4a0cb853f5c10$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1ea4a0cb853f5c10$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1ea4a0cb853f5c10$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1ea4a0cb853f5c10$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1ea4a0cb853f5c10$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1ea4a0cb853f5c10$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1ea4a0cb853f5c10$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1ea4a0cb853f5c10$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1ea4a0cb853f5c10$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1ea4a0cb853f5c10$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1ea4a0cb853f5c10$var$isRedirectResult(actionResult) || $1ea4a0cb853f5c10$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1ea4a0cb853f5c10$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1ea4a0cb853f5c10$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1ea4a0cb853f5c10$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1ea4a0cb853f5c10$var$isDeferredResult(actionResult)) throw $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1ea4a0cb853f5c10$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1ea4a0cb853f5c10$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1ea4a0cb853f5c10$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1ea4a0cb853f5c10$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1ea4a0cb853f5c10$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1ea4a0cb853f5c10$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1ea4a0cb853f5c10$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1ea4a0cb853f5c10$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1ea4a0cb853f5c10$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1ea4a0cb853f5c10$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) result = await $1ea4a0cb853f5c10$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!$1ea4a0cb853f5c10$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1ea4a0cb853f5c10$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1ea4a0cb853f5c10$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1ea4a0cb853f5c10$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1ea4a0cb853f5c10$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Replace : $1ea4a0cb853f5c10$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1ea4a0cb853f5c10$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1ea4a0cb853f5c10$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1ea4a0cb853f5c10$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1ea4a0cb853f5c10$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1ea4a0cb853f5c10$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1ea4a0cb853f5c10$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1ea4a0cb853f5c10$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1ea4a0cb853f5c10$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1ea4a0cb853f5c10$var$ResultType.redirect,
                response: $1ea4a0cb853f5c10$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1ea4a0cb853f5c10$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1ea4a0cb853f5c10$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1ea4a0cb853f5c10$var$ResultType.error,
                    error: $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1ea4a0cb853f5c10$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1ea4a0cb853f5c10$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1ea4a0cb853f5c10$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1ea4a0cb853f5c10$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1ea4a0cb853f5c10$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1ea4a0cb853f5c10$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1ea4a0cb853f5c10$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1ea4a0cb853f5c10$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1ea4a0cb853f5c10$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1ea4a0cb853f5c10$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1ea4a0cb853f5c10$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1ea4a0cb853f5c10$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1ea4a0cb853f5c10$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1ea4a0cb853f5c10$export$4d0306f8f6a4585b = Symbol("deferred");
function $1ea4a0cb853f5c10$export$3336b097a6fbc59a(routes, opts) {
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1ea4a0cb853f5c10$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1ea4a0cb853f5c10$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1ea4a0cb853f5c10$var$createLocation("", $1ea4a0cb853f5c10$export$fe53371bee54353d(url), null, "default");
        let matches = $1ea4a0cb853f5c10$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1ea4a0cb853f5c10$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1ea4a0cb853f5c10$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1ea4a0cb853f5c10$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1ea4a0cb853f5c10$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1ea4a0cb853f5c10$var$createLocation("", $1ea4a0cb853f5c10$export$fe53371bee54353d(url), null, "default");
        let matches = $1ea4a0cb853f5c10$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1ea4a0cb853f5c10$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1ea4a0cb853f5c10$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1ea4a0cb853f5c10$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1ea4a0cb853f5c10$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1ea4a0cb853f5c10$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1ea4a0cb853f5c10$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1ea4a0cb853f5c10$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1ea4a0cb853f5c10$var$isResponse(result) ? result : $1ea4a0cb853f5c10$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1ea4a0cb853f5c10$var$isDataStrategyResult(e) && $1ea4a0cb853f5c10$var$isResponse(e.result)) {
                if (e.type === $1ea4a0cb853f5c10$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1ea4a0cb853f5c10$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1ea4a0cb853f5c10$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) {
            let error = $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1ea4a0cb853f5c10$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1ea4a0cb853f5c10$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1ea4a0cb853f5c10$var$_extends({}, context, {
                statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1ea4a0cb853f5c10$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1ea4a0cb853f5c10$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1ea4a0cb853f5c10$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1ea4a0cb853f5c10$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1ea4a0cb853f5c10$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1ea4a0cb853f5c10$var$callDataStrategyImpl(dataStrategy || $1ea4a0cb853f5c10$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1ea4a0cb853f5c10$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1ea4a0cb853f5c10$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1ea4a0cb853f5c10$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1ea4a0cb853f5c10$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1ea4a0cb853f5c10$export$fec11da027c70692(routes, context, error) {
    let newContext = $1ea4a0cb853f5c10$var$_extends({}, context, {
        statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1ea4a0cb853f5c10$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1ea4a0cb853f5c10$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1ea4a0cb853f5c10$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1ea4a0cb853f5c10$export$cae722b0cc860f13(to ? to : ".", $1ea4a0cb853f5c10$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1ea4a0cb853f5c10$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1ea4a0cb853f5c10$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1ea4a0cb853f5c10$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1ea4a0cb853f5c10$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1ea4a0cb853f5c10$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1ea4a0cb853f5c10$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1ea4a0cb853f5c10$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1ea4a0cb853f5c10$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1ea4a0cb853f5c10$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1ea4a0cb853f5c10$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1ea4a0cb853f5c10$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1ea4a0cb853f5c10$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1ea4a0cb853f5c10$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1ea4a0cb853f5c10$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1ea4a0cb853f5c10$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1ea4a0cb853f5c10$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1ea4a0cb853f5c10$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1ea4a0cb853f5c10$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1ea4a0cb853f5c10$var$shouldRevalidateLoader(match, $1ea4a0cb853f5c10$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1ea4a0cb853f5c10$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1ea4a0cb853f5c10$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1ea4a0cb853f5c10$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1ea4a0cb853f5c10$var$shouldRevalidateLoader(fetcherMatch, $1ea4a0cb853f5c10$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1ea4a0cb853f5c10$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1ea4a0cb853f5c10$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1ea4a0cb853f5c10$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1ea4a0cb853f5c10$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1ea4a0cb853f5c10$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1ea4a0cb853f5c10$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1ea4a0cb853f5c10$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1ea4a0cb853f5c10$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1ea4a0cb853f5c10$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1ea4a0cb853f5c10$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1ea4a0cb853f5c10$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1ea4a0cb853f5c10$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1ea4a0cb853f5c10$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1ea4a0cb853f5c10$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1ea4a0cb853f5c10$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1ea4a0cb853f5c10$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1ea4a0cb853f5c10$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1ea4a0cb853f5c10$var$ResultType.data,
                result: undefined
            });
        };
        return $1ea4a0cb853f5c10$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1ea4a0cb853f5c10$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1ea4a0cb853f5c10$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1ea4a0cb853f5c10$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1ea4a0cb853f5c10$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1ea4a0cb853f5c10$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1ea4a0cb853f5c10$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: e
            };
        }
        if (type === $1ea4a0cb853f5c10$var$ResultType.error) return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: new $1ea4a0cb853f5c10$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1ea4a0cb853f5c10$var$ResultType.error) {
        if ($1ea4a0cb853f5c10$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1ea4a0cb853f5c10$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1ea4a0cb853f5c10$var$ResultType.error,
                error: new $1ea4a0cb853f5c10$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: result,
            statusCode: $1ea4a0cb853f5c10$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1ea4a0cb853f5c10$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1ea4a0cb853f5c10$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1ea4a0cb853f5c10$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1ea4a0cb853f5c10$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1ea4a0cb853f5c10$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1ea4a0cb853f5c10$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1ea4a0cb853f5c10$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1ea4a0cb853f5c10$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1ea4a0cb853f5c10$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1ea4a0cb853f5c10$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1ea4a0cb853f5c10$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1ea4a0cb853f5c10$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1ea4a0cb853f5c10$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1ea4a0cb853f5c10$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1ea4a0cb853f5c10$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(!$1ea4a0cb853f5c10$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1ea4a0cb853f5c10$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1ea4a0cb853f5c10$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1ea4a0cb853f5c10$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1ea4a0cb853f5c10$var$isErrorResult(result)) {
            let boundaryMatch = $1ea4a0cb853f5c10$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1ea4a0cb853f5c10$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1ea4a0cb853f5c10$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1ea4a0cb853f5c10$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1ea4a0cb853f5c10$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1ea4a0cb853f5c10$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1ea4a0cb853f5c10$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1ea4a0cb853f5c10$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1ea4a0cb853f5c10$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1ea4a0cb853f5c10$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1ea4a0cb853f5c10$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1ea4a0cb853f5c10$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1ea4a0cb853f5c10$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1ea4a0cb853f5c10$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1ea4a0cb853f5c10$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(path) : path;
    return $1ea4a0cb853f5c10$export$fe53371bee54353d($1ea4a0cb853f5c10$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1ea4a0cb853f5c10$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1ea4a0cb853f5c10$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1ea4a0cb853f5c10$var$ResultType.data || result.type === $1ea4a0cb853f5c10$var$ResultType.error);
}
function $1ea4a0cb853f5c10$var$isRedirectDataStrategyResultResult(result) {
    return $1ea4a0cb853f5c10$var$isResponse(result.result) && $1ea4a0cb853f5c10$var$redirectStatusCodes.has(result.result.status);
}
function $1ea4a0cb853f5c10$var$isDeferredResult(result) {
    return result.type === $1ea4a0cb853f5c10$var$ResultType.deferred;
}
function $1ea4a0cb853f5c10$var$isErrorResult(result) {
    return result.type === $1ea4a0cb853f5c10$var$ResultType.error;
}
function $1ea4a0cb853f5c10$var$isRedirectResult(result) {
    return (result && result.type) === $1ea4a0cb853f5c10$var$ResultType.redirect;
}
function $1ea4a0cb853f5c10$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1ea4a0cb853f5c10$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1ea4a0cb853f5c10$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1ea4a0cb853f5c10$var$isRedirectResponse(result) {
    if (!$1ea4a0cb853f5c10$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1ea4a0cb853f5c10$var$isValidMethod(method) {
    return $1ea4a0cb853f5c10$var$validRequestMethods.has(method.toLowerCase());
}
function $1ea4a0cb853f5c10$var$isMutationMethod(method) {
    return $1ea4a0cb853f5c10$var$validMutationMethods.has(method.toLowerCase());
}
async function $1ea4a0cb853f5c10$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1ea4a0cb853f5c10$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1ea4a0cb853f5c10$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1ea4a0cb853f5c10$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1ea4a0cb853f5c10$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1ea4a0cb853f5c10$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1ea4a0cb853f5c10$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1ea4a0cb853f5c10$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1ea4a0cb853f5c10$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1ea4a0cb853f5c10$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1ea4a0cb853f5c10$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1ea4a0cb853f5c10$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1ea4a0cb853f5c10$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1ea4a0cb853f5c10$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1ea4a0cb853f5c10$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1ea4a0cb853f5c10$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1ea4a0cb853f5c10$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1ea4a0cb853f5c10$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1ea4a0cb853f5c10$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1ea4a0cb853f5c10$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1ea4a0cb853f5c10$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1ea4a0cb853f5c10$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1ea4a0cb853f5c10$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1ea4a0cb853f5c10$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1ea4a0cb853f5c10$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1ea4a0cb853f5c10$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2WGWz = parcelRequire("2WGWz");

function $bc78fc24d57a3b2e$var$_extends() {
    $bc78fc24d57a3b2e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc78fc24d57a3b2e$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $bc78fc24d57a3b2e$export$3add0d5dce533e2e = /*#__PURE__*/ $2WGWz.createContext(null);
const $bc78fc24d57a3b2e$export$145dfa71566a64dc = /*#__PURE__*/ $2WGWz.createContext(null);
const $bc78fc24d57a3b2e$var$AwaitContext = /*#__PURE__*/ $2WGWz.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $bc78fc24d57a3b2e$export$26749e8557646306 = /*#__PURE__*/ $2WGWz.createContext(null);
const $bc78fc24d57a3b2e$export$c7914228fb69b0f5 = /*#__PURE__*/ $2WGWz.createContext(null);
const $bc78fc24d57a3b2e$export$9072aa6dd1f93057 = /*#__PURE__*/ $2WGWz.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $bc78fc24d57a3b2e$var$RouteErrorContext = /*#__PURE__*/ $2WGWz.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $bc78fc24d57a3b2e$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $2WGWz.useContext($bc78fc24d57a3b2e$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $bc78fc24d57a3b2e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $bc78fc24d57a3b2e$export$9c954a9d03d32f4a() {
    return $2WGWz.useContext($bc78fc24d57a3b2e$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $bc78fc24d57a3b2e$export$45d76561a5302f2b() {
    !$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return $2WGWz.useContext($bc78fc24d57a3b2e$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $bc78fc24d57a3b2e$export$1b3f31771c5d07c() {
    return $2WGWz.useContext($bc78fc24d57a3b2e$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $bc78fc24d57a3b2e$export$6c330e8992e8a295(pattern) {
    !$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $bc78fc24d57a3b2e$export$45d76561a5302f2b();
    return $2WGWz.useMemo(()=>(0, $1ea4a0cb853f5c10$export$81336c211d5ff295)(pattern, (0, $1ea4a0cb853f5c10$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $bc78fc24d57a3b2e$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $bc78fc24d57a3b2e$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $2WGWz.useContext($bc78fc24d57a3b2e$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2WGWz.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $bc78fc24d57a3b2e$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $bc78fc24d57a3b2e$var$useNavigateStable() : $bc78fc24d57a3b2e$var$useNavigateUnstable();
}
function $bc78fc24d57a3b2e$var$useNavigateUnstable() {
    !$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let dataRouterContext = $2WGWz.useContext($bc78fc24d57a3b2e$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $2WGWz.useContext($bc78fc24d57a3b2e$export$26749e8557646306);
    let { matches: matches } = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bc78fc24d57a3b2e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ea4a0cb853f5c10$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $2WGWz.useRef(false);
    $bc78fc24d57a3b2e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2WGWz.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1ea4a0cb853f5c10$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $bc78fc24d57a3b2e$var$OutletContext = /*#__PURE__*/ $2WGWz.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $bc78fc24d57a3b2e$export$4138103a3ae699cc() {
    return $2WGWz.useContext($bc78fc24d57a3b2e$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $bc78fc24d57a3b2e$export$a3be3530d8e40d0b(context) {
    let outlet = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $bc78fc24d57a3b2e$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $bc78fc24d57a3b2e$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $2WGWz.useContext($bc78fc24d57a3b2e$export$26749e8557646306);
    let { matches: matches } = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bc78fc24d57a3b2e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ea4a0cb853f5c10$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $2WGWz.useMemo(()=>(0, $1ea4a0cb853f5c10$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $bc78fc24d57a3b2e$export$5d3fca4a98652595(routes, locationArg) {
    return $bc78fc24d57a3b2e$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $bc78fc24d57a3b2e$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $2WGWz.useContext($bc78fc24d57a3b2e$export$26749e8557646306);
    let { matches: parentMatches } = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $bc78fc24d57a3b2e$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1ea4a0cb853f5c10$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1ea4a0cb853f5c10$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $bc78fc24d57a3b2e$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $bc78fc24d57a3b2e$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1ea4a0cb853f5c10$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $bc78fc24d57a3b2e$var$DefaultErrorComponent() {
    let error = $bc78fc24d57a3b2e$export$ed527bf60f6e05f2();
    let message = (0, $1ea4a0cb853f5c10$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $2WGWz.createElement($2WGWz.Fragment, null, /*#__PURE__*/ $2WGWz.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $2WGWz.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $2WGWz.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $bc78fc24d57a3b2e$var$defaultErrorElement = /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$DefaultErrorComponent, null);
class $bc78fc24d57a3b2e$var$RenderErrorBoundary extends $2WGWz.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $bc78fc24d57a3b2e$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $2WGWz.useContext($bc78fc24d57a3b2e$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $bc78fc24d57a3b2e$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $bc78fc24d57a3b2e$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $bc78fc24d57a3b2e$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $2WGWz.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $bc78fc24d57a3b2e$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($bc78fc24d57a3b2e$var$DataRouterHook || {});
var $bc78fc24d57a3b2e$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($bc78fc24d57a3b2e$var$DataRouterStateHook || {});
function $bc78fc24d57a3b2e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $bc78fc24d57a3b2e$var$useDataRouterContext(hookName) {
    let ctx = $2WGWz.useContext($bc78fc24d57a3b2e$export$3add0d5dce533e2e);
    !ctx && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return ctx;
}
function $bc78fc24d57a3b2e$var$useDataRouterState(hookName) {
    let state = $2WGWz.useContext($bc78fc24d57a3b2e$export$145dfa71566a64dc);
    !state && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return state;
}
function $bc78fc24d57a3b2e$var$useRouteContext(hookName) {
    let route = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    !route && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $bc78fc24d57a3b2e$var$useCurrentRouteId(hookName) {
    let route = $bc78fc24d57a3b2e$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $bc78fc24d57a3b2e$export$5fc8298006ad9e58() {
    return $bc78fc24d57a3b2e$var$useCurrentRouteId($bc78fc24d57a3b2e$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $bc78fc24d57a3b2e$export$d0fd4b7106de2769() {
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $bc78fc24d57a3b2e$export$600dc272ed516c15() {
    let dataRouterContext = $bc78fc24d57a3b2e$var$useDataRouterContext($bc78fc24d57a3b2e$var$DataRouterHook.UseRevalidator);
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseRevalidator);
    return $2WGWz.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $bc78fc24d57a3b2e$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseMatches);
    return $2WGWz.useMemo(()=>matches.map((m)=>(0, $1ea4a0cb853f5c10$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $bc78fc24d57a3b2e$export$1448a5050d252c4d() {
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseLoaderData);
    let routeId = $bc78fc24d57a3b2e$var$useCurrentRouteId($bc78fc24d57a3b2e$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $bc78fc24d57a3b2e$export$fd5d37484eab868d(routeId) {
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $bc78fc24d57a3b2e$export$fdc00f3f26066d5e() {
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseActionData);
    let routeId = $bc78fc24d57a3b2e$var$useCurrentRouteId($bc78fc24d57a3b2e$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $bc78fc24d57a3b2e$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $2WGWz.useContext($bc78fc24d57a3b2e$var$RouteErrorContext);
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseRouteError);
    let routeId = $bc78fc24d57a3b2e$var$useCurrentRouteId($bc78fc24d57a3b2e$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $bc78fc24d57a3b2e$export$78a72ddb39bdd145() {
    let value = $2WGWz.useContext($bc78fc24d57a3b2e$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $bc78fc24d57a3b2e$export$17f53340677d5831() {
    let value = $2WGWz.useContext($bc78fc24d57a3b2e$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $bc78fc24d57a3b2e$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $bc78fc24d57a3b2e$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $bc78fc24d57a3b2e$var$useDataRouterContext($bc78fc24d57a3b2e$var$DataRouterHook.UseBlocker);
    let state = $bc78fc24d57a3b2e$var$useDataRouterState($bc78fc24d57a3b2e$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $2WGWz.useState("");
    let blockerFunction = $2WGWz.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $bc78fc24d57a3b2e$var$_extends({}, currentLocation, {
                pathname: (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $bc78fc24d57a3b2e$var$_extends({}, nextLocation, {
                pathname: (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $2WGWz.useEffect(()=>{
        let key = String(++$bc78fc24d57a3b2e$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $2WGWz.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1ea4a0cb853f5c10$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $bc78fc24d57a3b2e$var$useNavigateStable() {
    let { router: router } = $bc78fc24d57a3b2e$var$useDataRouterContext($bc78fc24d57a3b2e$var$DataRouterHook.UseNavigateStable);
    let id = $bc78fc24d57a3b2e$var$useCurrentRouteId($bc78fc24d57a3b2e$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $2WGWz.useRef(false);
    $bc78fc24d57a3b2e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2WGWz.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $bc78fc24d57a3b2e$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $bc78fc24d57a3b2e$var$alreadyWarned$1 = {};
function $bc78fc24d57a3b2e$var$warningOnce(key, cond, message) {
    if (!cond && !$bc78fc24d57a3b2e$var$alreadyWarned$1[key]) $bc78fc24d57a3b2e$var$alreadyWarned$1[key] = true;
}
const $bc78fc24d57a3b2e$var$alreadyWarned = {};
function $bc78fc24d57a3b2e$var$warnOnce(key, message) {}
const $bc78fc24d57a3b2e$var$logDeprecation = (flag, msg, link)=>$bc78fc24d57a3b2e$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $bc78fc24d57a3b2e$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $bc78fc24d57a3b2e$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $bc78fc24d57a3b2e$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $bc78fc24d57a3b2e$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $bc78fc24d57a3b2e$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $bc78fc24d57a3b2e$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $bc78fc24d57a3b2e$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $bc78fc24d57a3b2e$var$START_TRANSITION = "startTransition";
const $bc78fc24d57a3b2e$var$startTransitionImpl = $2WGWz[$bc78fc24d57a3b2e$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $bc78fc24d57a3b2e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $2WGWz.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2WGWz.useCallback((newState)=>{
        if (v7_startTransition && $bc78fc24d57a3b2e$var$startTransitionImpl) $bc78fc24d57a3b2e$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $2WGWz.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $2WGWz.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $2WGWz.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2WGWz.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $2WGWz.useEffect(()=>$bc78fc24d57a3b2e$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2WGWz.createElement($2WGWz.Fragment, null, /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $bc78fc24d57a3b2e$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $bc78fc24d57a3b2e$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $bc78fc24d57a3b2e$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $2WGWz.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ea4a0cb853f5c10$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2WGWz.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2WGWz.useCallback((newState)=>{
        v7_startTransition && $bc78fc24d57a3b2e$var$startTransitionImpl ? $bc78fc24d57a3b2e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2WGWz.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2WGWz.useEffect(()=>$bc78fc24d57a3b2e$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $bc78fc24d57a3b2e$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $2WGWz.useContext($bc78fc24d57a3b2e$export$26749e8557646306);
    let { matches: matches } = $2WGWz.useContext($bc78fc24d57a3b2e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bc78fc24d57a3b2e$export$45d76561a5302f2b();
    let navigate = $bc78fc24d57a3b2e$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1ea4a0cb853f5c10$export$cae722b0cc860f13)(to, (0, $1ea4a0cb853f5c10$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $2WGWz.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $bc78fc24d57a3b2e$export$910ae8079b2c2852(props) {
    return $bc78fc24d57a3b2e$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $bc78fc24d57a3b2e$export$e7b0ac011bb776c6(_props) {
    (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $bc78fc24d57a3b2e$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1ea4a0cb853f5c10$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$bc78fc24d57a3b2e$export$9c954a9d03d32f4a() && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $2WGWz.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $bc78fc24d57a3b2e$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1ea4a0cb853f5c10$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $2WGWz.useMemo(()=>{
        let trailingPathname = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $bc78fc24d57a3b2e$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $bc78fc24d57a3b2e$export$5d3fca4a98652595($bc78fc24d57a3b2e$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $bc78fc24d57a3b2e$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$ResolveAwait, null, children));
}
var $bc78fc24d57a3b2e$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($bc78fc24d57a3b2e$var$AwaitRenderStatus || {});
const $bc78fc24d57a3b2e$var$neverSettledPromise = new Promise(()=>{});
class $bc78fc24d57a3b2e$var$AwaitErrorBoundary extends $2WGWz.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $bc78fc24d57a3b2e$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $bc78fc24d57a3b2e$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $bc78fc24d57a3b2e$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $bc78fc24d57a3b2e$var$AwaitRenderStatus.error : "_data" in promise ? $bc78fc24d57a3b2e$var$AwaitRenderStatus.success : $bc78fc24d57a3b2e$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $bc78fc24d57a3b2e$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $bc78fc24d57a3b2e$var$AwaitRenderStatus.error && promise._error instanceof (0, $1ea4a0cb853f5c10$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $bc78fc24d57a3b2e$var$neverSettledPromise;
        if (status === $bc78fc24d57a3b2e$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $bc78fc24d57a3b2e$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $bc78fc24d57a3b2e$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $2WGWz.createElement($bc78fc24d57a3b2e$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $bc78fc24d57a3b2e$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $bc78fc24d57a3b2e$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $2WGWz.createElement($2WGWz.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $bc78fc24d57a3b2e$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $2WGWz.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $2WGWz.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $2WGWz.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $bc78fc24d57a3b2e$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $bc78fc24d57a3b2e$export$e7b0ac011bb776c6) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $bc78fc24d57a3b2e$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $bc78fc24d57a3b2e$export$daf73786167a7f72(matches) {
    return $bc78fc24d57a3b2e$var$_renderMatches(matches);
}
function $bc78fc24d57a3b2e$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $2WGWz.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $2WGWz.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $2WGWz.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $bc78fc24d57a3b2e$export$f30f7e456d254e83(routes, opts) {
    return (0, $1ea4a0cb853f5c10$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $bc78fc24d57a3b2e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ea4a0cb853f5c10$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $bc78fc24d57a3b2e$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $f37a38af02f95fe8$var$_extends() {
    $f37a38af02f95fe8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f37a38af02f95fe8$var$_extends.apply(this, arguments);
}
function $f37a38af02f95fe8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $f37a38af02f95fe8$var$defaultMethod = "get";
const $f37a38af02f95fe8$var$defaultEncType = "application/x-www-form-urlencoded";
function $f37a38af02f95fe8$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $f37a38af02f95fe8$var$isButtonElement(object) {
    return $f37a38af02f95fe8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f37a38af02f95fe8$var$isFormElement(object) {
    return $f37a38af02f95fe8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f37a38af02f95fe8$var$isInputElement(object) {
    return $f37a38af02f95fe8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f37a38af02f95fe8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f37a38af02f95fe8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$f37a38af02f95fe8$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $f37a38af02f95fe8$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f37a38af02f95fe8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $f37a38af02f95fe8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $f37a38af02f95fe8$var$_formDataSupportsSubmitter = null;
function $f37a38af02f95fe8$var$isFormDataSubmitterSupported() {
    if ($f37a38af02f95fe8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $f37a38af02f95fe8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $f37a38af02f95fe8$var$_formDataSupportsSubmitter = true;
    }
    return $f37a38af02f95fe8$var$_formDataSupportsSubmitter;
}
const $f37a38af02f95fe8$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f37a38af02f95fe8$var$getFormEncType(encType) {
    if (encType != null && !$f37a38af02f95fe8$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $f37a38af02f95fe8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f37a38af02f95fe8$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $f37a38af02f95fe8$var$defaultMethod;
        encType = $f37a38af02f95fe8$var$getFormEncType(target.getAttribute("enctype")) || $f37a38af02f95fe8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f37a38af02f95fe8$var$isButtonElement(target) || $f37a38af02f95fe8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $f37a38af02f95fe8$var$defaultMethod;
        encType = $f37a38af02f95fe8$var$getFormEncType(target.getAttribute("formenctype")) || $f37a38af02f95fe8$var$getFormEncType(form.getAttribute("enctype")) || $f37a38af02f95fe8$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$f37a38af02f95fe8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f37a38af02f95fe8$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $f37a38af02f95fe8$var$defaultMethod;
        action = null;
        encType = $f37a38af02f95fe8$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $f37a38af02f95fe8$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $f37a38af02f95fe8$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $f37a38af02f95fe8$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $f37a38af02f95fe8$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $f37a38af02f95fe8$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $f37a38af02f95fe8$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1ea4a0cb853f5c10$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f37a38af02f95fe8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ea4a0cb853f5c10$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f37a38af02f95fe8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bc78fc24d57a3b2e$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f37a38af02f95fe8$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1ea4a0cb853f5c10$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f37a38af02f95fe8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ea4a0cb853f5c10$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f37a38af02f95fe8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bc78fc24d57a3b2e$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f37a38af02f95fe8$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $f37a38af02f95fe8$var$_extends({}, state, {
        errors: $f37a38af02f95fe8$var$deserializeErrors(state.errors)
    });
    return state;
}
function $f37a38af02f95fe8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1ea4a0cb853f5c10$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $f37a38af02f95fe8$export$7ad602f0e94e62d1 = /*#__PURE__*/ $2WGWz.createContext({
    isTransitioning: false
});
const $f37a38af02f95fe8$export$148fd98d095596d4 = /*#__PURE__*/ $2WGWz.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f37a38af02f95fe8$var$START_TRANSITION = "startTransition";
const $f37a38af02f95fe8$var$startTransitionImpl = $2WGWz[$f37a38af02f95fe8$var$START_TRANSITION];
const $f37a38af02f95fe8$var$FLUSH_SYNC = "flushSync";
const $f37a38af02f95fe8$var$flushSyncImpl = $9Np2q[$f37a38af02f95fe8$var$FLUSH_SYNC];
const $f37a38af02f95fe8$var$USE_ID = "useId";
const $f37a38af02f95fe8$var$useIdImpl = $2WGWz[$f37a38af02f95fe8$var$USE_ID];
function $f37a38af02f95fe8$var$startTransitionSafe(cb) {
    if ($f37a38af02f95fe8$var$startTransitionImpl) $f37a38af02f95fe8$var$startTransitionImpl(cb);
    else cb();
}
function $f37a38af02f95fe8$var$flushSyncSafe(cb) {
    if ($f37a38af02f95fe8$var$flushSyncImpl) $f37a38af02f95fe8$var$flushSyncImpl(cb);
    else cb();
}
class $f37a38af02f95fe8$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f37a38af02f95fe8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $2WGWz.useState(router.state);
    let [pendingState, setPendingState] = $2WGWz.useState();
    let [vtContext, setVtContext] = $2WGWz.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $2WGWz.useState();
    let [transition, setTransition] = $2WGWz.useState();
    let [interruption, setInterruption] = $2WGWz.useState();
    let fetcherData = $2WGWz.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $2WGWz.useCallback((cb)=>{
        if (v7_startTransition) $f37a38af02f95fe8$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $2WGWz.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $f37a38af02f95fe8$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $f37a38af02f95fe8$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $f37a38af02f95fe8$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $f37a38af02f95fe8$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $f37a38af02f95fe8$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $2WGWz.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $2WGWz.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $f37a38af02f95fe8$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $2WGWz.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $2WGWz.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $2WGWz.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $2WGWz.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $2WGWz.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2WGWz.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $2WGWz.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $2WGWz.useEffect(()=>(0, $bc78fc24d57a3b2e$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2WGWz.createElement($2WGWz.Fragment, null, /*#__PURE__*/ $2WGWz.createElement((0, $bc78fc24d57a3b2e$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2WGWz.createElement((0, $bc78fc24d57a3b2e$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $2WGWz.createElement($f37a38af02f95fe8$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $2WGWz.createElement($f37a38af02f95fe8$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $2WGWz.createElement((0, $bc78fc24d57a3b2e$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $2WGWz.createElement($f37a38af02f95fe8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $f37a38af02f95fe8$var$MemoizedDataRoutes = /*#__PURE__*/ $2WGWz.memo($f37a38af02f95fe8$var$DataRoutes);
function $f37a38af02f95fe8$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $bc78fc24d57a3b2e$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $f37a38af02f95fe8$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $2WGWz.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ea4a0cb853f5c10$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2WGWz.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2WGWz.useCallback((newState)=>{
        v7_startTransition && $f37a38af02f95fe8$var$startTransitionImpl ? $f37a38af02f95fe8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2WGWz.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2WGWz.useEffect(()=>(0, $bc78fc24d57a3b2e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $2WGWz.createElement((0, $bc78fc24d57a3b2e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $f37a38af02f95fe8$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $2WGWz.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ea4a0cb853f5c10$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2WGWz.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2WGWz.useCallback((newState)=>{
        v7_startTransition && $f37a38af02f95fe8$var$startTransitionImpl ? $f37a38af02f95fe8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2WGWz.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2WGWz.useEffect(()=>(0, $bc78fc24d57a3b2e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $2WGWz.createElement((0, $bc78fc24d57a3b2e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $f37a38af02f95fe8$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $2WGWz.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $2WGWz.useCallback((newState)=>{
        v7_startTransition && $f37a38af02f95fe8$var$startTransitionImpl ? $f37a38af02f95fe8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $2WGWz.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $2WGWz.useEffect(()=>(0, $bc78fc24d57a3b2e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $2WGWz.createElement((0, $bc78fc24d57a3b2e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $f37a38af02f95fe8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $f37a38af02f95fe8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $f37a38af02f95fe8$export$a6c7ac8248d6e38a = /*#__PURE__*/ $2WGWz.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $f37a38af02f95fe8$var$_objectWithoutPropertiesLoose(_ref7, $f37a38af02f95fe8$var$_excluded);
    let { basename: basename } = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $f37a38af02f95fe8$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($f37a38af02f95fe8$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $bc78fc24d57a3b2e$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $f37a38af02f95fe8$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $2WGWz.createElement("a", $f37a38af02f95fe8$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $f37a38af02f95fe8$export$b0d92dbee9b5b60d = /*#__PURE__*/ $2WGWz.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $f37a38af02f95fe8$var$_objectWithoutPropertiesLoose(_ref8, $f37a38af02f95fe8$var$_excluded2);
    let path = (0, $bc78fc24d57a3b2e$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    let routerState = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f37a38af02f95fe8$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $2WGWz.createElement($f37a38af02f95fe8$export$a6c7ac8248d6e38a, $f37a38af02f95fe8$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $f37a38af02f95fe8$export$a7fed597f4b8afd8 = /*#__PURE__*/ $2WGWz.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $f37a38af02f95fe8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $f37a38af02f95fe8$var$_objectWithoutPropertiesLoose(_ref9, $f37a38af02f95fe8$var$_excluded3);
    let submit = $f37a38af02f95fe8$export$47c85c6e3a081d3();
    let formAction = $f37a38af02f95fe8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $2WGWz.createElement("form", $f37a38af02f95fe8$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $f37a38af02f95fe8$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $f37a38af02f95fe8$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $f37a38af02f95fe8$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($f37a38af02f95fe8$var$DataRouterHook || ($f37a38af02f95fe8$var$DataRouterHook = {}));
var $f37a38af02f95fe8$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($f37a38af02f95fe8$var$DataRouterStateHook || ($f37a38af02f95fe8$var$DataRouterStateHook = {}));
// Internal hooks
function $f37a38af02f95fe8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $f37a38af02f95fe8$var$useDataRouterContext(hookName) {
    let ctx = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$3add0d5dce533e2e));
    !ctx && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f37a38af02f95fe8$var$useDataRouterState(hookName) {
    let state = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$145dfa71566a64dc));
    !state && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $f37a38af02f95fe8$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $bc78fc24d57a3b2e$export$9770f232ac06a008)();
    let location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    let path = (0, $bc78fc24d57a3b2e$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $2WGWz.useCallback((event)=>{
        if ($f37a38af02f95fe8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1ea4a0cb853f5c10$export$fe53371bee54353d)(location) === (0, $1ea4a0cb853f5c10$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $f37a38af02f95fe8$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $2WGWz.useRef($f37a38af02f95fe8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $2WGWz.useRef(false);
    let location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    let searchParams = $2WGWz.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $f37a38af02f95fe8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $bc78fc24d57a3b2e$export$9770f232ac06a008)();
    let setSearchParams = $2WGWz.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $f37a38af02f95fe8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $f37a38af02f95fe8$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $f37a38af02f95fe8$var$fetcherId = 0;
let $f37a38af02f95fe8$var$getUniqueFetcherId = ()=>"__" + String(++$f37a38af02f95fe8$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $f37a38af02f95fe8$export$47c85c6e3a081d3() {
    let { router: router } = $f37a38af02f95fe8$var$useDataRouterContext($f37a38af02f95fe8$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$26749e8557646306));
    let currentRouteId = (0, $bc78fc24d57a3b2e$export$5fc8298006ad9e58)();
    return $2WGWz.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $f37a38af02f95fe8$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f37a38af02f95fe8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $f37a38af02f95fe8$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $f37a38af02f95fe8$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$26749e8557646306));
    let routeContext = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$9072aa6dd1f93057));
    !routeContext && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $f37a38af02f95fe8$var$_extends({}, (0, $bc78fc24d57a3b2e$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ea4a0cb853f5c10$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1ea4a0cb853f5c10$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $f37a38af02f95fe8$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $f37a38af02f95fe8$var$useDataRouterContext($f37a38af02f95fe8$var$DataRouterHook.UseFetcher);
    let state = $f37a38af02f95fe8$var$useDataRouterState($f37a38af02f95fe8$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $2WGWz.useContext($f37a38af02f95fe8$export$148fd98d095596d4);
    let route = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    !route && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $f37a38af02f95fe8$var$useIdImpl ? $f37a38af02f95fe8$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $2WGWz.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($f37a38af02f95fe8$var$getUniqueFetcherId());
    // Registration/cleanup
    $2WGWz.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $2WGWz.useCallback((href, opts)=>{
        !routeId && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $f37a38af02f95fe8$export$47c85c6e3a081d3();
    let submit = $2WGWz.useCallback((target, opts)=>{
        submitImpl(target, $f37a38af02f95fe8$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $2WGWz.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $2WGWz.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $2WGWz.createElement($f37a38af02f95fe8$export$a7fed597f4b8afd8, $f37a38af02f95fe8$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1ea4a0cb853f5c10$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $2WGWz.useMemo(()=>$f37a38af02f95fe8$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $f37a38af02f95fe8$export$fa996778a3a31087() {
    let state = $f37a38af02f95fe8$var$useDataRouterState($f37a38af02f95fe8$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $f37a38af02f95fe8$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $f37a38af02f95fe8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $f37a38af02f95fe8$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $f37a38af02f95fe8$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $f37a38af02f95fe8$var$useDataRouterContext($f37a38af02f95fe8$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f37a38af02f95fe8$var$useDataRouterState($f37a38af02f95fe8$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $2WGWz.useContext((0, $bc78fc24d57a3b2e$export$26749e8557646306));
    let location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    let matches = (0, $bc78fc24d57a3b2e$export$2378eb7f5ff86053)();
    let navigation = (0, $bc78fc24d57a3b2e$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $2WGWz.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $f37a38af02f95fe8$var$usePageHide($2WGWz.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $f37a38af02f95fe8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f37a38af02f95fe8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f37a38af02f95fe8$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2WGWz.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f37a38af02f95fe8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f37a38af02f95fe8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2WGWz.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($f37a38af02f95fe8$var$_extends({}, location, {
                    pathname: (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($f37a38af02f95fe8$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2WGWz.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f37a38af02f95fe8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $2WGWz.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f37a38af02f95fe8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $2WGWz.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $f37a38af02f95fe8$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $bc78fc24d57a3b2e$export$b273b3273281a049)(when);
    $2WGWz.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $2WGWz.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $f37a38af02f95fe8$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $2WGWz.useContext($f37a38af02f95fe8$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1ea4a0cb853f5c10$export$3e9cee6b33872309)(false);
    let { basename: basename } = $f37a38af02f95fe8$var$useDataRouterContext($f37a38af02f95fe8$var$DataRouterHook.useViewTransitionState);
    let path = (0, $bc78fc24d57a3b2e$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1ea4a0cb853f5c10$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1ea4a0cb853f5c10$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1ea4a0cb853f5c10$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


const $bd664d6ef1f52408$export$9bd698419030e459 = ({ movie: movie, isFavorite: isFavorite, onToggleFavorite: onToggleFavorite })=>{
    const handleToggleFavorite = (e)=>{
        e.preventDefault(); // Prevent navigation when clicking the button
        e.stopPropagation(); // Stop event propagation
        if (onToggleFavorite && movie && movie.id) onToggleFavorite(movie.id);
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039), {
        className: "h-100 p-5 p-md-3 d-flex flex-column flex-md-row align-items-center border border-secondary card--movie",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                to: `/movies/${movie.id}`,
                className: "card__image",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Img, {
                        variant: "top",
                        src: movie.image,
                        alt: `${movie.title} movie poster`
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                        className: "visually-hidden",
                        children: [
                            "link to ",
                            movie.title,
                            " info page"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Title, {
                        className: "card__title text-light",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                            to: `/movies/${movie.id}`,
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h4", {
                                children: movie.title
                            })
                        })
                    }),
                    onToggleFavorite && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5489e531a8951c51$export$2e2bcd8739ae039), {
                            placement: "top",
                            overlay: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $9e73697666d1eda6$export$2e2bcd8739ae039), {
                                className: isFavorite ? 'favorite__tooltip favorite__tooltip--remove' : 'favorite__tooltip favorite__tooltip--add',
                                children: isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                            }),
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                className: "mt-2 border-0 bg-transparent favorite__button",
                                onClick: handleToggleFavorite,
                                children: [
                                    isFavorite ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                        })
                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                            d: "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                        className: "visually-hidden",
                                        children: isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                                    })
                                ]
                            })
                        }, "top")
                    })
                ]
            })
        ]
    });
};
$bd664d6ef1f52408$export$9bd698419030e459.propTypes = {
    movie: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
    }).isRequired,
    isFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    onToggleFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func
};







var $2WGWz = parcelRequire("2WGWz");


"use client";
function $7b6fb2806cf807bb$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $9283c6e4393bcc4e$export$8970c8db816a5863)();
    const minBreakpoint = (0, $9283c6e4393bcc4e$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $7b6fb2806cf807bb$var$Col = /*#__PURE__*/ $2WGWz.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $7b6fb2806cf807bb$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, !spans.length && bsPrefix)
    });
});
$7b6fb2806cf807bb$var$Col.displayName = 'Col';
var $7b6fb2806cf807bb$export$2e2bcd8739ae039 = $7b6fb2806cf807bb$var$Col;



var $2WGWz = parcelRequire("2WGWz");


"use client";
const $f7a0f00c5207df04$var$Row = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $9283c6e4393bcc4e$export$8970c8db816a5863)();
    const minBreakpoint = (0, $9283c6e4393bcc4e$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$f7a0f00c5207df04$var$Row.displayName = 'Row';
var $f7a0f00c5207df04$export$2e2bcd8739ae039 = $f7a0f00c5207df04$var$Row;



const $e5ff383576b0e9ff$export$78d497080ea8f89a = ({ movies: movies, isMovieFavorite: isMovieFavorite, onToggleFavorite: onToggleFavorite })=>{
    const { movieId: movieId } = (0, $bc78fc24d57a3b2e$export$99eaa27ddbbb95ef)();
    if (!movieId || !movies || movies.length === 0) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
        children: "Loading..."
    });
    const movie = movies.find((m)=>m.id === movieId);
    if (!movie) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
        children: "Movie not found"
    });
    const isFavorite = isMovieFavorite(movieId);
    const similarMovies = movies.filter((m)=>m.genre === movie.genre && m.id !== movie.id);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                md: 10,
                lg: 8,
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039), {
                    className: "card--movieview",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Header, {
                            className: "d-flex justify-content-between align-items-center border-bottom border-secondary  mb-4 pb-4 card--movieview__header",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                        variant: "outline-primary",
                                        children: "Back to Movies list"
                                    })
                                }),
                                onToggleFavorite && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5489e531a8951c51$export$2e2bcd8739ae039), {
                                        placement: "top",
                                        overlay: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $9e73697666d1eda6$export$2e2bcd8739ae039), {
                                            className: isFavorite ? 'favorite__tooltip favorite__tooltip--remove' : 'favorite__tooltip favorite__tooltip--add',
                                            children: isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                                        }),
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                            className: "border-0 bg-transparent favorite__button",
                                            onClick: ()=>onToggleFavorite(movieId),
                                            children: [
                                                isFavorite ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    viewBox: "0 0 16 16",
                                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                                    })
                                                }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    viewBox: "0 0 16 16",
                                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                        d: "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                                    className: "visually-hidden",
                                                    children: isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                                                })
                                            ]
                                        })
                                    }, "top")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Body, {
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                                className: "justify-content-center",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                        md: 4,
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Img, {
                                            variant: "top",
                                            src: movie.image,
                                            alt: movie.title,
                                            className: "mb-5 mb-md-0 card--movieview__image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                        md: 8,
                                        children: [
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Title, {
                                                className: "card--movieview__title h1",
                                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h1", {
                                                    children: movie.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Text, {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                                        children: "Director:"
                                                    }),
                                                    " ",
                                                    movie.director
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Text, {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                                        children: "Genre:"
                                                    }),
                                                    " ",
                                                    movie.genre
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Text, {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                                        children: "Description:"
                                                    }),
                                                    " ",
                                                    movie.description
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Text, {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                                        children: "Actors:"
                                                    }),
                                                    ' ',
                                                    Array.isArray(movie.actors) ? movie.actors.join(', ') : movie.actors
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            similarMovies.length > 0 && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                className: "mt-4 mb-5 col-12 similar-movies",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                        className: "border-bottom border-secondary mb-5",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                            className: "col-10 mx-auto mx-md-0 text-center text-md-start pb-3",
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("h4", {
                                children: [
                                    "Other movies in the genre ",
                                    movie.genre,
                                    ":"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                        children: similarMovies.map((similarMovie)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                md: 4,
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bd664d6ef1f52408$export$9bd698419030e459), {
                                    movie: similarMovie,
                                    isFavorite: isMovieFavorite(similarMovie.id),
                                    onToggleFavorite: onToggleFavorite
                                })
                            }, similarMovie.id))
                    })
                ]
            })
        ]
    });
};
$e5ff383576b0e9ff$export$78d497080ea8f89a.propTypes = {
    movies: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        director: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        genre: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string.isRequired,
        actors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string),
            (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
        ]).isRequired
    })).isRequired,
    isMovieFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func.isRequired,
    onToggleFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func.isRequired
};




var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");




"use client";
const $277e98d5cdd252df$var$DivStyledAsH4 = (0, $b9f90237085a60cc$export$2e2bcd8739ae039)('h4');
$277e98d5cdd252df$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $277e98d5cdd252df$var$AlertHeading = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $277e98d5cdd252df$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$277e98d5cdd252df$var$AlertHeading.displayName = 'AlertHeading';
var $277e98d5cdd252df$export$2e2bcd8739ae039 = $277e98d5cdd252df$var$AlertHeading;



var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");

function $997b6ee9c3b49856$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $32770ad027b0258a$export$2e2bcd8739ae039)(listener);
    (0, $2WGWz.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $2WGWz = parcelRequire("2WGWz");
function $2b351fe80e624578$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $2WGWz.useCallback)(()=>document, []);
    return (0, $997b6ee9c3b49856$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $2WGWz = parcelRequire("2WGWz");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $3c9c30fa73444234$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $1f09aa616755b094$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $1f09aa616755b094$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $2WGWz.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $3c9c30fa73444234$export$2e2bcd8739ae039 = $3c9c30fa73444234$var$useInterval;



var $2WGWz = parcelRequire("2WGWz");

function $246c3704c9a9d73d$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $1f09aa616755b094$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $1f09aa616755b094$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $2WGWz.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $246c3704c9a9d73d$export$2e2bcd8739ae039 = $246c3704c9a9d73d$var$useRafInterval;



var $2WGWz = parcelRequire("2WGWz");
function $6086b46458f9ceb2$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $2WGWz.useState)(initialState);
    const updater = (0, $2WGWz.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $828a3a0235be5dfa$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $6086b46458f9ceb2$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}




var $2WGWz = parcelRequire("2WGWz");
function $41a205d58d928501$export$2e2bcd8739ae039(value) {
    const ref = (0, $2WGWz.useRef)(null);
    (0, $2WGWz.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $2WGWz = parcelRequire("2WGWz");
function $3920cabdfde4ee66$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $2WGWz.useState)({
        image: null,
        error: null
    });
    (0, $2WGWz.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $2WGWz = parcelRequire("2WGWz");

const $fc9c63fac2402d56$var$targetMap = new WeakMap();
let $fc9c63fac2402d56$var$resizeObserver;
function $fc9c63fac2402d56$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $fc9c63fac2402d56$var$resizeObserver = $fc9c63fac2402d56$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $fc9c63fac2402d56$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $fc9c63fac2402d56$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $2WGWz.useState)(null);
    (0, $5db33268a50b3680$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $fc9c63fac2402d56$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $fc9c63fac2402d56$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $fc9c63fac2402d56$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $7746d2b26fe2313b$var$_excluded = [
    "onKeyDown"
];
function $7746d2b26fe2313b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $7746d2b26fe2313b$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $7746d2b26fe2313b$var$Anchor = /*#__PURE__*/ $2WGWz.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $7746d2b26fe2313b$var$_objectWithoutPropertiesLoose(_ref, $7746d2b26fe2313b$var$_excluded);
    const [buttonProps] = (0, $38c929f621e62455$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($7746d2b26fe2313b$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$7746d2b26fe2313b$var$Anchor.displayName = 'Anchor';
var $7746d2b26fe2313b$export$2e2bcd8739ae039 = $7746d2b26fe2313b$var$Anchor;




"use client";
const $c8f234612d401738$var$AlertLink = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $7746d2b26fe2313b$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$c8f234612d401738$var$AlertLink.displayName = 'AlertLink';
var $c8f234612d401738$export$2e2bcd8739ae039 = $c8f234612d401738$var$AlertLink;





var $2WGWz = parcelRequire("2WGWz");


const $2013d145291c2aaa$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'white'
    ])
};
const $2013d145291c2aaa$var$CloseButton = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$2013d145291c2aaa$var$CloseButton.displayName = 'CloseButton';
$2013d145291c2aaa$var$CloseButton.propTypes = $2013d145291c2aaa$var$propTypes;
var $2013d145291c2aaa$export$2e2bcd8739ae039 = $2013d145291c2aaa$var$CloseButton;



"use client";
const $ed47a6884294d0a8$var$Alert = /*#__PURE__*/ $2WGWz.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039), ...props } = (0, $feb65fa3eb9d2358$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $2e552e42661327c8$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2013d145291c2aaa$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$ed47a6884294d0a8$var$Alert.displayName = 'Alert';
var $ed47a6884294d0a8$export$2e2bcd8739ae039 = Object.assign($ed47a6884294d0a8$var$Alert, {
    Link: (0, $c8f234612d401738$export$2e2bcd8739ae039),
    Heading: (0, $277e98d5cdd252df$export$2e2bcd8739ae039)
});




var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");


const $43328c2cd85acaf4$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $43328c2cd85acaf4$var$Feedback = /*#__PURE__*/ $2WGWz.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$43328c2cd85acaf4$var$Feedback.displayName = 'Feedback';
$43328c2cd85acaf4$var$Feedback.propTypes = $43328c2cd85acaf4$var$propTypes;
var $43328c2cd85acaf4$export$2e2bcd8739ae039 = $43328c2cd85acaf4$var$Feedback;




var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
"use client";
// TODO
const $3170b156f6acc54d$var$FormContext = /*#__PURE__*/ $2WGWz.createContext({});
var $3170b156f6acc54d$export$2e2bcd8739ae039 = $3170b156f6acc54d$var$FormContext;




"use client";
const $5eb836c9b2ed74bf$var$FormCheckInput = /*#__PURE__*/ $2WGWz.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$5eb836c9b2ed74bf$var$FormCheckInput.displayName = 'FormCheckInput';
var $5eb836c9b2ed74bf$export$2e2bcd8739ae039 = $5eb836c9b2ed74bf$var$FormCheckInput;




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $3bfa3ddf1a0345f9$var$FormCheckLabel = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$3bfa3ddf1a0345f9$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $3bfa3ddf1a0345f9$export$2e2bcd8739ae039 = $3bfa3ddf1a0345f9$var$FormCheckLabel;





var $2WGWz = parcelRequire("2WGWz");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $38bf987037faea8a$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $2WGWz.Children.map(children, (child)=>/*#__PURE__*/ $2WGWz.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $38bf987037faea8a$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $2WGWz.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $2WGWz.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $38bf987037faea8a$export$500fd6099226ffae(children, type) {
    return $2WGWz.Children.toArray(children).some((child)=>/*#__PURE__*/ $2WGWz.isValidElement(child) && child.type === type);
}



"use client";
const $74860b4596facc8c$var$FormCheck = /*#__PURE__*/ $2WGWz.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    const innerFormContext = (0, $2WGWz.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $38bf987037faea8a$export$500fd6099226ffae)(children, (0, $3bfa3ddf1a0345f9$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5eb836c9b2ed74bf$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $3170b156f6acc54d$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $3bfa3ddf1a0345f9$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $43328c2cd85acaf4$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$74860b4596facc8c$var$FormCheck.displayName = 'FormCheck';
var $74860b4596facc8c$export$2e2bcd8739ae039 = Object.assign($74860b4596facc8c$var$FormCheck, {
    Input: (0, $5eb836c9b2ed74bf$export$2e2bcd8739ae039),
    Label: (0, $3bfa3ddf1a0345f9$export$2e2bcd8739ae039)
});




var $2WGWz = parcelRequire("2WGWz");





"use client";
const $cdd4c0ff30700226$var$FormControl = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$cdd4c0ff30700226$var$FormControl.displayName = 'FormControl';
var $cdd4c0ff30700226$export$2e2bcd8739ae039 = Object.assign($cdd4c0ff30700226$var$FormControl, {
    Feedback: $43328c2cd85acaf4$export$2e2bcd8739ae039
});



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $ab610119308fdf0d$var$FormFloating = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$ab610119308fdf0d$var$FormFloating.displayName = 'FormFloating';
var $ab610119308fdf0d$export$2e2bcd8739ae039 = $ab610119308fdf0d$var$FormFloating;



var $2WGWz = parcelRequire("2WGWz");


const $47a7d51d1e609c3a$var$FormGroup = /*#__PURE__*/ $2WGWz.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $2WGWz.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $3170b156f6acc54d$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$47a7d51d1e609c3a$var$FormGroup.displayName = 'FormGroup';
var $47a7d51d1e609c3a$export$2e2bcd8739ae039 = $47a7d51d1e609c3a$var$FormGroup;




var $2WGWz = parcelRequire("2WGWz");





"use client";
const $a7a23308050e94a6$var$FormLabel = /*#__PURE__*/ $2WGWz.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$a7a23308050e94a6$var$FormLabel.displayName = 'FormLabel';
var $a7a23308050e94a6$export$2e2bcd8739ae039 = $a7a23308050e94a6$var$FormLabel;




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $3161c174d41be88a$var$FormRange = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$3161c174d41be88a$var$FormRange.displayName = 'FormRange';
var $3161c174d41be88a$export$2e2bcd8739ae039 = $3161c174d41be88a$var$FormRange;




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $9b468880e2bd4391$var$FormSelect = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $2WGWz.useContext)((0, $3170b156f6acc54d$export$2e2bcd8739ae039));
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$9b468880e2bd4391$var$FormSelect.displayName = 'FormSelect';
var $9b468880e2bd4391$export$2e2bcd8739ae039 = $9b468880e2bd4391$var$FormSelect;




var $2WGWz = parcelRequire("2WGWz");


"use client";
const $35d5f73335f5a54a$var$FormText = /*#__PURE__*/ $2WGWz.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$35d5f73335f5a54a$var$FormText.displayName = 'FormText';
var $35d5f73335f5a54a$export$2e2bcd8739ae039 = $35d5f73335f5a54a$var$FormText;



var $2WGWz = parcelRequire("2WGWz");


const $d128f7bf8d310602$var$Switch = /*#__PURE__*/ $2WGWz.forwardRef((props, ref)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $74860b4596facc8c$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$d128f7bf8d310602$var$Switch.displayName = 'Switch';
var $d128f7bf8d310602$export$2e2bcd8739ae039 = Object.assign($d128f7bf8d310602$var$Switch, {
    Input: (0, $74860b4596facc8c$export$2e2bcd8739ae039).Input,
    Label: (0, $74860b4596facc8c$export$2e2bcd8739ae039).Label
});




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $ee7472acb95e344c$var$FloatingLabel = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $47a7d51d1e609c3a$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$ee7472acb95e344c$var$FloatingLabel.displayName = 'FloatingLabel';
var $ee7472acb95e344c$export$2e2bcd8739ae039 = $ee7472acb95e344c$var$FloatingLabel;



const $5acf5ec9c6a36bea$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $5acf5ec9c6a36bea$var$Form = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, validated && 'was-validated')
    }));
$5acf5ec9c6a36bea$var$Form.displayName = 'Form';
$5acf5ec9c6a36bea$var$Form.propTypes = $5acf5ec9c6a36bea$var$propTypes;
var $5acf5ec9c6a36bea$export$2e2bcd8739ae039 = Object.assign($5acf5ec9c6a36bea$var$Form, {
    Group: (0, $47a7d51d1e609c3a$export$2e2bcd8739ae039),
    Control: (0, $cdd4c0ff30700226$export$2e2bcd8739ae039),
    Floating: (0, $ab610119308fdf0d$export$2e2bcd8739ae039),
    Check: (0, $74860b4596facc8c$export$2e2bcd8739ae039),
    Switch: $d128f7bf8d310602$export$2e2bcd8739ae039,
    Label: (0, $a7a23308050e94a6$export$2e2bcd8739ae039),
    Text: (0, $35d5f73335f5a54a$export$2e2bcd8739ae039),
    Range: (0, $3161c174d41be88a$export$2e2bcd8739ae039),
    Select: (0, $9b468880e2bd4391$export$2e2bcd8739ae039),
    FloatingLabel: $ee7472acb95e344c$export$2e2bcd8739ae039
});



var $2WGWz = parcelRequire("2WGWz");


"use client";
const $62601e8353a7b7f7$var$Spinner = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$62601e8353a7b7f7$var$Spinner.displayName = 'Spinner';
var $62601e8353a7b7f7$export$2e2bcd8739ae039 = $62601e8353a7b7f7$var$Spinner;



const $bebe1cbb5a309c8c$export$923ea8233b386e99 = 'https://flicktionary.onrender.com';


const $d379e75a95ffce01$export$1582048ca8384970 = ({ onLoggedIn: onLoggedIn })=>{
    const [username, setUsername] = (0, $2WGWz.useState)('');
    const [password, setPassword] = (0, $2WGWz.useState)('');
    const [error, setError] = (0, $2WGWz.useState)('');
    const [isLoading, setIsLoading] = (0, $2WGWz.useState)(false);
    const handleSubmit = (event)=>{
        // this prevents the default behavior of the form which is to reload the entire page
        event.preventDefault();
        setError('');
        const data = {
            Username: username,
            Password: password
        };
        setIsLoading(true);
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((response)=>response.json()).then((data)=>{
            if (data.user) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                onLoggedIn(data.user, data.token);
            } else setError('Invalid username or password');
        }).catch(()=>{
            setError('Something went wrong. Please try again.');
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: [
            error && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $ed47a6884294d0a8$export$2e2bcd8739ae039), {
                variant: "danger",
                onClose: ()=>setError(''),
                dismissible: true,
                children: error
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "d-flex justify-content-between align-items-center border-bottom border-secondary mb-4 pb-3",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h4", {
                        className: "mb-0",
                        children: "Login"
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("i", {
                                className: "me-4",
                                children: "or"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                    variant: "outline-primary",
                                    children: "Signup"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                controlId: "formUsername",
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                        className: "text-info",
                        children: "Username:"
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                        type: "text",
                        value: username,
                        onChange: (e)=>setUsername(e.target.value),
                        required: true,
                        minLength: "3",
                        className: "border-primary"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                controlId: "formPassword",
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                        className: "text-info",
                        children: "Password:"
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                        type: "password",
                        value: password,
                        onChange: (e)=>setPassword(e.target.value),
                        required: true,
                        className: "border-primary"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                variant: "primary",
                type: "submit",
                className: "btn-lg",
                disabled: isLoading,
                children: isLoading ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $62601e8353a7b7f7$export$2e2bcd8739ae039), {
                            animation: "border",
                            size: "sm",
                            className: "me-2"
                        }),
                        "Logging in..."
                    ]
                }) : 'Submit'
            })
        ]
    });
};




var $2WGWz = parcelRequire("2WGWz");



const $ad22dac456f05c19$export$25f3896ea1e09820 = ()=>{
    const [username, setUsername] = (0, $2WGWz.useState)('');
    const [password, setPassword] = (0, $2WGWz.useState)('');
    const [email, setEmail] = (0, $2WGWz.useState)('');
    const [birthday, setBirthday] = (0, $2WGWz.useState)('');
    const [error, setError] = (0, $2WGWz.useState)('');
    const [success, setSuccess] = (0, $2WGWz.useState)('');
    const [isLoading, setIsLoading] = (0, $2WGWz.useState)(false);
    const handleSubmit = (event)=>{
        event.preventDefault();
        setError('');
        setSuccess('');
        const validationErrors = [];
        if (username.length < 5) validationErrors.push('Username must be at least 5 characters long.');
        if (password.length < 8) validationErrors.push('Password must be at least 8 characters long.');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) validationErrors.push('Please enter a valid email address.');
        if (!birthday) validationErrors.push('Please enter your date of birth.');
        else {
            const birthDate = new Date(birthday);
            const today = new Date();
            const minDate = new Date('1900-01-01');
            if (birthDate > today) validationErrors.push('Date of birth cannot be in the future.');
            else if (birthDate < minDate) validationErrors.push('Please enter a valid date of birth.');
            else {
                const age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                const dayDiff = today.getDate() - birthDate.getDate();
                const actualAge = monthDiff < 0 || monthDiff === 0 && dayDiff < 0 ? age - 1 : age;
                if (actualAge < 13) validationErrors.push('You must be at least 13 years old to sign up.');
            }
        }
        if (validationErrors.length > 0) {
            setError(validationErrors.join('\n'));
            return;
        }
        const data = {
            Username: username,
            Password: password,
            Email: email,
            Birthday: birthday
        };
        setIsLoading(true);
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/users`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async (response)=>{
            if (response.ok) {
                setSuccess('Signup successful! You can now log in.');
                setUsername('');
                setPassword('');
                setEmail('');
                setBirthday('');
            } else {
                const data = await response.json().catch(()=>null);
                if (data && data.errors) {
                    const messages = data.errors.map((err)=>err.msg);
                    setError(messages.join('\n'));
                } else setError('Signup failed. Please try again.');
            }
        }).catch(()=>{
            setError('Something went wrong. Please try again.');
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: [
            error && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $ed47a6884294d0a8$export$2e2bcd8739ae039), {
                variant: "danger",
                onClose: ()=>setError(''),
                dismissible: true,
                children: error.split('\n').map((msg, i)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                        children: msg
                    }, i))
            }),
            success && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $ed47a6884294d0a8$export$2e2bcd8739ae039), {
                variant: "success",
                onClose: ()=>setSuccess(''),
                dismissible: true,
                children: [
                    success,
                    " ",
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        children: "Go to Login"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        className: "col-12 d-flex justify-content-between align-items-center border-bottom border-secondary mb-4 pb-3",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h4", {
                                className: "mb-0",
                                children: "Signup"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("i", {
                                        className: "me-4",
                                        children: "or"
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                            variant: "outline-primary",
                                            children: "Login"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                            controlId: "formUsername",
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                    className: "text-info",
                                    children: "Username:"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    value: username,
                                    onChange: (e)=>setUsername(e.target.value),
                                    required: true,
                                    minLength: "5",
                                    className: "border-primary"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Text, {
                                    className: "text-muted",
                                    children: "Must be 5 or more characters"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                            controlId: "formPassword",
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                    className: "text-info",
                                    children: "Password:"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                    type: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value),
                                    className: "border-primary",
                                    required: true,
                                    minLength: "8"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Text, {
                                    className: "text-muted",
                                    children: "Must be 8 or more characters, including uppercase, lowercase, numbers, and special characters (!@#$%^&*-_=+;:,.)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                            controlId: "formEmail",
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                    className: "text-info",
                                    children: "Email:"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    className: "border-primary",
                                    required: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                            controlId: "formBirthday",
                            className: "mb-5",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                    className: "text-info",
                                    children: "Birthday:"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                    type: "date",
                                    value: birthday,
                                    onChange: (e)=>setBirthday(e.target.value),
                                    className: "border-primary",
                                    required: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                            variant: "primary",
                            type: "submit",
                            className: "btn-lg",
                            disabled: isLoading,
                            children: isLoading ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $62601e8353a7b7f7$export$2e2bcd8739ae039), {
                                        animation: "border",
                                        size: "sm",
                                        className: "me-2"
                                    }),
                                    "Signing up..."
                                ]
                            }) : 'Submit'
                        })
                    })
                ]
            })
        ]
    });
};





var $2WGWz = parcelRequire("2WGWz");


"use client";
const $a36e27a345dec7d9$var$Container = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$a36e27a345dec7d9$var$Container.displayName = 'Container';
var $a36e27a345dec7d9$export$2e2bcd8739ae039 = $a36e27a345dec7d9$var$Container;



var $2WGWz = parcelRequire("2WGWz");

var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}



var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
function $6b736bee1bb7963c$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $2WGWz.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}




var $2WGWz = parcelRequire("2WGWz");
const $a438abfe3ab0e48d$var$NavContext = /*#__PURE__*/ $2WGWz.createContext(null);
$a438abfe3ab0e48d$var$NavContext.displayName = 'NavContext';
var $a438abfe3ab0e48d$export$2e2bcd8739ae039 = $a438abfe3ab0e48d$var$NavContext;



var $2WGWz = parcelRequire("2WGWz");
const $2e59cc438e3c9bb4$var$SelectableContext = /*#__PURE__*/ $2WGWz.createContext(null);
const $2e59cc438e3c9bb4$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $2e59cc438e3c9bb4$export$2e2bcd8739ae039 = $2e59cc438e3c9bb4$var$SelectableContext;



var $2WGWz = parcelRequire("2WGWz");
const $4a2b068daec70d7e$var$TabContext = /*#__PURE__*/ $2WGWz.createContext(null);
var $4a2b068daec70d7e$export$2e2bcd8739ae039 = $4a2b068daec70d7e$var$TabContext;


const $5e9f242c0e76071e$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $5e9f242c0e76071e$export$635202801f9383a0 = `rrUi`;
function $5e9f242c0e76071e$export$5cc3b7b83e34ade7(property) {
    return `${$5e9f242c0e76071e$export$fd7bcb7e9bef4e8a}${property}`;
}
function $5e9f242c0e76071e$export$7776c0a7cd2eb3e0(property) {
    return `${$5e9f242c0e76071e$export$635202801f9383a0}${property}`;
}



var $2WGWz = parcelRequire("2WGWz");







const $45126291df1b24e3$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $45126291df1b24e3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $45126291df1b24e3$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $2WGWz.useContext)((0, $2e59cc438e3c9bb4$export$2e2bcd8739ae039));
    const navContext = (0, $2WGWz.useContext)((0, $a438abfe3ab0e48d$export$2e2bcd8739ae039));
    const tabContext = (0, $2WGWz.useContext)((0, $4a2b068daec70d7e$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $5e9f242c0e76071e$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $45126291df1b24e3$var$NavItem = /*#__PURE__*/ $2WGWz.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $38c929f621e62455$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $45126291df1b24e3$var$_objectWithoutPropertiesLoose(_ref, $45126291df1b24e3$var$_excluded);
    const [props, meta] = $45126291df1b24e3$export$d7a68693710982a(Object.assign({
        key: (0, $2e59cc438e3c9bb4$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $5e9f242c0e76071e$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$45126291df1b24e3$var$NavItem.displayName = 'NavItem';
var $45126291df1b24e3$export$2e2bcd8739ae039 = $45126291df1b24e3$var$NavItem;



const $627329c838895fe8$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $627329c838895fe8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $627329c838895fe8$var$noop = ()=>{};
const $627329c838895fe8$var$EVENT_KEY_ATTR = (0, $5e9f242c0e76071e$export$5cc3b7b83e34ade7)('event-key');
const $627329c838895fe8$var$Nav = /*#__PURE__*/ $2WGWz.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $627329c838895fe8$var$_objectWithoutPropertiesLoose(_ref, $627329c838895fe8$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $6b736bee1bb7963c$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $2WGWz.useRef)(false);
    const parentOnSelect = (0, $2WGWz.useContext)((0, $2e59cc438e3c9bb4$export$2e2bcd8739ae039));
    const tabContext = (0, $2WGWz.useContext)((0, $4a2b068daec70d7e$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $2WGWz.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(currentListNode, `[${$627329c838895fe8$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $5e9f242c0e76071e$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $2WGWz.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$627329c838895fe8$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $b38984c70268c255$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2e59cc438e3c9bb4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a438abfe3ab0e48d$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $2e59cc438e3c9bb4$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $627329c838895fe8$var$noop,
                getControllerId: getControllerId || $627329c838895fe8$var$noop
            },
            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$627329c838895fe8$var$Nav.displayName = 'Nav';
var $627329c838895fe8$export$2e2bcd8739ae039 = Object.assign($627329c838895fe8$var$Nav, {
    Item: (0, $45126291df1b24e3$export$2e2bcd8739ae039)
});




var $2WGWz = parcelRequire("2WGWz");
"use client";
// TODO: check
const $9c5a82b8e41dbb5a$var$context = /*#__PURE__*/ $2WGWz.createContext(null);
$9c5a82b8e41dbb5a$var$context.displayName = 'NavbarContext';
var $9c5a82b8e41dbb5a$export$2e2bcd8739ae039 = $9c5a82b8e41dbb5a$var$context;




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $4027ad56e8687859$var$NavItem = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$4027ad56e8687859$var$NavItem.displayName = 'NavItem';
var $4027ad56e8687859$export$2e2bcd8739ae039 = $4027ad56e8687859$var$NavItem;




var $2WGWz = parcelRequire("2WGWz");





"use client";
const $56015db8f860d1c9$var$NavLink = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $7746d2b26fe2313b$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $45126291df1b24e3$export$d7a68693710982a)({
        key: (0, $2e59cc438e3c9bb4$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$56015db8f860d1c9$var$NavLink.displayName = 'NavLink';
var $56015db8f860d1c9$export$2e2bcd8739ae039 = $56015db8f860d1c9$var$NavLink;



"use client";
const $abfaa45d828ede32$var$Nav = /*#__PURE__*/ $2WGWz.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $feb65fa3eb9d2358$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $2WGWz.useContext)((0, $9c5a82b8e41dbb5a$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $2WGWz.useContext)((0, $89976a14c022d99d$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $627329c838895fe8$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$abfaa45d828ede32$var$Nav.displayName = 'Nav';
var $abfaa45d828ede32$export$2e2bcd8739ae039 = Object.assign($abfaa45d828ede32$var$Nav, {
    Item: (0, $4027ad56e8687859$export$2e2bcd8739ae039),
    Link: (0, $56015db8f860d1c9$export$2e2bcd8739ae039)
});



var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");


"use client";
const $c26f83f6068d38a0$var$NavbarBrand = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$c26f83f6068d38a0$var$NavbarBrand.displayName = 'NavbarBrand';
var $c26f83f6068d38a0$export$2e2bcd8739ae039 = $c26f83f6068d38a0$var$NavbarBrand;



var $2WGWz = parcelRequire("2WGWz");



var $2WGWz = parcelRequire("2WGWz");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $273c300b0b4a052e$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $273c300b0b4a052e$export$2e2bcd8739ae039 = $273c300b0b4a052e$var$createChainedFunction;





const $ba57e55fa87e3d70$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $ba57e55fa87e3d70$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $ba57e55fa87e3d70$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $ba57e55fa87e3d70$var$collapseStyles = {
    [(0, $dcf47152d49f7679$export$84cbff306f539230)]: 'collapse',
    [(0, $dcf47152d49f7679$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $dcf47152d49f7679$export$df38205c966be359)]: 'collapsing',
    [(0, $dcf47152d49f7679$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $ba57e55fa87e3d70$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $ba57e55fa87e3d70$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $2WGWz.useMemo)(()=>(0, $273c300b0b4a052e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $2WGWz.useMemo)(()=>(0, $273c300b0b4a052e$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $2WGWz.useMemo)(()=>(0, $273c300b0b4a052e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $2WGWz.useMemo)(()=>(0, $273c300b0b4a052e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $ece0fef539b40514$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $2WGWz.useMemo)(()=>(0, $273c300b0b4a052e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $980b3c7829c29a12$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a7c5e041381e39e9$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $c132b796c65a883a$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, $ba57e55fa87e3d70$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$ba57e55fa87e3d70$var$Collapse.displayName = 'Collapse';
var $ba57e55fa87e3d70$export$2e2bcd8739ae039 = $ba57e55fa87e3d70$var$Collapse;





"use client";
const $50f6bc170e6ee6af$var$NavbarCollapse = /*#__PURE__*/ $2WGWz.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $2WGWz.useContext)((0, $9c5a82b8e41dbb5a$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $ba57e55fa87e3d70$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$50f6bc170e6ee6af$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $50f6bc170e6ee6af$export$2e2bcd8739ae039 = $50f6bc170e6ee6af$var$NavbarCollapse;




var $2WGWz = parcelRequire("2WGWz");




"use client";
const $dc772481037468de$var$NavbarToggle = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $2WGWz.useContext)((0, $9c5a82b8e41dbb5a$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $2e552e42661327c8$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$dc772481037468de$var$NavbarToggle.displayName = 'NavbarToggle';
var $dc772481037468de$export$2e2bcd8739ae039 = $dc772481037468de$var$NavbarToggle;



var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");
const $d2757b7dc49e017f$var$matchersByWindow = new WeakMap();
const $d2757b7dc49e017f$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $d2757b7dc49e017f$var$matchersByWindow.get(targetWindow) || new Map();
    $d2757b7dc49e017f$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $d2757b7dc49e017f$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $d2757b7dc49e017f$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $2WGWz.useState)(()=>mql ? mql.matches : false);
    (0, $cc67bff9c4584725$export$2e2bcd8739ae039)(()=>{
        let mql = $d2757b7dc49e017f$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $d2757b7dc49e017f$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $2WGWz = parcelRequire("2WGWz");
function $67f1d735200f89b2$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $2WGWz.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $d2757b7dc49e017f$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $67f1d735200f89b2$var$useBreakpoint = $67f1d735200f89b2$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $67f1d735200f89b2$export$2e2bcd8739ae039 = $67f1d735200f89b2$var$useBreakpoint;




var $2WGWz = parcelRequire("2WGWz");

function $7928c6e4d5223063$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");


var $2WGWz = parcelRequire("2WGWz");
function $dc5b4329e1849b1e$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $2WGWz.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $2WGWz = parcelRequire("2WGWz");
function $725073d4a3b70c67$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $dc5b4329e1849b1e$export$2e2bcd8739ae039)(fn);
    (0, $2WGWz.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $dee783110a450507$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $1167437827852ac1$export$1a88c12b8b979fa0 = (0, $5e9f242c0e76071e$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $1167437827852ac1$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $dee783110a450507$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($1167437827852ac1$export$1a88c12b8b979fa0, '');
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($1167437827852ac1$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $1167437827852ac1$export$2e2bcd8739ae039 = $1167437827852ac1$var$ModalManager;







const $0c3f916573cc6696$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0c3f916573cc6696$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $0c3f916573cc6696$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $0c3f916573cc6696$var$getManager(window) {
    if (!$0c3f916573cc6696$var$manager) $0c3f916573cc6696$var$manager = new (0, $1167437827852ac1$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0c3f916573cc6696$var$manager;
}
function $0c3f916573cc6696$var$useModalManager(provided) {
    const window = (0, $2e6f3a6bd4973324$export$2e2bcd8739ae039)();
    const modalManager = provided || $0c3f916573cc6696$var$getManager(window);
    const modal = (0, $2WGWz.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $2WGWz.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $2WGWz.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0c3f916573cc6696$var$Modal = /*#__PURE__*/ (0, $2WGWz.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $0c3f916573cc6696$var$_objectWithoutPropertiesLoose(_ref, $0c3f916573cc6696$var$_excluded);
    const ownerWindow = (0, $2e6f3a6bd4973324$export$2e2bcd8739ae039)();
    const container = (0, $ccbe49e7055777dd$export$2e2bcd8739ae039)(containerRef);
    const modal = $0c3f916573cc6696$var$useModalManager(providedManager);
    const isMounted = (0, $54f0a492ad063b1e$export$2e2bcd8739ae039)();
    const prevShow = (0, $41a205d58d928501$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $2WGWz.useState)(!show);
    const lastFocusRef = (0, $2WGWz.useRef)(null);
    (0, $2WGWz.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $32770ad027b0258a$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $32770ad027b0258a$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $2WGWz.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $2WGWz.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $725073d4a3b70c67$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $32770ad027b0258a$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $32770ad027b0258a$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $c132b796c65a883a$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $2WGWz.useRef)();
    const removeKeydownListenerRef = (0, $2WGWz.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $2WGWz.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $c5fbdc32ab2a3998$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $c5fbdc32ab2a3998$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9Np2q))).createPortal(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0c3f916573cc6696$var$Modal.displayName = 'Modal';
var $0c3f916573cc6696$export$2e2bcd8739ae039 = Object.assign($0c3f916573cc6696$var$Modal, {
    Manager: (0, $1167437827852ac1$export$2e2bcd8739ae039)
});




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $9ee429e950cee4b2$var$OffcanvasBody = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$9ee429e950cee4b2$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $9ee429e950cee4b2$export$2e2bcd8739ae039 = $9ee429e950cee4b2$var$OffcanvasBody;




var $2WGWz = parcelRequire("2WGWz");






"use client";
const $66346d2dffd55337$var$transitionStyles = {
    [(0, $dcf47152d49f7679$export$df38205c966be359)]: 'show',
    [(0, $dcf47152d49f7679$export$78e9e6e3e014d60a)]: 'show'
};
const $66346d2dffd55337$var$OffcanvasToggling = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $980b3c7829c29a12$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a7c5e041381e39e9$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $c132b796c65a883a$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $2WGWz.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, (status === (0, $dcf47152d49f7679$export$df38205c966be359) || status === (0, $dcf47152d49f7679$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $66346d2dffd55337$var$transitionStyles[status])
            })
    });
});
$66346d2dffd55337$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $66346d2dffd55337$export$2e2bcd8739ae039 = $66346d2dffd55337$var$OffcanvasToggling;



var $2WGWz = parcelRequire("2WGWz");
"use client";
const $2c122d57a2f790ba$var$ModalContext = /*#__PURE__*/ $2WGWz.createContext({
    onHide () {}
});
var $2c122d57a2f790ba$export$2e2bcd8739ae039 = $2c122d57a2f790ba$var$ModalContext;




var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");




"use client";
const $2ef4f418ca094286$var$AbstractModalHeader = /*#__PURE__*/ $2WGWz.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $2WGWz.useContext)((0, $2c122d57a2f790ba$export$2e2bcd8739ae039));
    const handleClick = (0, $2e552e42661327c8$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2013d145291c2aaa$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$2ef4f418ca094286$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $2ef4f418ca094286$export$2e2bcd8739ae039 = $2ef4f418ca094286$var$AbstractModalHeader;



"use client";
const $2ab7367b397caa15$var$OffcanvasHeader = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2ef4f418ca094286$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$2ab7367b397caa15$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $2ab7367b397caa15$export$2e2bcd8739ae039 = $2ab7367b397caa15$var$OffcanvasHeader;



var $2WGWz = parcelRequire("2WGWz");




"use client";
const $9819279a47452b76$var$DivStyledAsH5 = (0, $b9f90237085a60cc$export$2e2bcd8739ae039)('h5');
const $9819279a47452b76$var$OffcanvasTitle = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $9819279a47452b76$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$9819279a47452b76$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $9819279a47452b76$export$2e2bcd8739ae039 = $9819279a47452b76$var$OffcanvasTitle;




function $da42d038f708cdd8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $bb7f18969320ba30$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $9bb1922ade4b5d1d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $9bb1922ade4b5d1d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $9bb1922ade4b5d1d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $9bb1922ade4b5d1d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $139746addfc3f454$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $139746addfc3f454$var$BootstrapModalManager extends (0, $1167437827852ac1$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $da42d038f708cdd8$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $139746addfc3f454$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $139746addfc3f454$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $139746addfc3f454$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $9bb1922ade4b5d1d$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $139746addfc3f454$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $139746addfc3f454$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $139746addfc3f454$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $139746addfc3f454$var$sharedManager;
function $139746addfc3f454$export$a03641438014b436(options) {
    if (!$139746addfc3f454$var$sharedManager) $139746addfc3f454$var$sharedManager = new $139746addfc3f454$var$BootstrapModalManager(options);
    return $139746addfc3f454$var$sharedManager;
}
var $139746addfc3f454$export$2e2bcd8739ae039 = $139746addfc3f454$var$BootstrapModalManager;



"use client";
function $0d16d439b76c012a$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $66346d2dffd55337$export$2e2bcd8739ae039), {
        ...props
    });
}
function $0d16d439b76c012a$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039), {
        ...props
    });
}
const $0d16d439b76c012a$var$Offcanvas = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $2WGWz.useRef)();
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $2WGWz.useState)(false);
    const handleHide = (0, $2e552e42661327c8$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $67f1d735200f89b2$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $2WGWz.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $2WGWz.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $139746addfc3f454$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $139746addfc3f454$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $2WGWz.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2c122d57a2f790ba$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $0c3f916573cc6696$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $0d16d439b76c012a$var$DialogTransition,
                    backdropTransition: $0d16d439b76c012a$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$0d16d439b76c012a$var$Offcanvas.displayName = 'Offcanvas';
var $0d16d439b76c012a$export$2e2bcd8739ae039 = Object.assign($0d16d439b76c012a$var$Offcanvas, {
    Body: (0, $9ee429e950cee4b2$export$2e2bcd8739ae039),
    Header: (0, $2ab7367b397caa15$export$2e2bcd8739ae039),
    Title: (0, $9819279a47452b76$export$2e2bcd8739ae039)
});




"use client";
const $886be97cafd17fd4$var$NavbarOffcanvas = /*#__PURE__*/ $2WGWz.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $2WGWz.useContext)((0, $9c5a82b8e41dbb5a$export$2e2bcd8739ae039));
    const handleHide = (0, $2e552e42661327c8$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $0d16d439b76c012a$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$886be97cafd17fd4$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $886be97cafd17fd4$export$2e2bcd8739ae039 = $886be97cafd17fd4$var$NavbarOffcanvas;





var $2WGWz = parcelRequire("2WGWz");



"use client";
const $866baef1b7db06d8$var$NavbarText = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$866baef1b7db06d8$var$NavbarText.displayName = 'NavbarText';
var $866baef1b7db06d8$export$2e2bcd8739ae039 = $866baef1b7db06d8$var$NavbarText;



"use client";
const $553195ce0979a4bd$var$Navbar = /*#__PURE__*/ $2WGWz.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $feb65fa3eb9d2358$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $2WGWz.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $2WGWz.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $9c5a82b8e41dbb5a$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2e59cc438e3c9bb4$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$553195ce0979a4bd$var$Navbar.displayName = 'Navbar';
var $553195ce0979a4bd$export$2e2bcd8739ae039 = Object.assign($553195ce0979a4bd$var$Navbar, {
    Brand: (0, $c26f83f6068d38a0$export$2e2bcd8739ae039),
    Collapse: (0, $50f6bc170e6ee6af$export$2e2bcd8739ae039),
    Offcanvas: (0, $886be97cafd17fd4$export$2e2bcd8739ae039),
    Text: (0, $866baef1b7db06d8$export$2e2bcd8739ae039),
    Toggle: (0, $dc772481037468de$export$2e2bcd8739ae039)
});



const $cdccd31991b06637$export$214ae410b202e65a = ({ user: user, onLoggedOut: onLoggedOut, pathname: pathname })=>{
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $553195ce0979a4bd$export$2e2bcd8739ae039), {
            expand: "lg",
            bg: "dark",
            variant: "dark",
            "data-bs-theme": "dark",
            className: "mb-5 p-4",
            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $a36e27a345dec7d9$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $553195ce0979a4bd$export$2e2bcd8739ae039).Brand, {
                        as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                        to: "/",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h1", {
                                className: "fs-4",
                                children: "F L I C K T I O N A R Y"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                                className: "fs-6",
                                children: "A dictionary for flicks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $553195ce0979a4bd$export$2e2bcd8739ae039).Toggle, {
                        "aria-controls": "basic-navbar-nav"
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $553195ce0979a4bd$export$2e2bcd8739ae039).Collapse, {
                        id: "basic-navbar-nav",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $abfaa45d828ede32$export$2e2bcd8739ae039), {
                            className: "ms-auto gap-3",
                            children: [
                                !user && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $abfaa45d828ede32$export$2e2bcd8739ae039).Link, {
                                            as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                            to: "/login",
                                            className: pathname === '/login' ? 'current' : '',
                                            children: "Login"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $abfaa45d828ede32$export$2e2bcd8739ae039).Link, {
                                            as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                            to: "/signup",
                                            className: pathname === '/signup' ? 'current' : '',
                                            children: "Signup"
                                        })
                                    ]
                                }),
                                user && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $abfaa45d828ede32$export$2e2bcd8739ae039).Link, {
                                            as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                            to: "/",
                                            className: pathname === '/' ? 'current' : '',
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $abfaa45d828ede32$export$2e2bcd8739ae039).Link, {
                                            as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                            to: "/profile",
                                            className: pathname === '/profile' ? 'current' : '',
                                            children: "Profile"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $abfaa45d828ede32$export$2e2bcd8739ae039).Link, {
                                            onClick: onLoggedOut,
                                            children: "Logout"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};




var $2WGWz = parcelRequire("2WGWz");






var $9c19bd5bfd1a1a58$var$size;
function $9c19bd5bfd1a1a58$export$2e2bcd8739ae039(recalc) {
    if (!$9c19bd5bfd1a1a58$var$size && $9c19bd5bfd1a1a58$var$size !== 0 || recalc) {
        if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9c19bd5bfd1a1a58$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9c19bd5bfd1a1a58$var$size;
}



var $2WGWz = parcelRequire("2WGWz");
function $0cac437c74db7b49$export$2e2bcd8739ae039() {
    return (0, $2WGWz.useState)(null);
}







var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $99edea3aed138ca6$var$ModalBody = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$99edea3aed138ca6$var$ModalBody.displayName = 'ModalBody';
var $99edea3aed138ca6$export$2e2bcd8739ae039 = $99edea3aed138ca6$var$ModalBody;





var $2WGWz = parcelRequire("2WGWz");


"use client";
const $11eaaf0aceda0f31$var$ModalDialog = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$11eaaf0aceda0f31$var$ModalDialog.displayName = 'ModalDialog';
var $11eaaf0aceda0f31$export$2e2bcd8739ae039 = $11eaaf0aceda0f31$var$ModalDialog;



var $2WGWz = parcelRequire("2WGWz");



"use client";
const $02b978578fa9074a$var$ModalFooter = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$02b978578fa9074a$var$ModalFooter.displayName = 'ModalFooter';
var $02b978578fa9074a$export$2e2bcd8739ae039 = $02b978578fa9074a$var$ModalFooter;




var $2WGWz = parcelRequire("2WGWz");



"use client";
const $4f17266f66bbd58c$var$ModalHeader = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2ef4f418ca094286$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$4f17266f66bbd58c$var$ModalHeader.displayName = 'ModalHeader';
var $4f17266f66bbd58c$export$2e2bcd8739ae039 = $4f17266f66bbd58c$var$ModalHeader;



var $2WGWz = parcelRequire("2WGWz");




"use client";
const $4c3f77cb67e4239d$var$DivStyledAsH4 = (0, $b9f90237085a60cc$export$2e2bcd8739ae039)('h4');
const $4c3f77cb67e4239d$var$ModalTitle = /*#__PURE__*/ $2WGWz.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $4c3f77cb67e4239d$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$4c3f77cb67e4239d$var$ModalTitle.displayName = 'ModalTitle';
var $4c3f77cb67e4239d$export$2e2bcd8739ae039 = $4c3f77cb67e4239d$var$ModalTitle;




"use client";
function $70bae50234205705$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $70bae50234205705$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $acf1c2fbf4ec15e7$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $70bae50234205705$var$Modal = /*#__PURE__*/ $2WGWz.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $11eaaf0aceda0f31$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $2WGWz.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $2WGWz.useState)(false);
    const waitingForMouseUpRef = (0, $2WGWz.useRef)(false);
    const ignoreBackdropClickRef = (0, $2WGWz.useRef)(false);
    const removeStaticModalAnimationRef = (0, $2WGWz.useRef)(null);
    const [modal, setModalRef] = (0, $0cac437c74db7b49$export$2e2bcd8739ae039)();
    const mergedRef = (0, $ef11d68cfaaeb713$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $2e552e42661327c8$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $9283c6e4393bcc4e$export$35e511eefa30ac5a)();
    bsPrefix = (0, $9283c6e4393bcc4e$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $2WGWz.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $139746addfc3f454$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $2e552e42661327c8$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $65aa685ec02b57e6$export$2e2bcd8739ae039)(()=>{
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $2WGWz.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2c122d57a2f790ba$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $0c3f916573cc6696$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $70bae50234205705$var$DialogTransition : undefined,
            backdropTransition: animation ? $70bae50234205705$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$70bae50234205705$var$Modal.displayName = 'Modal';
var $70bae50234205705$export$2e2bcd8739ae039 = Object.assign($70bae50234205705$var$Modal, {
    Body: (0, $99edea3aed138ca6$export$2e2bcd8739ae039),
    Header: (0, $4f17266f66bbd58c$export$2e2bcd8739ae039),
    Title: (0, $4c3f77cb67e4239d$export$2e2bcd8739ae039),
    Footer: (0, $02b978578fa9074a$export$2e2bcd8739ae039),
    Dialog: (0, $11eaaf0aceda0f31$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});





const $ac8839470e379cfc$export$b378b4d12a0dcbde = ({ user: user, movies: movies, favoriteMovies: favoriteMovies, onToggleFavorite: onToggleFavorite, onLoggedOut: onLoggedOut })=>{
    const [userInfo, setUserInfo] = (0, $2WGWz.useState)(null);
    const [formData, setFormData] = (0, $2WGWz.useState)({
        username: '',
        password: '',
        email: '',
        dateOfBirth: ''
    });
    const [error, setError] = (0, $2WGWz.useState)('');
    const [success, setSuccess] = (0, $2WGWz.useState)('');
    const navigate = (0, $bc78fc24d57a3b2e$export$9770f232ac06a008)();
    const [show, setShow] = (0, $2WGWz.useState)(false);
    const handleClose = ()=>setShow(false);
    const handleShow = ()=>setShow(true);
    (0, $2WGWz.useEffect)(()=>{
        if (!user) return;
        // Fetch user information
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/users/${user.Username}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then((response)=>response.json()).then((currentUser)=>{
            setUserInfo(currentUser);
            setFormData({
                username: currentUser.Username,
                password: '',
                email: currentUser.Email,
                dateOfBirth: currentUser.Birthday ? new Date(currentUser.Birthday).toISOString().split('T')[0] : ''
            });
        }).catch(()=>{
            setError('Failed to fetch user information');
        });
    }, [
        user
    ]);
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleUpdateProfile = (e)=>{
        e.preventDefault();
        setError('');
        setSuccess('');
        const updateData = {
            Username: formData.username,
            Email: formData.email,
            Birthday: formData.dateOfBirth
        };
        // Only include password if it's being changed
        if (formData.password) updateData.Password = formData.password;
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/users/${userInfo.Username}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(updateData)
        }).then((response)=>{
            if (!response.ok) throw new Error('Failed to update profile');
            return response.json();
        }).then((updatedUser)=>{
            setUserInfo(updatedUser);
            setSuccess('Profile updated successfully');
            // Clear password field after successful update
            setFormData((prev)=>({
                    ...prev,
                    password: ''
                }));
        }).catch(()=>{
            setError('Failed to update profile');
        });
    };
    const handleDeregister = ()=>{
        if (!window.confirm('Are you sure you want to deregister? This action cannot be undone.')) return;
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/users/${userInfo.Username}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then((response)=>{
            if (!response.ok) throw new Error('Failed to deregister');
            onLoggedOut();
            navigate('/login');
        }).catch(()=>{
            setError('Failed to deregister');
        });
    };
    if (!userInfo) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
        children: "Loading..."
    });
    const favoriteMoviesList = movies.filter((movie)=>favoriteMovies && favoriteMovies.includes(movie.id));
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
            className: "mb-5 py-5 justify-content-center",
            children: [
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                    className: "mb-5 pb-3 border-bottom border-secondary",
                    md: 10,
                    lg: 6,
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("h3", {
                        className: "mb-0",
                        children: [
                            "Welcome ",
                            userInfo.Username,
                            "!"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                    className: "w-100"
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                    md: 6,
                    lg: 4,
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h5", {
                            className: "mb-3",
                            children: "Your profile information:"
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("p", {
                            children: [
                                "Username: ",
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                    children: userInfo.Username
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("p", {
                            children: [
                                "Email: ",
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                    children: userInfo.Email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("p", {
                            children: [
                                "Date of Birth:",
                                ' ',
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                    children: userInfo.Birthday ? new Date(userInfo.Birthday).toLocaleDateString() : 'Not set'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $70bae50234205705$export$2e2bcd8739ae039), {
                            show: show,
                            onHide: handleClose,
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039), {
                                onSubmit: handleUpdateProfile,
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $70bae50234205705$export$2e2bcd8739ae039).Header, {
                                        closeButton: true,
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $70bae50234205705$export$2e2bcd8739ae039).Title, {
                                            children: "Edit Profile"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $70bae50234205705$export$2e2bcd8739ae039).Body, {
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e4744ef9e9086def$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e4744ef9e9086def$export$2e2bcd8739ae039).Body, {
                                                children: [
                                                    error && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                                        className: "alert alert-danger",
                                                        children: error
                                                    }),
                                                    success && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                                        className: "alert alert-success",
                                                        children: success
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                                                children: "Username"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                                                type: "text",
                                                                name: "username",
                                                                value: formData.username,
                                                                onChange: handleInputChange,
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                                                children: "Password"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                                                type: "password",
                                                                name: "password",
                                                                value: formData.password,
                                                                onChange: handleInputChange,
                                                                placeholder: "Leave blank to keep current password"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                                                children: "Email"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                                                type: "email",
                                                                name: "email",
                                                                value: formData.email,
                                                                onChange: handleInputChange,
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                                                children: "Date of Birth"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                                                type: "date",
                                                                name: "dateOfBirth",
                                                                value: formData.dateOfBirth,
                                                                onChange: handleInputChange
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $70bae50234205705$export$2e2bcd8739ae039).Footer, {
                                        children: [
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                                variant: "secondary",
                                                onClick: handleClose,
                                                children: "Close"
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                                variant: "primary",
                                                type: "submit",
                                                className: "me-2",
                                                children: "Update Profile"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                    md: 4,
                    lg: 2,
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                        className: "d-flex flex-column gap-4",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                variant: "primary",
                                size: "lg",
                                onClick: handleShow,
                                children: "Edit Profile"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                variant: "danger",
                                type: "button",
                                size: "lg",
                                onClick: handleDeregister,
                                children: "Deregister"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                    className: "w-100"
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                    className: "mt-5 pt-3 movies--favorite",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h3", {
                            className: "my-5",
                            children: "Favorite Movies"
                        }),
                        favoriteMoviesList.length === 0 ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                            children: "No favorite movies yet."
                        }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                            children: favoriteMoviesList.map((movie)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                    md: 4,
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bd664d6ef1f52408$export$9bd698419030e459), {
                                        movie: movie,
                                        isFavorite: true,
                                        onToggleFavorite: onToggleFavorite
                                    })
                                }, movie.id))
                        })
                    ]
                })
            ]
        })
    });
};




var $2WGWz = parcelRequire("2WGWz");





const $4f17a56e5d7d2954$export$447ad2da1559da84 = (movie)=>({
        id: movie._id,
        title: movie.Title,
        description: movie.Description,
        director: movie.Director.Name,
        genre: movie.Genre.Name,
        image: movie.ImagePath,
        featured: movie.Featured,
        actors: movie.Actors
    });



const $ee2fc09121221c1a$export$4346cbb3f6673ddd = ({ user: user, token: token, onToggleFavorite: onToggleFavorite, isMovieFavorite: isMovieFavorite })=>{
    const [movies, setMovies] = (0, $2WGWz.useState)([]);
    const [searchParams, setSearchParams] = (0, $2WGWz.useState)({
        q: '',
        title: '',
        genre: '',
        director: '',
        actor: '',
        featured: ''
    });
    const [error, setError] = (0, $2WGWz.useState)(null);
    const [isLoading, setIsLoading] = (0, $2WGWz.useState)(false);
    const [options, setOptions] = (0, $2WGWz.useState)({
        genres: [],
        directors: [],
        actors: []
    });
    const location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    const debounceTimer = (0, $2WGWz.useRef)(null);
    // Fetch options for dropdowns
    (0, $2WGWz.useEffect)(()=>{
        if (!token) return;
        const controller = new AbortController();
        const fetchOptions = async ()=>{
            try {
                const response = await fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/movies`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    signal: controller.signal
                });
                if (!response.ok) throw new Error('Failed to fetch options');
                const data = await response.json();
                // Extract unique values for each category
                const genres = [
                    ...new Set(data.map((movie)=>movie.Genre.Name))
                ].sort();
                const directors = [
                    ...new Set(data.map((movie)=>movie.Director.Name))
                ].sort();
                const actors = [
                    ...new Set(data.flatMap((movie)=>movie.Actors))
                ].sort();
                setOptions({
                    genres: genres,
                    directors: directors,
                    actors: actors
                });
            } catch (err) {
                if (err.name !== 'AbortError') setError('Failed to load filter options');
            }
        };
        fetchOptions();
        return ()=>controller.abort();
    }, [
        token
    ]);
    const performSearch = async (params)=>{
        try {
            setIsLoading(true);
            setError(null);
            // Create URL with query parameters
            const queryString = new URLSearchParams();
            Object.entries(params).forEach(([key, value])=>{
                if (value) queryString.append(key, value);
            });
            const url = `${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/search?${queryString.toString()}`;
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Search failed');
            const data = await response.json();
            setMovies(data.map((0, $4f17a56e5d7d2954$export$447ad2da1559da84)));
        } catch (err) {
            setError(err.message || 'An error occurred while searching for movies');
            setMovies([]);
        } finally{
            setIsLoading(false);
        }
    };
    // Load search params from URL on mount
    (0, $2WGWz.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        const searchQuery = {
            q: params.get('q') || '',
            title: params.get('title') || '',
            genre: params.get('genre') || '',
            director: params.get('director') || '',
            actor: params.get('actor') || '',
            featured: params.get('featured') || ''
        };
        setSearchParams(searchQuery);
        performSearch(searchQuery);
    }, [
        location
    ]);
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        const updated = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(updated);
        clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(()=>{
            performSearch(updated);
        }, 500);
    };
    const handleSearch = (e)=>{
        e.preventDefault();
        performSearch(searchParams); // Immediate search on form submit
    };
    const handleReset = ()=>{
        const emptyParams = {
            q: '',
            title: '',
            genre: '',
            director: '',
            actor: '',
            featured: ''
        };
        setSearchParams(emptyParams);
        performSearch(emptyParams);
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $a36e27a345dec7d9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039), {
                onSubmit: handleSearch,
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                        className: "justify-content-center my-md-3 g-4",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 10,
                                lg: 6,
                                className: "mb-0",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                    className: "mb-3- py-4-",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                            className: "text-info visually-hidden",
                                            children: "Global Search"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Control, {
                                            type: "text",
                                            name: "q",
                                            value: searchParams.q,
                                            onChange: handleInputChange,
                                            placeholder: "Search movies...",
                                            className: "border-primary",
                                            size: "lg"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 2,
                                lg: 2,
                                className: "mb-5",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    type: "submit",
                                    size: "lg",
                                    className: "w-100",
                                    children: "Search"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                        className: "mb-5 pb-5 g-4 justify-content-center align-items-end",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                            htmlFor: "genre",
                                            className: "text-info",
                                            children: "Filter by Genre"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Select, {
                                            id: "genre",
                                            name: "genre",
                                            value: searchParams.genre,
                                            onChange: handleInputChange,
                                            className: "border-primary",
                                            size: "lg",
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All Genres"
                                                }),
                                                options.genres.map((genre)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                        value: genre,
                                                        children: genre
                                                    }, genre))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                            htmlFor: "director",
                                            className: "text-info",
                                            children: "Filter by Director"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Select, {
                                            id: "director",
                                            name: "director",
                                            value: searchParams.director,
                                            onChange: handleInputChange,
                                            className: "border-primary",
                                            size: "lg",
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All Directors"
                                                }),
                                                options.directors.map((director)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                        value: director,
                                                        children: director
                                                    }, director))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Label, {
                                            htmlFor: "actor",
                                            className: "text-info",
                                            children: "Filter by Actor"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $5acf5ec9c6a36bea$export$2e2bcd8739ae039).Select, {
                                            id: "actor",
                                            name: "actor",
                                            value: searchParams.actor,
                                            onChange: handleInputChange,
                                            className: "border-primary",
                                            size: "lg",
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All Actors"
                                                }),
                                                options.actors.map((actor)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                        value: actor,
                                                        children: actor
                                                    }, actor))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 1,
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $8fef066443ddfb90$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    onClick: handleReset,
                                    size: "lg",
                                    className: "flex-shrink-1",
                                    children: "Reset"
                                })
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "alert alert-danger",
                role: "alert",
                children: error
            }),
            isLoading ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "text-center my-5",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $62601e8353a7b7f7$export$2e2bcd8739ae039), {
                        animation: "border",
                        role: "status",
                        variant: "primary",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                            className: "visually-hidden",
                            children: "Loading..."
                        })
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                        className: "text-light mt-2",
                        children: "Searching for movies..."
                    })
                ]
            }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                children: movies.length === 0 ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                        className: "text-light",
                        children: "No movies found matching your search criteria."
                    })
                }) : movies.map((movie)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                        xs: 12,
                        md: 6,
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bd664d6ef1f52408$export$9bd698419030e459), {
                            movie: movie,
                            isFavorite: isMovieFavorite(movie.id),
                            onToggleFavorite: onToggleFavorite
                        })
                    }, movie.id))
            })
        ]
    });
};
$ee2fc09121221c1a$export$4346cbb3f6673ddd.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
    token: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    onToggleFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func.isRequired,
    isMovieFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func.isRequired
};






const $d7311e010576220e$export$a06f1c675e846f6f = ({ user: user, onLoggedOut: onLoggedOut, pathname: pathname })=>{
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("footer", {
        className: "py-4 mt-5 border-top border-secondary",
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a36e27a345dec7d9$export$2e2bcd8739ae039), {
            fluid: true,
            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a36e27a345dec7d9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    md: 6,
                                    className: "d-flex gap-3 mb-4 mb-md-0 flex-column flex-md-row",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h6", {
                                            className: "text-info",
                                            children: new Date().getFullYear()
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h6", {
                                            className: "text-info",
                                            children: "F L I C K T I O N A R Y"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h6", {
                                            className: "text-info",
                                            children: "A dictionary for flicks"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    md: 6,
                                    className: "d-flex gap-3 flex-column flex-md-row justify-content-end",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $abfaa45d828ede32$export$2e2bcd8739ae039), {
                                        className: "gap-3 justify-content-end flex-column flex-md-row",
                                        children: [
                                            !user && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                                        as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                                        to: "/login",
                                                        className: pathname === '/login' ? 'current' : '',
                                                        children: "Login"
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                                        as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                                        to: "/signup",
                                                        className: pathname === '/signup' ? 'current' : '',
                                                        children: "Signup"
                                                    })
                                                ]
                                            }),
                                            user && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                                        as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                                        to: "/",
                                                        className: pathname === '/' ? 'current' : '',
                                                        children: "Home"
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                                        as: (0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a),
                                                        to: "/profile",
                                                        className: pathname === '/profile' ? 'current' : '',
                                                        children: "Profile"
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$a6c7ac8248d6e38a), {
                                                        onClick: onLoggedOut,
                                                        children: "Logout"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};






// MainViewContent component that uses useLocation
const $53aa19e059d1ce0f$var$MainView = ()=>{
    const location = (0, $bc78fc24d57a3b2e$export$45d76561a5302f2b)();
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const storedToken = localStorage.getItem('token');
    // movies to be displayed
    const [movies, setMovies] = (0, $2WGWz.useState)([]);
    // user's favorite movies
    const [favoriteMovies, setFavoriteMovies] = (0, $2WGWz.useState)([]);
    // user
    const [user, setUser] = (0, $2WGWz.useState)(storedUser ? storedUser : null);
    // token
    const [token, setToken] = (0, $2WGWz.useState)(storedToken ? storedToken : null);
    // Update page title based on current route
    (0, $2WGWz.useEffect)(()=>{
        const path = location.pathname;
        if (path === '/') document.title = 'Flicktionary';
        else if (path === '/login') document.title = 'Login - Flicktionary';
        else if (path === '/signup') document.title = 'Signup - Flicktionary';
        else if (path === '/profile') document.title = 'Profile - Flicktionary';
        else if (path.startsWith('/movies/')) {
            const movieId = path.split('/')[2];
            const movie = movies.find((m)=>m.id === movieId);
            document.title = movie ? `${movie.title} - Flicktionary` : 'Flicktionary';
        }
    }, [
        location.pathname,
        movies
    ]);
    // Fetch movies from API
    (0, $2WGWz.useEffect)(()=>{
        if (!token) return;
        const controller = new AbortController();
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/movies`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            signal: controller.signal
        }).then((response)=>{
            if (!response.ok) throw new Error('Failed to fetch movies');
            return response.json();
        }).then((data)=>{
            setMovies(data.map((0, $4f17a56e5d7d2954$export$447ad2da1559da84)));
        }).catch((err)=>{
            if (err.name !== 'AbortError') return;
        });
        return ()=>controller.abort();
    }, [
        token
    ]);
    // Fetch user's favorite movies from user object
    (0, $2WGWz.useEffect)(()=>{
        if (!user || !token) return;
        const controller = new AbortController();
        fetch(`${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/users/${user.Username}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            signal: controller.signal
        }).then((response)=>{
            if (!response.ok) throw new Error('Failed to fetch user data');
            return response.json();
        }).then((userData)=>{
            if (userData.FavoriteMovies) setFavoriteMovies(userData.FavoriteMovies);
        }).catch((err)=>{
            if (err.name !== 'AbortError') return;
        });
        return ()=>controller.abort();
    }, [
        user,
        token
    ]);
    // Function to toggle favorite status
    const toggleFavorite = (movieId)=>{
        if (!user || !token) return;
        const isFavorite = favoriteMovies.includes(movieId);
        let updatedFavorites;
        if (isFavorite) // Remove from favorites
        updatedFavorites = favoriteMovies.filter((id)=>id !== movieId);
        else // Add to favorites
        updatedFavorites = [
            ...favoriteMovies,
            movieId
        ];
        // First, update the local state to provide immediate feedback
        setFavoriteMovies(updatedFavorites);
        // Update the user in localStorage
        const updatedUser = {
            ...user,
            FavoriteMovies: updatedFavorites
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        setUser(updatedUser);
        // Use the correct endpoint structure for adding/removing favorite movies
        const endpoint = `${(0, $bebe1cbb5a309c8c$export$923ea8233b386e99)}/users/${user.Username}/movies/${movieId}`;
        const method = isFavorite ? 'DELETE' : 'POST';
        // Update user's favorite movies in the database
        fetch(endpoint, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }).then(async (response)=>{
            const responseText = await response.text();
            if (response.ok) try {
                const responseData = JSON.parse(responseText);
                // Update the state with the server response
                if (responseData.FavoriteMovies) {
                    setFavoriteMovies(responseData.FavoriteMovies);
                    const newUser = {
                        ...user,
                        FavoriteMovies: responseData.FavoriteMovies
                    };
                    localStorage.setItem('user', JSON.stringify(newUser));
                    setUser(newUser);
                }
            } catch (e) {
            // Response is not JSON
            }
            else {
                // Revert the local state if the server update fails
                setFavoriteMovies(favoriteMovies);
                localStorage.setItem('user', JSON.stringify(user));
                setUser(user);
            }
        }).catch(()=>{
            // Revert the local state if the server update fails
            setFavoriteMovies(favoriteMovies);
            localStorage.setItem('user', JSON.stringify(user));
            setUser(user);
        });
    };
    // Check if a movie is in favorites
    const isMovieFavorite = (movieId)=>{
        return favoriteMovies.includes(movieId);
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a36e27a345dec7d9$export$2e2bcd8739ae039), {
                fluid: true,
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $cdccd31991b06637$export$214ae410b202e65a), {
                    user: user,
                    pathname: location.pathname,
                    onLoggedOut: ()=>{
                        setUser(null);
                        localStorage.removeItem('user');
                        localStorage.removeItem('token');
                    }
                })
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a36e27a345dec7d9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f7a0f00c5207df04$export$2e2bcd8739ae039), {
                    className: location.pathname !== '/' ? 'justify-content-center ' + location.pathname.slice(1) : 'justify-content-start',
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $bc78fc24d57a3b2e$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$e7b0ac011bb776c6), {
                                path: "/signup",
                                element: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: user ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$444b3ab0cb9aec40), {
                                        to: "/"
                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                        md: 10,
                                        xl: 8,
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $ad22dac456f05c19$export$25f3896ea1e09820), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$e7b0ac011bb776c6), {
                                path: "/login",
                                element: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: user ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$444b3ab0cb9aec40), {
                                        to: "/"
                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                        md: 5,
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $d379e75a95ffce01$export$1582048ca8384970), {
                                            onLoggedIn: (user, token)=>{
                                                setUser(user);
                                                setToken(token);
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$e7b0ac011bb776c6), {
                                path: "/profile",
                                element: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: !user ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$444b3ab0cb9aec40), {
                                        to: "/login",
                                        replace: true
                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $ac8839470e379cfc$export$b378b4d12a0dcbde), {
                                        user: user,
                                        movies: movies,
                                        favoriteMovies: favoriteMovies,
                                        onToggleFavorite: toggleFavorite,
                                        onLoggedOut: ()=>{
                                            setUser(null);
                                            localStorage.removeItem('user');
                                            localStorage.removeItem('token');
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: !user ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$444b3ab0cb9aec40), {
                                        to: "/login"
                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $ee2fc09121221c1a$export$4346cbb3f6673ddd), {
                                        user: user,
                                        token: token,
                                        onToggleFavorite: toggleFavorite,
                                        isMovieFavorite: isMovieFavorite
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$e7b0ac011bb776c6), {
                                path: "/movies/:movieId",
                                element: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
                                    children: !user ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $bc78fc24d57a3b2e$export$444b3ab0cb9aec40), {
                                        to: "/login",
                                        replace: true
                                    }) : movies.length === 0 ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7b6fb2806cf807bb$export$2e2bcd8739ae039), {
                                        children: "The list is empty!"
                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e5ff383576b0e9ff$export$78d497080ea8f89a), {
                                        movies: movies,
                                        isMovieFavorite: isMovieFavorite,
                                        onToggleFavorite: toggleFavorite
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $d7311e010576220e$export$a06f1c675e846f6f), {
                user: user,
                pathname: location.pathname,
                onLoggedOut: ()=>{
                    setUser(null);
                    localStorage.removeItem('user');
                    localStorage.removeItem('token');
                }
            })
        ]
    });
};
var $53aa19e059d1ce0f$export$2e2bcd8739ae039 = $53aa19e059d1ce0f$var$MainView;




const $34a83e38fb8b3bfc$var$App = ()=>{
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37a38af02f95fe8$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $53aa19e059d1ce0f$export$2e2bcd8739ae039), {})
    });
};
const $34a83e38fb8b3bfc$var$container = document.querySelector('#root');
const $34a83e38fb8b3bfc$var$root = (0, $9304165f01abb7b7$exports.createRoot)($34a83e38fb8b3bfc$var$container);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($34a83e38fb8b3bfc$var$App, {}));


//# sourceMappingURL=repo.1100b2ac.js.map
